/* tslint:disable */
/* eslint-disable */
/**
 * Propally API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface APIError
 */
export interface APIError {
    /**
     * 
     * @type {number}
     * @memberof APIError
     */
    code: number;
    /**
     * 
     * @type {string}
     * @memberof APIError
     */
    message: string;
}
/**
 * 
 * @export
 * @interface AdjustTracker
 */
export interface AdjustTracker {
    /**
     * 
     * @type {number}
     * @memberof AdjustTracker
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdjustTracker
     */
    user_id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    first_tracker?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    first_tracker_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    tracker?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    tracker_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    request_id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    remote_ip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    user_agent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    adid?: string | null;
    /**
     * 受信時の生パラメータ（JSON）
     * @type {object}
     * @memberof AdjustTracker
     */
    raw_params?: object | null;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AdjustTracker
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface AdminAgentBorrowingRange
 */
export interface AdminAgentBorrowingRange {
    /**
     * 
     * @type {number}
     * @memberof AdminAgentBorrowingRange
     */
    annual_income_min?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentBorrowingRange
     */
    annual_income_max?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentBorrowingRange
     */
    multiplier?: number | null;
}
/**
 * 
 * @export
 * @interface AdminAgentMemo
 */
export interface AdminAgentMemo {
    /**
     * 
     * @type {number}
     * @memberof AdminAgentMemo
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentMemo
     */
    admin_user_id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentMemo
     */
    agent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminAgentMemo
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAgentMemo
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminAgentMemo
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface AdminAgentTargetConditionPayload
 */
export interface AdminAgentTargetConditionPayload {
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    version?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    age_min?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    age_max?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    annual_income_min?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    annual_income_max?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAgentTargetConditionPayload
     */
    work_experience_years?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAgentTargetConditionPayload
     */
    job_categories?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAgentTargetConditionPayload
     */
    job_industries?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AdminAgentTargetConditionPayload
     */
    free_note?: string | null;
    /**
     * 
     * @type {Array<AdminAgentBorrowingRange>}
     * @memberof AdminAgentTargetConditionPayload
     */
    borrowing_ranges?: Array<AdminAgentBorrowingRange>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AdminAgentTargetConditionPayload
     */
    residence_prefectures?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof AdminAgentTargetConditionPayload
     */
    financial_asset_ids?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    investment_property_count_min?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AdminAgentTargetConditionPayload
     */
    investment_property_count_max?: number | null;
}
/**
 * 
 * @export
 * @interface AdminUserMemo
 */
export interface AdminUserMemo {
    /**
     * 
     * @type {number}
     * @memberof AdminUserMemo
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserMemo
     */
    admin_user_id?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminUserMemo
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUserMemo
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserMemo
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUserMemo
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface Agent
 */
export interface Agent {
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Agent
     */
    company_id?: number;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    password_confirmation?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    family_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    profile?: string | null;
    /**
     * はじめて不動産投資をする人に向けた一言（前後の空白を除いて40字まで、超過は422。プランナー本人が入力。「」は画面側で付ける。空白のみ・未入力は null）
     * @type {string}
     * @memberof Agent
     */
    beginner_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    last_accessed_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    updated_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    is_enabled_notification_new_user?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    is_enabled_notification_new_property?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    is_need_user_notifications?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    is_displayed_in_recommend_feed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    is_displayed_in_active_feed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    is_displayed_in_compatibility_feed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    is_displayed_in_match_feed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    is_displayed_in_limited_property?: boolean;
    /**
     * 対応可能種別一覧
     * @type {Array<AgentSupportedPropertyTypeEnum>}
     * @memberof Agent
     */
    supported_property_types?: Array<AgentSupportedPropertyTypeEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof Agent
     */
    discarded_at?: string | null;
    /**
     * 
     * @type {AdminAgentMemo}
     * @memberof Agent
     */
    admin_agent_memo?: AdminAgentMemo;
    /**
     * エージェントのおすすめレベル
     * @type {number}
     * @memberof Agent
     */
    recommendation_level?: number | null;
    /**
     * 
     * @type {AgentCompatibilityRadar}
     * @memberof Agent
     */
    compatibility_radar?: AgentCompatibilityRadar | null;
    /**
     * 
     * @type {AgentPropallyComment}
     * @memberof Agent
     */
    propally_comment?: AgentPropallyComment | null;
    /**
     * 
     * @type {AgentCompatibilityProfile}
     * @memberof Agent
     */
    agent_compatibility_profile?: AgentCompatibilityProfile | null;
    /**
     * 
     * @type {Company}
     * @memberof Agent
     */
    company?: Company;
    /**
     * 
     * @type {AgentProfileImage}
     * @memberof Agent
     */
    agent_profile_image?: AgentProfileImage | null;
    /**
     * 
     * @type {AgentIntroductionImage}
     * @memberof Agent
     */
    agent_introduction_image?: AgentIntroductionImage | null;
    /**
     * 
     * @type {Array<AssessmentProposal>}
     * @memberof Agent
     */
    assessment_proposals?: Array<AssessmentProposal>;
    /**
     * 
     * @type {Array<InvestmentProposal>}
     * @memberof Agent
     */
    investment_proposals?: Array<InvestmentProposal>;
    /**
     * 
     * @type {Array<ProposalMatching>}
     * @memberof Agent
     */
    proposal_matchings?: Array<ProposalMatching>;
    /**
     * 
     * @type {Array<ContractApplication>}
     * @memberof Agent
     */
    contract_applications?: Array<ContractApplication>;
    /**
     * 対象条件
     * @type {string}
     * @memberof Agent
     */
    target_condition?: string | null;
    /**
     * 
     * @type {AdminAgentTargetConditionPayload}
     * @memberof Agent
     */
    target_condition_payload?: AdminAgentTargetConditionPayload | null;
    /**
     * 
     * @type {boolean}
     * @memberof Agent
     */
    is_matched?: boolean | null;
    /**
     * 
     * @type {AgentMetrics}
     * @memberof Agent
     */
    metrics?: AgentMetrics;
}
/**
 * 
 * @export
 * @interface AgentAvailableContactSlotsResponse
 */
export interface AgentAvailableContactSlotsResponse {
    /**
     * 連絡対応可能枠。空配列は「全枠対応可（未設定）」
     * @type {Array<AgentAvailableContactSlotsResponseAvailableContactSlots>}
     * @memberof AgentAvailableContactSlotsResponse
     */
    available_contact_slots: Array<AgentAvailableContactSlotsResponseAvailableContactSlots>;
}
/**
 * 
 * @export
 * @interface AgentAvailableContactSlotsResponseAvailableContactSlots
 */
export interface AgentAvailableContactSlotsResponseAvailableContactSlots {
    /**
     * 曜日（0=日曜〜6=土曜）
     * @type {number}
     * @memberof AgentAvailableContactSlotsResponseAvailableContactSlots
     */
    wday: number;
    /**
     * 2時間枠
     * @type {string}
     * @memberof AgentAvailableContactSlotsResponseAvailableContactSlots
     */
    time_slot: AgentAvailableContactSlotsResponseAvailableContactSlotsTimeSlotEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgentAvailableContactSlotsResponseAvailableContactSlotsTimeSlotEnum {
    _911 = 'slot_9_11',
    _1113 = 'slot_11_13',
    _1315 = 'slot_13_15',
    _1517 = 'slot_15_17',
    _1719 = 'slot_17_19',
    _1921 = 'slot_19_21'
}

/**
 * 相性レーダー用営業可能エリア
 * @export
 * @enum {string}
 */
export enum AgentCompatibilityAreaEnum {
    関東 = '関東',
    関西中京 = '関西中京',
    九州 = '九州',
    その他地方 = 'その他地方',
    全国対応 = '全国対応'
}

/**
 * 相性レーダー用対応可資産帯プリセット
 * @export
 * @enum {string}
 */
export enum AgentCompatibilityAssetPresetEnum {
    _500万円以下 = '〜500万円',
    _1000万円以下 = '〜1,000万円',
    _3000万円以下 = '〜3,000万円',
    _500万5000万円 = '500万〜5,000万円',
    _1000万1億円 = '1,000万〜1億円',
    _3000万円以上 = '3,000万円〜',
    制限なし = '制限なし'
}

/**
 * 
 * @export
 * @interface AgentCompatibilityProfile
 */
export interface AgentCompatibilityProfile {
    /**
     * 
     * @type {number}
     * @memberof AgentCompatibilityProfile
     */
    id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AgentCompatibilityProfile
     */
    agent_id?: number | null;
    /**
     * 
     * @type {Array<AgentCompatibilityPropertyTypeEnum>}
     * @memberof AgentCompatibilityProfile
     */
    supported_property_types?: Array<AgentCompatibilityPropertyTypeEnum> | null;
    /**
     * 
     * @type {AgentCompatibilityPropertyTypeEnum}
     * @memberof AgentCompatibilityProfile
     */
    primary_property_type?: AgentCompatibilityPropertyTypeEnum | null;
    /**
     * 主力年収（万円）
     * @type {number}
     * @memberof AgentCompatibilityProfile
     */
    primary_annual_income?: number | null;
    /**
     * 対応可年収レンジ下限（万円）
     * @type {number}
     * @memberof AgentCompatibilityProfile
     */
    supported_annual_income_min?: number | null;
    /**
     * 対応可年収レンジ上限（万円）
     * @type {number}
     * @memberof AgentCompatibilityProfile
     */
    supported_annual_income_max?: number | null;
    /**
     * 
     * @type {MoneyAmount}
     * @memberof AgentCompatibilityProfile
     */
    primary_asset_band?: MoneyAmount | null;
    /**
     * 
     * @type {AgentCompatibilityAssetPresetEnum}
     * @memberof AgentCompatibilityProfile
     */
    supported_asset_preset?: AgentCompatibilityAssetPresetEnum | null;
    /**
     * 
     * @type {AgentCompatibilitySupportLevelEnum}
     * @memberof AgentCompatibilityProfile
     */
    beginner_support_level?: AgentCompatibilitySupportLevelEnum | null;
    /**
     * 
     * @type {AgentCompatibilitySupportLevelEnum}
     * @memberof AgentCompatibilityProfile
     */
    experienced_support_level?: AgentCompatibilitySupportLevelEnum | null;
    /**
     * 
     * @type {AgentCompatibilityAreaEnum}
     * @memberof AgentCompatibilityProfile
     */
    primary_area?: AgentCompatibilityAreaEnum | null;
    /**
     * 
     * @type {Array<AgentCompatibilityAreaEnum>}
     * @memberof AgentCompatibilityProfile
     */
    supported_areas?: Array<AgentCompatibilityAreaEnum> | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCompatibilityProfile
     */
    created_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentCompatibilityProfile
     */
    updated_at?: string | null;
}
/**
 * 相性レーダー用物件種別
 * @export
 * @enum {string}
 */
export enum AgentCompatibilityPropertyTypeEnum {
    区分 = '区分',
    一棟 = '一棟',
    戸建 = '戸建',
    海外 = '海外',
    その他 = 'その他'
}

/**
 * 
 * @export
 * @interface AgentCompatibilityRadar
 */
export interface AgentCompatibilityRadar {
    /**
     * 5軸スコアの単純平均
     * @type {number}
     * @memberof AgentCompatibilityRadar
     */
    total_score?: number;
    /**
     * 
     * @type {AgentCompatibilityRadarScores}
     * @memberof AgentCompatibilityRadar
     */
    scores?: AgentCompatibilityRadarScores;
}
/**
 * 
 * @export
 * @interface AgentCompatibilityRadarScores
 */
export interface AgentCompatibilityRadarScores {
    /**
     * 得意物件種別一致
     * @type {number}
     * @memberof AgentCompatibilityRadarScores
     */
    property_type?: number;
    /**
     * 得意年収一致
     * @type {number}
     * @memberof AgentCompatibilityRadarScores
     */
    annual_income?: number;
    /**
     * 得意資産一致
     * @type {number}
     * @memberof AgentCompatibilityRadarScores
     */
    financial_asset?: number;
    /**
     * 得意ステージ一致
     * @type {number}
     * @memberof AgentCompatibilityRadarScores
     */
    investment_stage?: number;
    /**
     * 営業可能エリア一致
     * @type {number}
     * @memberof AgentCompatibilityRadarScores
     */
    area?: number;
}
/**
 * 相性レーダー用ステージ対応度
 * @export
 * @enum {string}
 */
export enum AgentCompatibilitySupportLevelEnum {
    優先 = '優先',
    普通 = '普通',
    非優先 = '非優先'
}

/**
 * 
 * @export
 * @interface AgentDetailAccessLog
 */
export interface AgentDetailAccessLog {
    /**
     * 
     * @type {number}
     * @memberof AgentDetailAccessLog
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentDetailAccessLog
     */
    agent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentDetailAccessLog
     */
    user_id?: number;
    /**
     * 
     * @type {AgentDetailAccessSourceEnum}
     * @memberof AgentDetailAccessLog
     */
    source?: AgentDetailAccessSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentDetailAccessLog
     */
    accessed_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDetailAccessLog
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDetailAccessLog
     */
    updated_at?: string;
    /**
     * 
     * @type {Agent}
     * @memberof AgentDetailAccessLog
     */
    agent?: Agent;
    /**
     * 
     * @type {User}
     * @memberof AgentDetailAccessLog
     */
    user?: User;
}
/**
 * 
 * @export
 * @interface AgentDetailAccessLogRequest
 */
export interface AgentDetailAccessLogRequest {
    /**
     * 
     * @type {number}
     * @memberof AgentDetailAccessLogRequest
     */
    agent_id: number;
    /**
     * 
     * @type {AgentDetailAccessSourceEnum}
     * @memberof AgentDetailAccessLogRequest
     */
    source: AgentDetailAccessSourceEnum;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum AgentDetailAccessSourceEnum {
    Top = 'top',
    AgentSearch = 'agent_search',
    SearchResult = 'search_result',
    LimitedProperty = 'limited_property',
    LearningArticle = 'learning_article',
    SimilarAgent = 'similar_agent',
    DiagnosisCompatibilityAgents = 'diagnosis_compatibility_agents'
}

/**
 * エージェント検索結果をまとめのレスポンス
 * @export
 * @interface AgentFeedsResponse
 */
export interface AgentFeedsResponse {
    /**
     * 
     * @type {PaginatedAgentsResponse}
     * @memberof AgentFeedsResponse
     */
    match: PaginatedAgentsResponse;
    /**
     * 
     * @type {PaginatedAgentsResponse}
     * @memberof AgentFeedsResponse
     */
    top_rated: PaginatedAgentsResponse;
    /**
     * 
     * @type {PaginatedAgentsResponse}
     * @memberof AgentFeedsResponse
     */
    active: PaginatedAgentsResponse;
}
/**
 * 
 * @export
 * @interface AgentIntroductionImage
 */
export interface AgentIntroductionImage {
    /**
     * 
     * @type {number}
     * @memberof AgentIntroductionImage
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentIntroductionImage
     */
    agent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentIntroductionImage
     */
    object_storage_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentIntroductionImage
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentIntroductionImage
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentIntroductionImage
     */
    image_url?: string | null;
}
/**
 * 
 * @export
 * @interface AgentInvestmentProposalSummary
 */
export interface AgentInvestmentProposalSummary {
    /**
     * 
     * @type {Agent}
     * @memberof AgentInvestmentProposalSummary
     */
    agent?: Agent;
    /**
     * 
     * @type {Company}
     * @memberof AgentInvestmentProposalSummary
     */
    company?: Company;
    /**
     * 
     * @type {Array<MasterAgentSearchTag>}
     * @memberof AgentInvestmentProposalSummary
     */
    master_agent_search_tags?: Array<MasterAgentSearchTag>;
    /**
     * 
     * @type {number}
     * @memberof AgentInvestmentProposalSummary
     */
    latest_proposal_id?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentInvestmentProposalSummary
     */
    latest_proposal_date?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AgentInvestmentProposalSummary
     */
    latest_proposal_is_user_read?: boolean;
    /**
     * 最新投資提案の第一希望日
     * @type {string}
     * @memberof AgentInvestmentProposalSummary
     */
    latest_proposal_first_preferred_contact_date?: string | null;
    /**
     * 最新投資提案の第一希望時間帯
     * @type {string}
     * @memberof AgentInvestmentProposalSummary
     */
    latest_proposal_first_preferred_contact_time_slot?: AgentInvestmentProposalSummaryLatestProposalFirstPreferredContactTimeSlotEnum;
    /**
     * 最新投資提案の第二希望日
     * @type {string}
     * @memberof AgentInvestmentProposalSummary
     */
    latest_proposal_second_preferred_contact_date?: string | null;
    /**
     * 最新投資提案の第二希望時間帯
     * @type {string}
     * @memberof AgentInvestmentProposalSummary
     */
    latest_proposal_second_preferred_contact_time_slot?: AgentInvestmentProposalSummaryLatestProposalSecondPreferredContactTimeSlotEnum;
    /**
     * 
     * @type {string}
     * @memberof AgentInvestmentProposalSummary
     */
    status?: AgentInvestmentProposalSummaryStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum AgentInvestmentProposalSummaryLatestProposalFirstPreferredContactTimeSlotEnum {
    Morning = 'morning',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Slot911 = 'slot_9_11',
    Slot1113 = 'slot_11_13',
    Slot1315 = 'slot_13_15',
    Slot1517 = 'slot_15_17',
    Slot1719 = 'slot_17_19',
    Slot1921 = 'slot_19_21'
}
/**
    * @export
    * @enum {string}
    */
export enum AgentInvestmentProposalSummaryLatestProposalSecondPreferredContactTimeSlotEnum {
    Morning = 'morning',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Slot911 = 'slot_9_11',
    Slot1113 = 'slot_11_13',
    Slot1315 = 'slot_13_15',
    Slot1517 = 'slot_15_17',
    Slot1719 = 'slot_17_19',
    Slot1921 = 'slot_19_21'
}
/**
    * @export
    * @enum {string}
    */
export enum AgentInvestmentProposalSummaryStatusEnum {
    Proceeding = 'proceeding',
    Pending = 'pending',
    Matched = 'matched'
}

/**
 * ユーザーがお断りしたプランナー（user × agent で 1 件、解除不可）
 * @export
 * @interface AgentMessageRefusal
 */
export interface AgentMessageRefusal {
    /**
     * 
     * @type {number}
     * @memberof AgentMessageRefusal
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMessageRefusal
     */
    agent_id?: number;
    /**
     * お断り操作をしたメッセージの投資提案 ID
     * @type {number}
     * @memberof AgentMessageRefusal
     */
    investment_proposal_id?: number | null;
    /**
     * お断りした日時
     * @type {string}
     * @memberof AgentMessageRefusal
     */
    created_at?: string;
    /**
     * 
     * @type {AgentMessageRefusalAgent}
     * @memberof AgentMessageRefusal
     */
    agent?: AgentMessageRefusalAgent;
}
/**
 * 退会済みのプランナーも返す（名前の表示用）
 * @export
 * @interface AgentMessageRefusalAgent
 */
export interface AgentMessageRefusalAgent {
    /**
     * 
     * @type {number}
     * @memberof AgentMessageRefusalAgent
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMessageRefusalAgent
     */
    company_id?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageRefusalAgent
     */
    family_name?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageRefusalAgent
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentMessageRefusalAgent
     */
    company_name?: string | null;
}
/**
 * エージェント一覧で表示する集計値（サーバ計算）。target_month 指定時は当月に限った値を返す。
 * @export
 * @interface AgentMetrics
 */
export interface AgentMetrics {
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    total_proposal_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    total_user_read_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    total_matching_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    total_contract_application_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    proposal_user_read_rate?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    proposal_matching_rate?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    contract_application_rate?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_inflow_user_proposal_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_re_proposal_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_inflow_user_re_proposal_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_user_read_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_user_read_count_including_prev?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_matching_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_matching_count_including_prev?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_total_matching_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_contract_application_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_contract_application_count_including_prev?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_total_user_read_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_total_matching_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_match_rate_for_business_meeting?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_user_read_rate?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_inflow_user_user_read_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_inflow_user_user_read_rate?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_matching_rate?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_inflow_user_matching_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_proposal_inflow_user_matching_rate?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_contract_application_rate?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_access_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_daily_average_access_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_contract_inflow_user_application_count?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentMetrics
     */
    target_month_contract_inflow_user_application_rate?: number;
}
/**
 * 
 * @export
 * @interface AgentProfileImage
 */
export interface AgentProfileImage {
    /**
     * 
     * @type {number}
     * @memberof AgentProfileImage
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AgentProfileImage
     */
    agent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof AgentProfileImage
     */
    object_storage_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AgentProfileImage
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentProfileImage
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentProfileImage
     */
    image_url?: string | null;
}
/**
 * プロパリーからのコメント（未設定のエージェントは null）
 * @export
 * @interface AgentPropallyComment
 */
export interface AgentPropallyComment {
    /**
     * 
     * @type {string}
     * @memberof AgentPropallyComment
     */
    comment: string;
}
/**
 * 
 * @export
 * @interface AgentSearchRequest
 */
export interface AgentSearchRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof AgentSearchRequest
     */
    company_agent_search_tag_ids?: Array<number>;
}
/**
 * エージェントの対応可能種別
 * @export
 * @enum {string}
 */
export enum AgentSupportedPropertyTypeEnum {
    区分 = '区分',
    一棟 = '一棟',
    海外不動産 = '海外不動産'
}

/**
 * エージェント一覧の並び順
 * @export
 * @enum {string}
 */
export enum AgentsSortOptionEnum {
    Compatibility = 'compatibility'
}

/**
 * 
 * @export
 * @interface AssessmentProposal
 */
export interface AssessmentProposal {
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    agent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    property_id?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    user_id?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    proposal_price?: number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    proposal_content?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentProposal
     */
    is_user_read?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentProposal
     */
    is_user_approved?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposal
     */
    trade_type?: number | null;
    /**
     * status=scheduled の場合は予約送信予定日時、status=sent の場合は実送信日時
     * @type {string}
     * @memberof AssessmentProposal
     */
    proposal_date?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    user_read_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    user_approved_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    user_registered_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    short_appeal_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposal
     */
    discarded_at?: string | null;
    /**
     * 
     * @type {ProposalDeliveryStatus}
     * @memberof AssessmentProposal
     */
    status?: ProposalDeliveryStatus;
    /**
     * 送信失敗理由。例 daily_offer_limit, user_withdrawn, agent_access_blocked
     * @type {string}
     * @memberof AssessmentProposal
     */
    failure_reason?: string | null;
    /**
     * 
     * @type {Agent}
     * @memberof AssessmentProposal
     */
    agent?: Agent;
    /**
     * 
     * @type {User}
     * @memberof AssessmentProposal
     */
    user?: User;
    /**
     * 
     * @type {Property}
     * @memberof AssessmentProposal
     */
    property?: Property;
    /**
     * 
     * @type {Array<AssessmentProposalAttachmentFile>}
     * @memberof AssessmentProposal
     */
    assessment_proposal_attachment_files?: Array<AssessmentProposalAttachmentFile>;
    /**
     * 
     * @type {ProposalStatusEnum}
     * @memberof AssessmentProposal
     */
    proposal_status?: ProposalStatusEnum | null;
    /**
     * 本提案がマッチしているかどうか
     * @type {boolean}
     * @memberof AssessmentProposal
     */
    is_matched?: boolean | null;
    /**
     * ユーザーが本提案をマッチ（承認）可能かどうか
     * @type {boolean}
     * @memberof AssessmentProposal
     */
    is_matchable?: boolean | null;
    /**
     * 全提案、手動ユーザ提案含め、ユーザとエージェントでのマッチが存在するかどうか
     * @type {boolean}
     * @memberof AssessmentProposal
     */
    has_matched?: boolean | null;
}
/**
 * 
 * @export
 * @interface AssessmentProposalAttachmentFile
 */
export interface AssessmentProposalAttachmentFile {
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposalAttachmentFile
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof AssessmentProposalAttachmentFile
     */
    assessment_proposal_id?: number;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposalAttachmentFile
     */
    object_storage_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposalAttachmentFile
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposalAttachmentFile
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof AssessmentProposalAttachmentFile
     */
    file_url?: string | null;
}
/**
 * 
 * @export
 * @interface AssessmentProposalUnreadCountResponse
 */
export interface AssessmentProposalUnreadCountResponse {
    /**
     * 査定提案未読数
     * @type {number}
     * @memberof AssessmentProposalUnreadCountResponse
     */
    unread_count: number;
}
/**
 * base64でファイルを送信するための共通形式（名称はImageだがPDF等も可）。 type には MIME type（例: application/pdf, image/png）を指定する。 
 * @export
 * @interface Base64EncodedImage
 */
export interface Base64EncodedImage {
    /**
     * 
     * @type {string}
     * @memberof Base64EncodedImage
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Base64EncodedImage
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Base64EncodedImage
     */
    data: string;
}
/**
 * 
 * @export
 * @interface BuildingDetail
 */
export interface BuildingDetail {
    /**
     * 管理会社委託費（建物＋賃貸管理含む）
     * @type {number}
     * @memberof BuildingDetail
     */
    management_company_commission?: number | null;
    /**
     * 共用部水道光熱費
     * @type {number}
     * @memberof BuildingDetail
     */
    shared_utility_expenses?: number | null;
    /**
     * その他経費
     * @type {number}
     * @memberof BuildingDetail
     */
    misc_building_cost?: number | null;
}
/**
 * 
 * @export
 * @interface BuildingRoom
 */
export interface BuildingRoom {
    /**
     * 
     * @type {number}
     * @memberof BuildingRoom
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingRoom
     */
    property_id?: number;
    /**
     * 
     * @type {string}
     * @memberof BuildingRoom
     */
    room_number?: string;
    /**
     * 
     * @type {number}
     * @memberof BuildingRoom
     */
    monthly_fee?: number;
    /**
     * 
     * @type {number}
     * @memberof BuildingRoom
     */
    other_monthly_income?: number;
    /**
     * 
     * @type {string}
     * @memberof BuildingRoom
     */
    starts_at?: string;
    /**
     * 
     * @type {string}
     * @memberof BuildingRoom
     */
    ends_at?: string;
    /**
     * 
     * @type {string}
     * @memberof BuildingRoom
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof BuildingRoom
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof BuildingRoom
     */
    discarded_at?: string | null;
}
/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    home_page_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    short_appeal_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    achievements?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    strengths_of_properties_for_sale_and_purchase?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    strengths_of_partner_financial_institutions?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    strengths_of_properties_for_management?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    appeal_point?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    updated_at?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof Company
     */
    company_agent_search_tag_ids?: Array<number>;
    /**
     * 
     * @type {CompanyLogoImage}
     * @memberof Company
     */
    company_logo_image?: CompanyLogoImage | null;
    /**
     * 
     * @type {Array<SalesAchievements>}
     * @memberof Company
     */
    sales_achievements?: Array<SalesAchievements>;
    /**
     * 
     * @type {Array<LimitedProperties>}
     * @memberof Company
     */
    limited_properties?: Array<LimitedProperties>;
}
/**
 * 
 * @export
 * @interface CompanyLogoImage
 */
export interface CompanyLogoImage {
    /**
     * 
     * @type {number}
     * @memberof CompanyLogoImage
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyLogoImage
     */
    company_id?: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoImage
     */
    object_storage_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoImage
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoImage
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyLogoImage
     */
    image_url?: string | null;
}
/**
 * 検討時期
 * @export
 * @enum {string}
 */
export enum ConsiderationPeriodEnum {
    一ヶ月以内 = '一ヶ月以内',
    半年以内 = '半年以内',
    一年以内 = '一年以内',
    それ以上 = 'それ以上'
}

/**
 * 
 * @export
 * @interface ContractApplication
 */
export interface ContractApplication {
    /**
     * 
     * @type {number}
     * @memberof ContractApplication
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractApplication
     */
    proposal_matching_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractApplication
     */
    agent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractApplication
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    application_date?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ContractApplication
     */
    contract_price?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    contract_property_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    contract_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractApplication
     */
    user_registered_at?: string | null;
    /**
     * 
     * @type {Agent}
     * @memberof ContractApplication
     */
    agent?: Agent;
    /**
     * 
     * @type {User}
     * @memberof ContractApplication
     */
    user?: User;
    /**
     * 
     * @type {Array<ContractApplicationAttachmentFile>}
     * @memberof ContractApplication
     */
    contract_application_attachment_files?: Array<ContractApplicationAttachmentFile>;
}
/**
 * 
 * @export
 * @interface ContractApplicationAttachmentFile
 */
export interface ContractApplicationAttachmentFile {
    /**
     * 
     * @type {number}
     * @memberof ContractApplicationAttachmentFile
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof ContractApplicationAttachmentFile
     */
    contract_application_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ContractApplicationAttachmentFile
     */
    object_storage_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContractApplicationAttachmentFile
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractApplicationAttachmentFile
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ContractApplicationAttachmentFile
     */
    attachment_file_url?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum DegreeOfConsiderationEnum {
    Considering = 'Considering',
    NotConsidered = 'NotConsidered'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum DeviceTypeEnum {
    Ios = 'ios',
    Android = 'android',
    Other = 'other',
    Unknown = 'unknown'
}

/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    id: number;
    /**
     * 
     * @type {DocumentType}
     * @memberof Document
     */
    document_type: DocumentType;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    created_at: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    memo?: string;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    file_url?: string | null;
}
/**
 * 
 * @export
 * @interface DocumentForm
 */
export interface DocumentForm {
    /**
     * 
     * @type {string}
     * @memberof DocumentForm
     */
    memo: string;
}
/**
 * ドキュメント種別 0:マイソク・物件提案資料 1:物件パンフレット 2:売買契約書 3:重要事項説明書 4:金銭消費貸借契約書 5:返済予定表 6:賃貸借契約書 7:賃貸管理委託契約書 8:保険証券 9:納税通知書（固定資産税・都市計画税） 10:納税通知書（不動産取得税） 11:その他 
 * @export
 * @enum {string}
 */
export enum DocumentType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3,
    NUMBER_4 = 4,
    NUMBER_5 = 5,
    NUMBER_6 = 6,
    NUMBER_7 = 7,
    NUMBER_8 = 8,
    NUMBER_9 = 9,
    NUMBER_10 = 10,
    NUMBER_11 = 11
}

/**
 * HowMa(外部API)_建物エリア情報
 * @export
 * @interface HowMaArea
 */
export interface HowMaArea {
    /**
     * 住所テキスト(丁目）
     * @type {string}
     * @memberof HowMaArea
     */
    name: string;
}
/**
 * HowMa(外部API)_建物情報
 * @export
 * @interface HowMaBuilding
 */
export interface HowMaBuilding {
    /**
     * マンションID(コラビット)
     * @type {number}
     * @memberof HowMaBuilding
     */
    id: number;
    /**
     * マンション名称
     * @type {string}
     * @memberof HowMaBuilding
     */
    name: string;
    /**
     * 竣工年
     * @type {number}
     * @memberof HowMaBuilding
     */
    built_at_year: number;
    /**
     * 総階数
     * @type {number}
     * @memberof HowMaBuilding
     */
    floor_number: number | null;
    /**
     * 
     * @type {HowMaStation}
     * @memberof HowMaBuilding
     */
    station: HowMaStation | null;
    /**
     * 
     * @type {HowMaArea}
     * @memberof HowMaBuilding
     */
    area: HowMaArea;
}
/**
 * HowMa(外部API)_建物詳細取得APIレスポンスの型
 * @export
 * @interface HowMaBuildingDetailResponse
 */
export interface HowMaBuildingDetailResponse {
    /**
     * 
     * @type {HowMaBuilding}
     * @memberof HowMaBuildingDetailResponse
     */
    building: HowMaBuilding;
    /**
     * 部屋情報一覧
     * @type {Array<HowMaRoom>}
     * @memberof HowMaBuildingDetailResponse
     */
    rooms: Array<HowMaRoom>;
    /**
     * 部屋の合計件数
     * @type {number}
     * @memberof HowMaBuildingDetailResponse
     */
    total_count: number;
}
/**
 * HowMa(外部API)_建物検索APIレスポンスの型
 * @export
 * @interface HowMaBuildingsResponse
 */
export interface HowMaBuildingsResponse {
    /**
     * 建物候補一覧
     * @type {Array<HowMaBuilding>}
     * @memberof HowMaBuildingsResponse
     */
    buildings: Array<HowMaBuilding>;
    /**
     * 検索結果の合計件数
     * @type {number}
     * @memberof HowMaBuildingsResponse
     */
    total_count: number;
}
/**
 * HowMa(外部API)_建物検索APIリクエストの型
 * @export
 * @interface HowMaBuildingsSearchRequest
 */
export interface HowMaBuildingsSearchRequest {
    /**
     * マンション名テキスト
     * @type {string}
     * @memberof HowMaBuildingsSearchRequest
     */
    text: string;
    /**
     * ソート設定(任意)
     * @type {string}
     * @memberof HowMaBuildingsSearchRequest
     */
    order?: string;
    /**
     * ソート設定(昇順フラグ)(任意)
     * @type {boolean}
     * @memberof HowMaBuildingsSearchRequest
     */
    ascending?: boolean;
    /**
     * 建物候補の件数(任意)
     * @type {number}
     * @memberof HowMaBuildingsSearchRequest
     */
    limit?: number;
    /**
     * 一覧のページ番号(任意)
     * @type {number}
     * @memberof HowMaBuildingsSearchRequest
     */
    page?: number;
}
/**
 * HowMa(外部API)_部屋情報
 * @export
 * @interface HowMaRoom
 */
export interface HowMaRoom {
    /**
     * 部屋番号
     * @type {string}
     * @memberof HowMaRoom
     */
    name: string;
    /**
     * 間取り(半角文字列)
     * @type {string}
     * @memberof HowMaRoom
     */
    floor_plan: string;
    /**
     * 専有面積(㎡、小数点2桁)
     * @type {number}
     * @memberof HowMaRoom
     */
    m2: number;
    /**
     * 所在階
     * @type {number}
     * @memberof HowMaRoom
     */
    floor_number: number;
}
/**
 * HowMa(外部API)_駅情報
 * @export
 * @interface HowMaStation
 */
export interface HowMaStation {
    /**
     * 最寄駅名称
     * @type {string}
     * @memberof HowMaStation
     */
    name: string;
    /**
     * 駅コード(コラビット) 整数7桁 ※新幹線は6桁
     * @type {number}
     * @memberof HowMaStation
     */
    cd: number;
    /**
     * 路線コード(コラビット) 整数5桁 ※新幹線は4桁
     * @type {number}
     * @memberof HowMaStation
     */
    line_cd: number;
}
/**
 * 
 * @export
 * @interface Id
 */
export interface Id {
    /**
     * 
     * @type {number}
     * @memberof Id
     */
    id?: number;
}
/**
 * 
 * @export
 * @interface IdName
 */
export interface IdName {
    /**
     * 
     * @type {number}
     * @memberof IdName
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IdName
     */
    name?: string | null;
}
/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    property_id?: number;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    object_storage_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    discarded_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    image_url?: string | null;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    adjust_network?: string | null;
}
/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * 
     * @type {object}
     * @memberof InlineObject1
     */
    social_login_response?: object;
    /**
     * 
     * @type {string}
     * @memberof InlineObject1
     */
    adjust_network?: string | null;
}
/**
 * 
 * @export
 * @interface InlineObject10
 */
export interface InlineObject10 {
    /**
     * 補完に使用するマンション名
     * @type {string}
     * @memberof InlineObject10
     */
    property_name: string;
    /**
     * 号室
     * @type {string}
     * @memberof InlineObject10
     */
    room_number?: string;
    /**
     * 所在階
     * @type {number}
     * @memberof InlineObject10
     */
    floor?: number;
    /**
     * 都道府県
     * @type {string}
     * @memberof InlineObject10
     */
    prefecture?: string;
    /**
     * 市区町村
     * @type {string}
     * @memberof InlineObject10
     */
    city?: string;
    /**
     * 番地
     * @type {string}
     * @memberof InlineObject10
     */
    town?: string;
    /**
     * 路線名
     * @type {string}
     * @memberof InlineObject10
     */
    railway?: string;
    /**
     * 駅名
     * @type {string}
     * @memberof InlineObject10
     */
    station?: string;
    /**
     * 駅徒歩（分）
     * @type {number}
     * @memberof InlineObject10
     */
    walk?: number;
    /**
     * 築年（YYYY）
     * @type {string}
     * @memberof InlineObject10
     */
    built_at?: string;
    /**
     * 専有面積（m2）
     * @type {number}
     * @memberof InlineObject10
     */
    occupied_area_m2?: number;
    /**
     * 間取り
     * @type {string}
     * @memberof InlineObject10
     */
    layout?: string;
    /**
     * 構造
     * @type {string}
     * @memberof InlineObject10
     */
    structure?: string;
    /**
     * 管理形態
     * @type {string}
     * @memberof InlineObject10
     */
    management_type?: string;
    /**
     * 売却状況
     * @type {string}
     * @memberof InlineObject10
     */
    sales_status?: string;
    /**
     * 購入年月（YYYY-MM）
     * @type {string}
     * @memberof InlineObject10
     */
    bought_at?: string;
    /**
     * 購入日（1-31）
     * @type {number}
     * @memberof InlineObject10
     */
    bought_at_day?: number;
}
/**
 * 
 * @export
 * @interface InlineObject11
 */
export interface InlineObject11 {
    /**
     * 
     * @type {Base64EncodedImage}
     * @memberof InlineObject11
     */
    sale_contract_document?: Base64EncodedImage;
    /**
     * 
     * @type {Base64EncodedImage}
     * @memberof InlineObject11
     */
    important_explanation_document?: Base64EncodedImage;
    /**
     * 
     * @type {Base64EncodedImage}
     * @memberof InlineObject11
     */
    lease_contract_document?: Base64EncodedImage;
}
/**
 * 
 * @export
 * @interface InlineObject12
 */
export interface InlineObject12 {
    /**
     * 補完に使用するマンション名
     * @type {string}
     * @memberof InlineObject12
     */
    property_name: string;
    /**
     * 号室
     * @type {string}
     * @memberof InlineObject12
     */
    room_number?: string;
    /**
     * 所在階
     * @type {number}
     * @memberof InlineObject12
     */
    floor?: number;
    /**
     * 都道府県
     * @type {string}
     * @memberof InlineObject12
     */
    prefecture?: string;
    /**
     * 市区町村
     * @type {string}
     * @memberof InlineObject12
     */
    city?: string;
    /**
     * 番地
     * @type {string}
     * @memberof InlineObject12
     */
    town?: string;
    /**
     * 路線名
     * @type {string}
     * @memberof InlineObject12
     */
    railway?: string;
    /**
     * 駅名
     * @type {string}
     * @memberof InlineObject12
     */
    station?: string;
    /**
     * 駅徒歩（分）
     * @type {number}
     * @memberof InlineObject12
     */
    walk?: number;
    /**
     * 築年（YYYY）
     * @type {string}
     * @memberof InlineObject12
     */
    built_at?: string;
    /**
     * 専有面積（m2）
     * @type {number}
     * @memberof InlineObject12
     */
    occupied_area_m2?: number;
    /**
     * 間取り
     * @type {string}
     * @memberof InlineObject12
     */
    layout?: string;
    /**
     * 構造
     * @type {string}
     * @memberof InlineObject12
     */
    structure?: string;
}
/**
 * 
 * @export
 * @interface InlineObject13
 */
export interface InlineObject13 {
    /**
     * 
     * @type {Base64EncodedImage}
     * @memberof InlineObject13
     */
    sale_contract_document?: Base64EncodedImage;
    /**
     * 
     * @type {Base64EncodedImage}
     * @memberof InlineObject13
     */
    important_explanation_document?: Base64EncodedImage;
    /**
     * 
     * @type {Base64EncodedImage}
     * @memberof InlineObject13
     */
    lease_contract_document?: Base64EncodedImage;
}
/**
 * 
 * @export
 * @interface InlineObject14
 */
export interface InlineObject14 {
    /**
     * 
     * @type {Array<ReserveFundPriceChange>}
     * @memberof InlineObject14
     */
    reserve_fund_price_changes?: Array<ReserveFundPriceChange>;
}
/**
 * 
 * @export
 * @interface InlineObject2
 */
export interface InlineObject2 {
    /**
     * 
     * @type {object}
     * @memberof InlineObject2
     */
    social_login_response?: object;
    /**
     * 
     * @type {string}
     * @memberof InlineObject2
     */
    adjust_network?: string | null;
}
/**
 * 
 * @export
 * @interface InlineObject3
 */
export interface InlineObject3 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject3
     */
    email_confirmation_token?: string;
}
/**
 * 
 * @export
 * @interface InlineObject4
 */
export interface InlineObject4 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject4
     */
    phone_number?: string;
}
/**
 * 
 * @export
 * @interface InlineObject5
 */
export interface InlineObject5 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject5
     */
    email?: string;
}
/**
 * 
 * @export
 * @interface InlineObject6
 */
export interface InlineObject6 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject6
     */
    password_reset_token?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject6
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineObject6
     */
    password_confirmation?: string;
}
/**
 * 
 * @export
 * @interface InlineObject7
 */
export interface InlineObject7 {
    /**
     * 補完に使用するマンション名
     * @type {string}
     * @memberof InlineObject7
     */
    property_name: string;
}
/**
 * 
 * @export
 * @interface InlineObject8
 */
export interface InlineObject8 {
    /**
     * 補完に使用するマンション名
     * @type {string}
     * @memberof InlineObject8
     */
    property_name: string;
    /**
     * 号室
     * @type {string}
     * @memberof InlineObject8
     */
    room_number?: string;
    /**
     * 所在階
     * @type {number}
     * @memberof InlineObject8
     */
    floor?: number;
    /**
     * 都道府県
     * @type {string}
     * @memberof InlineObject8
     */
    prefecture?: string;
    /**
     * 市区町村
     * @type {string}
     * @memberof InlineObject8
     */
    city?: string;
    /**
     * 番地
     * @type {string}
     * @memberof InlineObject8
     */
    town?: string;
    /**
     * 路線名
     * @type {string}
     * @memberof InlineObject8
     */
    railway?: string;
    /**
     * 駅名
     * @type {string}
     * @memberof InlineObject8
     */
    station?: string;
    /**
     * 駅徒歩（分）
     * @type {number}
     * @memberof InlineObject8
     */
    walk?: number;
    /**
     * 築年（YYYY）
     * @type {string}
     * @memberof InlineObject8
     */
    built_at?: string;
    /**
     * 専有面積（m2）
     * @type {number}
     * @memberof InlineObject8
     */
    occupied_area_m2?: number;
    /**
     * 間取り
     * @type {string}
     * @memberof InlineObject8
     */
    layout?: string;
    /**
     * 構造
     * @type {string}
     * @memberof InlineObject8
     */
    structure?: string;
    /**
     * 管理形態
     * @type {string}
     * @memberof InlineObject8
     */
    management_type?: string;
    /**
     * 売却状況
     * @type {string}
     * @memberof InlineObject8
     */
    sales_status?: string;
    /**
     * 購入年月（YYYY-MM）
     * @type {string}
     * @memberof InlineObject8
     */
    bought_at?: string;
    /**
     * 購入日（1-31）
     * @type {number}
     * @memberof InlineObject8
     */
    bought_at_day?: number;
}
/**
 * 
 * @export
 * @interface InlineObject9
 */
export interface InlineObject9 {
    /**
     * 補完に使用するマンション名
     * @type {string}
     * @memberof InlineObject9
     */
    property_name: string;
    /**
     * 号室
     * @type {string}
     * @memberof InlineObject9
     */
    room_number?: string;
    /**
     * 所在階
     * @type {number}
     * @memberof InlineObject9
     */
    floor?: number;
    /**
     * 都道府県
     * @type {string}
     * @memberof InlineObject9
     */
    prefecture?: string;
    /**
     * 市区町村
     * @type {string}
     * @memberof InlineObject9
     */
    city?: string;
    /**
     * 番地
     * @type {string}
     * @memberof InlineObject9
     */
    town?: string;
    /**
     * 路線名
     * @type {string}
     * @memberof InlineObject9
     */
    railway?: string;
    /**
     * 駅名
     * @type {string}
     * @memberof InlineObject9
     */
    station?: string;
    /**
     * 駅徒歩（分）
     * @type {number}
     * @memberof InlineObject9
     */
    walk?: number;
    /**
     * 築年（YYYY）
     * @type {string}
     * @memberof InlineObject9
     */
    built_at?: string;
    /**
     * 専有面積（m2）
     * @type {number}
     * @memberof InlineObject9
     */
    occupied_area_m2?: number;
    /**
     * 間取り
     * @type {string}
     * @memberof InlineObject9
     */
    layout?: string;
    /**
     * 構造
     * @type {string}
     * @memberof InlineObject9
     */
    structure?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse200
     */
    status?: InlineResponse200StatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse200StatusEnum {
    Ok = 'ok'
}

/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2001
     */
    min_version?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2002
     */
    message?: string;
    /**
     * 送信成功後に再送できるまでの秒数
     * @type {number}
     * @memberof InlineResponse2002
     */
    retry_after?: number;
}
/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse2003
     */
    url?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 {
    /**
     * 署名付きURL
     * @type {string}
     * @memberof InlineResponse2004
     */
    signed_url?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 {
    /**
     * 
     * @type {Array<WebinarSummary>}
     * @memberof InlineResponse2005
     */
    webinars?: Array<WebinarSummary>;
}
/**
 * 
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 {
    /**
     * 
     * @type {WebinarDetail}
     * @memberof InlineResponse2006
     */
    webinar?: WebinarDetail;
}
/**
 * 
 * @export
 * @interface InlineResponse201
 */
export interface InlineResponse201 {
    /**
     * 
     * @type {WebinarViewing}
     * @memberof InlineResponse201
     */
    viewing_history?: WebinarViewing;
}
/**
 * 
 * @export
 * @interface InlineResponse401
 */
export interface InlineResponse401 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse401
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse422
 */
export interface InlineResponse422 {
    /**
     * ALREADY_MATCHED: マッチ済み（無効化済みのマッチも含む）のプランナーからのメッセージ NOT_REFUSABLE: マッチ不可（is_matchable=false）のメッセージ 
     * @type {string}
     * @memberof InlineResponse422
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse422
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse4221
 */
export interface InlineResponse4221 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse4221
     */
    message?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse4221
     */
    errors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse4221
     */
    code?: string;
}
/**
 * 
 * @export
 * @interface InlineResponse429
 */
export interface InlineResponse429 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse429
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse429
     */
    code?: string;
    /**
     * 再送できるまでの残り秒数
     * @type {number}
     * @memberof InlineResponse429
     */
    retry_after?: number;
    /**
     * 同一セッション・同一電話番号の送信済みコードを保持している場合のみtrue
     * @type {boolean}
     * @memberof InlineResponse429
     */
    code_available?: boolean;
    /**
     * pendingは送信処理中、sentは送信済みの再送間隔内
     * @type {string}
     * @memberof InlineResponse429
     */
    delivery_state?: InlineResponse429DeliveryStateEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse429DeliveryStateEnum {
    Pending = 'pending',
    Sent = 'sent'
}

/**
 * 
 * @export
 * @interface InlineResponse500
 */
export interface InlineResponse500 {
    /**
     * 
     * @type {string}
     * @memberof InlineResponse500
     */
    status?: InlineResponse500StatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineResponse500StatusEnum {
    InternalServerError = 'internal_server_error'
}

/**
 * 
 * @export
 * @interface InvestmentProposal
 */
export interface InvestmentProposal {
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposal
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposal
     */
    agent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposal
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    proposal_content?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentProposal
     */
    is_user_read?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentProposal
     */
    is_user_approved?: boolean | null;
    /**
     * status=scheduled の場合は予約送信予定日時、status=sent の場合は実送信日時
     * @type {string}
     * @memberof InvestmentProposal
     */
    proposal_date?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    user_read_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    user_approved_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    user_registered_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    short_appeal_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposal
     */
    discarded_at?: string | null;
    /**
     * 
     * @type {ProposalDeliveryStatus}
     * @memberof InvestmentProposal
     */
    status?: ProposalDeliveryStatus;
    /**
     * 送信失敗理由。例 daily_offer_limit, user_withdrawn, agent_access_blocked
     * @type {string}
     * @memberof InvestmentProposal
     */
    failure_reason?: string | null;
    /**
     * 第一希望日
     * @type {string}
     * @memberof InvestmentProposal
     */
    first_preferred_contact_date?: string | null;
    /**
     * 第一希望時間帯
     * @type {string}
     * @memberof InvestmentProposal
     */
    first_preferred_contact_time_slot?: InvestmentProposalFirstPreferredContactTimeSlotEnum;
    /**
     * 第二希望日
     * @type {string}
     * @memberof InvestmentProposal
     */
    second_preferred_contact_date?: string | null;
    /**
     * 第二希望時間帯
     * @type {string}
     * @memberof InvestmentProposal
     */
    second_preferred_contact_time_slot?: InvestmentProposalSecondPreferredContactTimeSlotEnum;
    /**
     * 
     * @type {Agent}
     * @memberof InvestmentProposal
     */
    agent?: Agent;
    /**
     * 
     * @type {User}
     * @memberof InvestmentProposal
     */
    user?: User;
    /**
     * 
     * @type {Array<InvestmentProposalAttachmentFile>}
     * @memberof InvestmentProposal
     */
    investment_proposal_attachment_files?: Array<InvestmentProposalAttachmentFile>;
    /**
     * 
     * @type {ProposalStatusEnum}
     * @memberof InvestmentProposal
     */
    proposal_status?: ProposalStatusEnum | null;
    /**
     * 本提案がマッチしているかどうか
     * @type {boolean}
     * @memberof InvestmentProposal
     */
    is_matched?: boolean | null;
    /**
     * ユーザーが本提案をマッチ（承認）可能かどうか
     * @type {boolean}
     * @memberof InvestmentProposal
     */
    is_matchable?: boolean | null;
    /**
     * 全提案、手動ユーザ提案含め、ユーザとエージェントでのマッチが存在するかどうか
     * @type {boolean}
     * @memberof InvestmentProposal
     */
    has_matched?: boolean | null;
    /**
     * 必要に応じて、ユーザーと該当エージェント間の提案履歴を返す
     * @type {Array<InvestmentProposalHistory>}
     * @memberof InvestmentProposal
     */
    history_investment_proposals?: Array<InvestmentProposalHistory> | null;
    /**
     * 
     * @type {OfferScore}
     * @memberof InvestmentProposal
     */
    offer_score?: OfferScore | null;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentProposalFirstPreferredContactTimeSlotEnum {
    Morning = 'morning',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Slot911 = 'slot_9_11',
    Slot1113 = 'slot_11_13',
    Slot1315 = 'slot_13_15',
    Slot1517 = 'slot_15_17',
    Slot1719 = 'slot_17_19',
    Slot1921 = 'slot_19_21'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentProposalSecondPreferredContactTimeSlotEnum {
    Morning = 'morning',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Slot911 = 'slot_9_11',
    Slot1113 = 'slot_11_13',
    Slot1315 = 'slot_13_15',
    Slot1517 = 'slot_15_17',
    Slot1719 = 'slot_17_19',
    Slot1921 = 'slot_19_21'
}

/**
 * 
 * @export
 * @interface InvestmentProposalApprovedWithRecommendationsResponse
 */
export interface InvestmentProposalApprovedWithRecommendationsResponse {
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalApprovedWithRecommendationsResponse
     */
    message?: string | null;
    /**
     * 
     * @type {Array<Agent>}
     * @memberof InvestmentProposalApprovedWithRecommendationsResponse
     */
    recommend_agents?: Array<Agent> | null;
}
/**
 * 
 * @export
 * @interface InvestmentProposalAttachmentFile
 */
export interface InvestmentProposalAttachmentFile {
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposalAttachmentFile
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposalAttachmentFile
     */
    investment_proposal_id?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalAttachmentFile
     */
    object_storage_path?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalAttachmentFile
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalAttachmentFile
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalAttachmentFile
     */
    file_url?: string | null;
}
/**
 * 
 * @export
 * @interface InvestmentProposalHistory
 */
export interface InvestmentProposalHistory {
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalHistory
     */
    short_appeal_message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalHistory
     */
    proposal_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalHistory
     */
    proposal_content?: string;
}
/**
 * 
 * @export
 * @interface InvestmentProposalPreferredContactSchedulesRequest
 */
export interface InvestmentProposalPreferredContactSchedulesRequest {
    /**
     * 第一希望日
     * @type {string}
     * @memberof InvestmentProposalPreferredContactSchedulesRequest
     */
    first_preferred_contact_date: string;
    /**
     * 第一希望時間帯（morning/afternoon/evening は旧3枠。新規は2時間枠 slot_* を使用）
     * @type {string}
     * @memberof InvestmentProposalPreferredContactSchedulesRequest
     */
    first_preferred_contact_time_slot: InvestmentProposalPreferredContactSchedulesRequestFirstPreferredContactTimeSlotEnum;
    /**
     * 第二希望日
     * @type {string}
     * @memberof InvestmentProposalPreferredContactSchedulesRequest
     */
    second_preferred_contact_date: string;
    /**
     * 第二希望時間帯（morning/afternoon/evening は旧3枠。新規は2時間枠 slot_* を使用）
     * @type {string}
     * @memberof InvestmentProposalPreferredContactSchedulesRequest
     */
    second_preferred_contact_time_slot: InvestmentProposalPreferredContactSchedulesRequestSecondPreferredContactTimeSlotEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentProposalPreferredContactSchedulesRequestFirstPreferredContactTimeSlotEnum {
    Morning = 'morning',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Slot911 = 'slot_9_11',
    Slot1113 = 'slot_11_13',
    Slot1315 = 'slot_13_15',
    Slot1517 = 'slot_15_17',
    Slot1719 = 'slot_17_19',
    Slot1921 = 'slot_19_21'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentProposalPreferredContactSchedulesRequestSecondPreferredContactTimeSlotEnum {
    Morning = 'morning',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Slot911 = 'slot_9_11',
    Slot1113 = 'slot_11_13',
    Slot1315 = 'slot_13_15',
    Slot1517 = 'slot_15_17',
    Slot1719 = 'slot_17_19',
    Slot1921 = 'slot_19_21'
}

/**
 * 
 * @export
 * @interface InvestmentProposalStatusResponse
 */
export interface InvestmentProposalStatusResponse {
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposalStatusResponse
     */
    agent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalStatusResponse
     */
    status?: InvestmentProposalStatusResponseStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentProposalStatusResponseStatusEnum {
    Proceeding = 'proceeding',
    Pending = 'pending',
    Matched = 'matched'
}

/**
 * 
 * @export
 * @interface InvestmentProposalStatusUpdateRequest
 */
export interface InvestmentProposalStatusUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof InvestmentProposalStatusUpdateRequest
     */
    agent_id: number;
    /**
     * 
     * @type {string}
     * @memberof InvestmentProposalStatusUpdateRequest
     */
    status: InvestmentProposalStatusUpdateRequestStatusEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentProposalStatusUpdateRequestStatusEnum {
    Proceeding = 'proceeding',
    Pending = 'pending',
    Matched = 'matched'
}

/**
 * 
 * @export
 * @interface InvestmentProposalUnreadCountResponse
 */
export interface InvestmentProposalUnreadCountResponse {
    /**
     * 投資提案未読数
     * @type {number}
     * @memberof InvestmentProposalUnreadCountResponse
     */
    unread_count: number;
}
/**
 * 
 * @export
 * @interface InvestmentStyleDiagnosis
 */
export interface InvestmentStyleDiagnosis {
    /**
     * 投資目的（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosis
     */
    purposes?: Array<InvestmentStyleDiagnosisPurposesEnum>;
    /**
     * 最も重要な投資目的
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    primary_purpose?: InvestmentStyleDiagnosisPrimaryPurposeEnum;
    /**
     * 理想の状態（自由記述）。旧設問。現行の入力画面では target_monthly_income に置き換え、過去の回答のために残す
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    ideal_text?: string | null;
    /**
     * 将来の不動産収入（月額）。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    target_monthly_income?: InvestmentStyleDiagnosisTargetMonthlyIncomeEnum;
    /**
     * 関心事項1位
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    interest_1st?: InvestmentStyleDiagnosisInterest1stEnum;
    /**
     * 関心事項2位
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    interest_2nd?: InvestmentStyleDiagnosisInterest2ndEnum;
    /**
     * 関心事項3位
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    interest_3rd?: InvestmentStyleDiagnosisInterest3rdEnum;
    /**
     * 成功条件（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosis
     */
    success_conditions?: Array<InvestmentStyleDiagnosisSuccessConditionsEnum>;
    /**
     * 毎月の持ち出し許容額
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    monthly_out_of_pocket?: InvestmentStyleDiagnosisMonthlyOutOfPocketEnum;
    /**
     * 借入についての考え方。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    borrowing_stance?: InvestmentStyleDiagnosisBorrowingStanceEnum;
    /**
     * 保有期間の想定
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    holding_period?: InvestmentStyleDiagnosisHoldingPeriodEnum;
    /**
     * 立地⇔利回りの選好（1:立地重視〜5:利回り重視）
     * @type {number}
     * @memberof InvestmentStyleDiagnosis
     */
    location_yield_preference?: number;
    /**
     * 運用スタイル
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    management_style?: InvestmentStyleDiagnosisManagementStyleEnum;
    /**
     * 売却タイミングの考え方
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    short_term_sale_intent?: InvestmentStyleDiagnosisShortTermSaleIntentEnum;
    /**
     * 1件目の時期。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    first_purchase_timing?: InvestmentStyleDiagnosisFirstPurchaseTimingEnum;
    /**
     * 比べたいプランナーの人数。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    planner_comparison_count?: InvestmentStyleDiagnosisPlannerComparisonCountEnum;
    /**
     * 面談で確認したいこと（複数選択・配列順が選択順）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosis
     */
    meeting_check_items?: Array<InvestmentStyleDiagnosisMeetingCheckItemsEnum>;
    /**
     * 希望する説明方法（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosis
     */
    explanation_styles?: Array<InvestmentStyleDiagnosisExplanationStylesEnum>;
    /**
     * 面談で聞きたいこと（自由記述）
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    meeting_free_text?: string | null;
    /**
     * 不安要素：ローン負担
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    anxiety_loan?: InvestmentStyleDiagnosisAnxietyLoanEnum;
    /**
     * 不安要素：空室
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    anxiety_vacancy?: InvestmentStyleDiagnosisAnxietyVacancyEnum;
    /**
     * 不安要素：出口・売却
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    anxiety_exit?: InvestmentStyleDiagnosisAnxietyExitEnum;
    /**
     * 不安要素：修繕費
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    anxiety_repair?: InvestmentStyleDiagnosisAnxietyRepairEnum;
    /**
     * 不安要素：営業に流されること
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    anxiety_sales_pressure?: InvestmentStyleDiagnosisAnxietySalesPressureEnum;
    /**
     * 避けたい営業スタイル（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosis
     */
    avoid_sales_styles?: Array<InvestmentStyleDiagnosisAvoidSalesStylesEnum>;
    /**
     * 家賃収入の使いみち。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    rental_income_use?: InvestmentStyleDiagnosisRentalIncomeUseEnum;
    /**
     * 働き方の見通し。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    work_outlook?: InvestmentStyleDiagnosisWorkOutlookEnum;
    /**
     * 
     * @type {number}
     * @memberof InvestmentStyleDiagnosis
     */
    id?: number;
    /**
     * お客様タイプ
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    customer_type?: InvestmentStyleDiagnosisCustomerTypeEnum;
    /**
     * 診断から導出した中心的な投資目的
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    core_goal?: InvestmentStyleDiagnosisCoreGoalEnum;
    /**
     * 関心グラフ（スコア降順）
     * @type {Array<InvestmentStyleDiagnosisInterestScore>}
     * @memberof InvestmentStyleDiagnosis
     */
    interest_scores?: Array<InvestmentStyleDiagnosisInterestScore>;
    /**
     * 向いているアセット（おすすめ順）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosis
     */
    suited_assets?: Array<InvestmentStyleDiagnosisSuitedAssetsEnum>;
    /**
     * 面談で聞くと良い質問（最大5件・表示順）
     * @type {Array<InvestmentStyleDiagnosisMeetingQuestion>}
     * @memberof InvestmentStyleDiagnosis
     */
    meeting_questions?: Array<InvestmentStyleDiagnosisMeetingQuestion>;
    /**
     * 不安項目（降順）
     * @type {Array<InvestmentStyleDiagnosisAnxietyScore>}
     * @memberof InvestmentStyleDiagnosis
     */
    anxiety_scores?: Array<InvestmentStyleDiagnosisAnxietyScore>;
    /**
     * 避けるべき進め方の警告（重要度順・最大2件）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosis
     */
    avoid_sales_style_warnings?: Array<InvestmentStyleDiagnosisAvoidSalesStyleWarningsEnum>;
    /**
     * 安全装置フラグ（強い不安が3つ以上）
     * @type {boolean}
     * @memberof InvestmentStyleDiagnosis
     */
    needs_safety_content?: boolean;
    /**
     * 診断完了日時（作成日時）
     * @type {string}
     * @memberof InvestmentStyleDiagnosis
     */
    created_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPurposesEnum {
    RetirementIncome = 'retirement_income',
    InflationHedge = 'inflation_hedge',
    LifeInsurance = 'life_insurance',
    TaxSaving = 'tax_saving',
    SideIncome = 'side_income',
    ShortTermGain = 'short_term_gain'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPrimaryPurposeEnum {
    RetirementIncome = 'retirement_income',
    InflationHedge = 'inflation_hedge',
    LifeInsurance = 'life_insurance',
    TaxSaving = 'tax_saving',
    SideIncome = 'side_income',
    ShortTermGain = 'short_term_gain'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisTargetMonthlyIncomeEnum {
    Plus30k = 'plus_30k',
    Plus50k = 'plus_50k',
    Plus100k = 'plus_100k',
    Plus150kOrMore = 'plus_150k_or_more',
    Undecided = 'undecided'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisInterest1stEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisInterest2ndEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisInterest3rdEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisSuccessConditionsEnum {
    RetirementMonthly = 'retirement_monthly',
    DebtFreeAsset = 'debt_free_asset',
    AvoidBigLoss = 'avoid_big_loss',
    AbleToExpand = 'able_to_expand',
    TaxAchieved = 'tax_achieved'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisMonthlyOutOfPocketEnum {
    NearZero = 'near_zero',
    Within5k = 'within_5k',
    Within10k = 'within_10k',
    Within30k = 'within_30k',
    Within50k = 'within_50k',
    Over50k = 'over_50k'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisBorrowingStanceEnum {
    StartSmallFirstLoan = 'start_small_first_loan',
    OkIfRentCovers = 'ok_if_rent_covers',
    AnxiousWithMortgage = 'anxious_with_mortgage',
    StartBigIfPossible = 'start_big_if_possible',
    UnsureEligibility = 'unsure_eligibility'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisHoldingPeriodEnum {
    Within5y = 'within_5y',
    About10y = 'about_10y',
    About20y = 'about_20y',
    About30y = 'about_30y',
    AfterPayoff = 'after_payoff'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisManagementStyleEnum {
    FullyDelegated = 'fully_delegated',
    DelegatedWithReport = 'delegated_with_report',
    KeyDecisionsOnly = 'key_decisions_only',
    SelfDirected = 'self_directed',
    ActiveLandlord = 'active_landlord'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisShortTermSaleIntentEnum {
    Yes = 'yes',
    Conditional = 'conditional',
    No = 'no',
    Neutral = 'neutral'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisFirstPurchaseTimingEnum {
    Within1m = 'within_1m',
    Within3m = 'within_3m',
    Within6m = 'within_6m',
    Within1y = 'within_1y',
    ConsultPlanner = 'consult_planner'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerComparisonCountEnum {
    One = 'one',
    TwoToThree = 'two_to_three',
    FiveOrMore = 'five_or_more',
    TenOrMore = 'ten_or_more',
    ConsultPlanner = 'consult_planner'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisMeetingCheckItemsEnum {
    MonthlyRealCost = 'monthly_real_cost',
    VacancyCost = 'vacancy_cost',
    InterestRateRise = 'interest_rate_rise',
    RentDecline = 'rent_decline',
    RepairCost = 'repair_cost',
    SalePrice = 'sale_price',
    TaxEffect = 'tax_effect',
    UnfitCase = 'unfit_case',
    Comparison = 'comparison',
    LoanConsult = 'loan_consult',
    SupportDetail = 'support_detail'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisExplanationStylesEnum {
    BeginnerFriendly = 'beginner_friendly',
    WithNumbers = 'with_numbers',
    RiskFirst = 'risk_first',
    ProsCons = 'pros_cons',
    NoJargon = 'no_jargon',
    VsOtherInvestments = 'vs_other_investments',
    WithRationale = 'with_rationale',
    ConcisePoints = 'concise_points',
    OwnPace = 'own_pace',
    ProactiveSuggestion = 'proactive_suggestion'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnxietyLoanEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnxietyVacancyEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnxietyExitEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnxietyRepairEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnxietySalesPressureEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAvoidSalesStylesEnum {
    Overpriced = 'overpriced',
    TaxOnly = 'tax_only',
    PushyImmediate = 'pushy_immediate',
    HighManagement = 'high_management',
    ExcessiveLoan = 'excessive_loan'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRentalIncomeUseEnum {
    Savings = 'savings',
    LivingExpenses = 'living_expenses',
    LoanPrepayment = 'loan_prepayment',
    Family = 'family',
    NextProperty = 'next_property'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisWorkOutlookEnum {
    Until60 = 'until_60',
    Until65 = 'until_65',
    Until70 = 'until_70',
    AsLongAsAble = 'as_long_as_able',
    Undecided = 'undecided'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisCustomerTypeEnum {
    ShortTermGain = 'short_term_gain',
    LongTermHold = 'long_term_hold',
    LocationFocused = 'location_focused',
    YieldFocused = 'yield_focused'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisCoreGoalEnum {
    RetirementIncome = 'retirement_income',
    LongTermAsset = 'long_term_asset',
    FamilyProtection = 'family_protection',
    SideIncome = 'side_income',
    LowEffort = 'low_effort',
    YieldImprovement = 'yield_improvement',
    LossAvoidance = 'loss_avoidance',
    ShortTermGain = 'short_term_gain'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisSuitedAssetsEnum {
    UrbanUsedKubun = 'urban_used_kubun',
    NewKubun = 'new_kubun',
    RenovatedKubun = 'renovated_kubun',
    UrbanOldIttou = 'urban_old_ittou',
    UrbanNewIttou = 'urban_new_ittou',
    RuralOldIttou = 'rural_old_ittou',
    RuralNewIttou = 'rural_new_ittou'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAvoidSalesStyleWarningsEnum {
    Overpriced = 'overpriced',
    TaxOnly = 'tax_only',
    PushyImmediate = 'pushy_immediate',
    HighManagement = 'high_management',
    ExcessiveLoan = 'excessive_loan'
}

/**
 * 
 * @export
 * @interface InvestmentStyleDiagnosisAnswers
 */
export interface InvestmentStyleDiagnosisAnswers {
    /**
     * 投資目的（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    purposes?: Array<InvestmentStyleDiagnosisAnswersPurposesEnum>;
    /**
     * 最も重要な投資目的
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    primary_purpose?: InvestmentStyleDiagnosisAnswersPrimaryPurposeEnum;
    /**
     * 理想の状態（自由記述）。旧設問。現行の入力画面では target_monthly_income に置き換え、過去の回答のために残す
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    ideal_text?: string | null;
    /**
     * 将来の不動産収入（月額）。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    target_monthly_income?: InvestmentStyleDiagnosisAnswersTargetMonthlyIncomeEnum;
    /**
     * 関心事項1位
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    interest_1st?: InvestmentStyleDiagnosisAnswersInterest1stEnum;
    /**
     * 関心事項2位
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    interest_2nd?: InvestmentStyleDiagnosisAnswersInterest2ndEnum;
    /**
     * 関心事項3位
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    interest_3rd?: InvestmentStyleDiagnosisAnswersInterest3rdEnum;
    /**
     * 成功条件（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    success_conditions?: Array<InvestmentStyleDiagnosisAnswersSuccessConditionsEnum>;
    /**
     * 毎月の持ち出し許容額
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    monthly_out_of_pocket?: InvestmentStyleDiagnosisAnswersMonthlyOutOfPocketEnum;
    /**
     * 借入についての考え方。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    borrowing_stance?: InvestmentStyleDiagnosisAnswersBorrowingStanceEnum;
    /**
     * 保有期間の想定
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    holding_period?: InvestmentStyleDiagnosisAnswersHoldingPeriodEnum;
    /**
     * 立地⇔利回りの選好（1:立地重視〜5:利回り重視）
     * @type {number}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    location_yield_preference?: number;
    /**
     * 運用スタイル
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    management_style?: InvestmentStyleDiagnosisAnswersManagementStyleEnum;
    /**
     * 売却タイミングの考え方
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    short_term_sale_intent?: InvestmentStyleDiagnosisAnswersShortTermSaleIntentEnum;
    /**
     * 1件目の時期。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    first_purchase_timing?: InvestmentStyleDiagnosisAnswersFirstPurchaseTimingEnum;
    /**
     * 比べたいプランナーの人数。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    planner_comparison_count?: InvestmentStyleDiagnosisAnswersPlannerComparisonCountEnum;
    /**
     * 面談で確認したいこと（複数選択・配列順が選択順）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    meeting_check_items?: Array<InvestmentStyleDiagnosisAnswersMeetingCheckItemsEnum>;
    /**
     * 希望する説明方法（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    explanation_styles?: Array<InvestmentStyleDiagnosisAnswersExplanationStylesEnum>;
    /**
     * 面談で聞きたいこと（自由記述）
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    meeting_free_text?: string | null;
    /**
     * 不安要素：ローン負担
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    anxiety_loan?: InvestmentStyleDiagnosisAnswersAnxietyLoanEnum;
    /**
     * 不安要素：空室
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    anxiety_vacancy?: InvestmentStyleDiagnosisAnswersAnxietyVacancyEnum;
    /**
     * 不安要素：出口・売却
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    anxiety_exit?: InvestmentStyleDiagnosisAnswersAnxietyExitEnum;
    /**
     * 不安要素：修繕費
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    anxiety_repair?: InvestmentStyleDiagnosisAnswersAnxietyRepairEnum;
    /**
     * 不安要素：営業に流されること
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    anxiety_sales_pressure?: InvestmentStyleDiagnosisAnswersAnxietySalesPressureEnum;
    /**
     * 避けたい営業スタイル（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    avoid_sales_styles?: Array<InvestmentStyleDiagnosisAnswersAvoidSalesStylesEnum>;
    /**
     * 家賃収入の使いみち。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    rental_income_use?: InvestmentStyleDiagnosisAnswersRentalIncomeUseEnum;
    /**
     * 働き方の見通し。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnswers
     */
    work_outlook?: InvestmentStyleDiagnosisAnswersWorkOutlookEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersPurposesEnum {
    RetirementIncome = 'retirement_income',
    InflationHedge = 'inflation_hedge',
    LifeInsurance = 'life_insurance',
    TaxSaving = 'tax_saving',
    SideIncome = 'side_income',
    ShortTermGain = 'short_term_gain'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersPrimaryPurposeEnum {
    RetirementIncome = 'retirement_income',
    InflationHedge = 'inflation_hedge',
    LifeInsurance = 'life_insurance',
    TaxSaving = 'tax_saving',
    SideIncome = 'side_income',
    ShortTermGain = 'short_term_gain'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersTargetMonthlyIncomeEnum {
    Plus30k = 'plus_30k',
    Plus50k = 'plus_50k',
    Plus100k = 'plus_100k',
    Plus150kOrMore = 'plus_150k_or_more',
    Undecided = 'undecided'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersInterest1stEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersInterest2ndEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersInterest3rdEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersSuccessConditionsEnum {
    RetirementMonthly = 'retirement_monthly',
    DebtFreeAsset = 'debt_free_asset',
    AvoidBigLoss = 'avoid_big_loss',
    AbleToExpand = 'able_to_expand',
    TaxAchieved = 'tax_achieved'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersMonthlyOutOfPocketEnum {
    NearZero = 'near_zero',
    Within5k = 'within_5k',
    Within10k = 'within_10k',
    Within30k = 'within_30k',
    Within50k = 'within_50k',
    Over50k = 'over_50k'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersBorrowingStanceEnum {
    StartSmallFirstLoan = 'start_small_first_loan',
    OkIfRentCovers = 'ok_if_rent_covers',
    AnxiousWithMortgage = 'anxious_with_mortgage',
    StartBigIfPossible = 'start_big_if_possible',
    UnsureEligibility = 'unsure_eligibility'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersHoldingPeriodEnum {
    Within5y = 'within_5y',
    About10y = 'about_10y',
    About20y = 'about_20y',
    About30y = 'about_30y',
    AfterPayoff = 'after_payoff'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersManagementStyleEnum {
    FullyDelegated = 'fully_delegated',
    DelegatedWithReport = 'delegated_with_report',
    KeyDecisionsOnly = 'key_decisions_only',
    SelfDirected = 'self_directed',
    ActiveLandlord = 'active_landlord'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersShortTermSaleIntentEnum {
    Yes = 'yes',
    Conditional = 'conditional',
    No = 'no',
    Neutral = 'neutral'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersFirstPurchaseTimingEnum {
    Within1m = 'within_1m',
    Within3m = 'within_3m',
    Within6m = 'within_6m',
    Within1y = 'within_1y',
    ConsultPlanner = 'consult_planner'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersPlannerComparisonCountEnum {
    One = 'one',
    TwoToThree = 'two_to_three',
    FiveOrMore = 'five_or_more',
    TenOrMore = 'ten_or_more',
    ConsultPlanner = 'consult_planner'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersMeetingCheckItemsEnum {
    MonthlyRealCost = 'monthly_real_cost',
    VacancyCost = 'vacancy_cost',
    InterestRateRise = 'interest_rate_rise',
    RentDecline = 'rent_decline',
    RepairCost = 'repair_cost',
    SalePrice = 'sale_price',
    TaxEffect = 'tax_effect',
    UnfitCase = 'unfit_case',
    Comparison = 'comparison',
    LoanConsult = 'loan_consult',
    SupportDetail = 'support_detail'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersExplanationStylesEnum {
    BeginnerFriendly = 'beginner_friendly',
    WithNumbers = 'with_numbers',
    RiskFirst = 'risk_first',
    ProsCons = 'pros_cons',
    NoJargon = 'no_jargon',
    VsOtherInvestments = 'vs_other_investments',
    WithRationale = 'with_rationale',
    ConcisePoints = 'concise_points',
    OwnPace = 'own_pace',
    ProactiveSuggestion = 'proactive_suggestion'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersAnxietyLoanEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersAnxietyVacancyEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersAnxietyExitEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersAnxietyRepairEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersAnxietySalesPressureEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersAvoidSalesStylesEnum {
    Overpriced = 'overpriced',
    TaxOnly = 'tax_only',
    PushyImmediate = 'pushy_immediate',
    HighManagement = 'high_management',
    ExcessiveLoan = 'excessive_loan'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersRentalIncomeUseEnum {
    Savings = 'savings',
    LivingExpenses = 'living_expenses',
    LoanPrepayment = 'loan_prepayment',
    Family = 'family',
    NextProperty = 'next_property'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnswersWorkOutlookEnum {
    Until60 = 'until_60',
    Until65 = 'until_65',
    Until70 = 'until_70',
    AsLongAsAble = 'as_long_as_able',
    Undecided = 'undecided'
}

/**
 * 
 * @export
 * @interface InvestmentStyleDiagnosisAnxietyScore
 */
export interface InvestmentStyleDiagnosisAnxietyScore {
    /**
     * 
     * @type {string}
     * @memberof InvestmentStyleDiagnosisAnxietyScore
     */
    key?: InvestmentStyleDiagnosisAnxietyScoreKeyEnum;
    /**
     * 
     * @type {number}
     * @memberof InvestmentStyleDiagnosisAnxietyScore
     */
    score?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisAnxietyScoreKeyEnum {
    Loan = 'loan',
    Vacancy = 'vacancy',
    Exit = 'exit',
    Repair = 'repair',
    SalesPressure = 'sales_pressure'
}

/**
 * 
 * @export
 * @interface InvestmentStyleDiagnosisInterestScore
 */
export interface InvestmentStyleDiagnosisInterestScore {
    /**
     * 関心グラフの項目キー
     * @type {string}
     * @memberof InvestmentStyleDiagnosisInterestScore
     */
    key?: InvestmentStyleDiagnosisInterestScoreKeyEnum;
    /**
     * 
     * @type {number}
     * @memberof InvestmentStyleDiagnosisInterestScore
     */
    score?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisInterestScoreKeyEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}

/**
 * 面談で聞くと良い質問（1件）
 * @export
 * @interface InvestmentStyleDiagnosisMeetingQuestion
 */
export interface InvestmentStyleDiagnosisMeetingQuestion {
    /**
     * 質問テンプレートのキー
     * @type {string}
     * @memberof InvestmentStyleDiagnosisMeetingQuestion
     */
    key?: InvestmentStyleDiagnosisMeetingQuestionKeyEnum;
    /**
     * 本人が選択した項目か、不足分を補完した項目か
     * @type {string}
     * @memberof InvestmentStyleDiagnosisMeetingQuestion
     */
    source?: InvestmentStyleDiagnosisMeetingQuestionSourceEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisMeetingQuestionKeyEnum {
    MonthlyRealCost = 'monthly_real_cost',
    VacancyCost = 'vacancy_cost',
    InterestRateRise = 'interest_rate_rise',
    RentDecline = 'rent_decline',
    RepairCost = 'repair_cost',
    SalePrice = 'sale_price',
    TaxEffect = 'tax_effect',
    UnfitCase = 'unfit_case',
    Comparison = 'comparison',
    LoanConsult = 'loan_consult',
    SupportDetail = 'support_detail'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisMeetingQuestionSourceEnum {
    UserSelected = 'user_selected',
    AutoSafety = 'auto_safety'
}

/**
 * 認証済みプランナーに公開する診断回答。新設問は公開可否を確認して追加する。
 * @export
 * @interface InvestmentStyleDiagnosisPlannerAnswers
 */
export interface InvestmentStyleDiagnosisPlannerAnswers {
    /**
     * 投資目的（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    purposes?: Array<InvestmentStyleDiagnosisPlannerAnswersPurposesEnum>;
    /**
     * 最も重要な投資目的
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    primary_purpose?: InvestmentStyleDiagnosisPlannerAnswersPrimaryPurposeEnum;
    /**
     * 理想の状態（自由記述）。旧設問。現行の入力画面では target_monthly_income に置き換え、過去の回答のために残す
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    ideal_text?: string | null;
    /**
     * 将来の不動産収入（月額）。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    target_monthly_income?: InvestmentStyleDiagnosisPlannerAnswersTargetMonthlyIncomeEnum;
    /**
     * 関心事項1位
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    interest_1st?: InvestmentStyleDiagnosisPlannerAnswersInterest1stEnum;
    /**
     * 関心事項2位
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    interest_2nd?: InvestmentStyleDiagnosisPlannerAnswersInterest2ndEnum;
    /**
     * 関心事項3位
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    interest_3rd?: InvestmentStyleDiagnosisPlannerAnswersInterest3rdEnum;
    /**
     * 成功条件（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    success_conditions?: Array<InvestmentStyleDiagnosisPlannerAnswersSuccessConditionsEnum>;
    /**
     * 毎月の持ち出し許容額
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    monthly_out_of_pocket?: InvestmentStyleDiagnosisPlannerAnswersMonthlyOutOfPocketEnum;
    /**
     * 借入についての考え方。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    borrowing_stance?: InvestmentStyleDiagnosisPlannerAnswersBorrowingStanceEnum;
    /**
     * 保有期間の想定
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    holding_period?: InvestmentStyleDiagnosisPlannerAnswersHoldingPeriodEnum;
    /**
     * 立地⇔利回りの選好（1:立地重視〜5:利回り重視）
     * @type {number}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    location_yield_preference?: number;
    /**
     * 運用スタイル
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    management_style?: InvestmentStyleDiagnosisPlannerAnswersManagementStyleEnum;
    /**
     * 売却タイミングの考え方
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    short_term_sale_intent?: InvestmentStyleDiagnosisPlannerAnswersShortTermSaleIntentEnum;
    /**
     * 1件目の時期。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    first_purchase_timing?: InvestmentStyleDiagnosisPlannerAnswersFirstPurchaseTimingEnum;
    /**
     * 比べたいプランナーの人数。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    planner_comparison_count?: InvestmentStyleDiagnosisPlannerAnswersPlannerComparisonCountEnum;
    /**
     * 面談で確認したいこと（複数選択・配列順が選択順）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    meeting_check_items?: Array<InvestmentStyleDiagnosisPlannerAnswersMeetingCheckItemsEnum>;
    /**
     * 希望する説明方法（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    explanation_styles?: Array<InvestmentStyleDiagnosisPlannerAnswersExplanationStylesEnum>;
    /**
     * 面談で聞きたいこと（自由記述）
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    meeting_free_text?: string | null;
    /**
     * 不安要素：ローン負担
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    anxiety_loan?: InvestmentStyleDiagnosisPlannerAnswersAnxietyLoanEnum;
    /**
     * 不安要素：空室
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    anxiety_vacancy?: InvestmentStyleDiagnosisPlannerAnswersAnxietyVacancyEnum;
    /**
     * 不安要素：出口・売却
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    anxiety_exit?: InvestmentStyleDiagnosisPlannerAnswersAnxietyExitEnum;
    /**
     * 不安要素：修繕費
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    anxiety_repair?: InvestmentStyleDiagnosisPlannerAnswersAnxietyRepairEnum;
    /**
     * 不安要素：営業に流されること
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    anxiety_sales_pressure?: InvestmentStyleDiagnosisPlannerAnswersAnxietySalesPressureEnum;
    /**
     * 避けたい営業スタイル（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisPlannerAnswers
     */
    avoid_sales_styles?: Array<InvestmentStyleDiagnosisPlannerAnswersAvoidSalesStylesEnum>;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersPurposesEnum {
    RetirementIncome = 'retirement_income',
    InflationHedge = 'inflation_hedge',
    LifeInsurance = 'life_insurance',
    TaxSaving = 'tax_saving',
    SideIncome = 'side_income',
    ShortTermGain = 'short_term_gain'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersPrimaryPurposeEnum {
    RetirementIncome = 'retirement_income',
    InflationHedge = 'inflation_hedge',
    LifeInsurance = 'life_insurance',
    TaxSaving = 'tax_saving',
    SideIncome = 'side_income',
    ShortTermGain = 'short_term_gain'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersTargetMonthlyIncomeEnum {
    Plus30k = 'plus_30k',
    Plus50k = 'plus_50k',
    Plus100k = 'plus_100k',
    Plus150kOrMore = 'plus_150k_or_more',
    Undecided = 'undecided'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersInterest1stEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersInterest2ndEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersInterest3rdEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersSuccessConditionsEnum {
    RetirementMonthly = 'retirement_monthly',
    DebtFreeAsset = 'debt_free_asset',
    AvoidBigLoss = 'avoid_big_loss',
    AbleToExpand = 'able_to_expand',
    TaxAchieved = 'tax_achieved'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersMonthlyOutOfPocketEnum {
    NearZero = 'near_zero',
    Within5k = 'within_5k',
    Within10k = 'within_10k',
    Within30k = 'within_30k',
    Within50k = 'within_50k',
    Over50k = 'over_50k'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersBorrowingStanceEnum {
    StartSmallFirstLoan = 'start_small_first_loan',
    OkIfRentCovers = 'ok_if_rent_covers',
    AnxiousWithMortgage = 'anxious_with_mortgage',
    StartBigIfPossible = 'start_big_if_possible',
    UnsureEligibility = 'unsure_eligibility'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersHoldingPeriodEnum {
    Within5y = 'within_5y',
    About10y = 'about_10y',
    About20y = 'about_20y',
    About30y = 'about_30y',
    AfterPayoff = 'after_payoff'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersManagementStyleEnum {
    FullyDelegated = 'fully_delegated',
    DelegatedWithReport = 'delegated_with_report',
    KeyDecisionsOnly = 'key_decisions_only',
    SelfDirected = 'self_directed',
    ActiveLandlord = 'active_landlord'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersShortTermSaleIntentEnum {
    Yes = 'yes',
    Conditional = 'conditional',
    No = 'no',
    Neutral = 'neutral'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersFirstPurchaseTimingEnum {
    Within1m = 'within_1m',
    Within3m = 'within_3m',
    Within6m = 'within_6m',
    Within1y = 'within_1y',
    ConsultPlanner = 'consult_planner'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersPlannerComparisonCountEnum {
    One = 'one',
    TwoToThree = 'two_to_three',
    FiveOrMore = 'five_or_more',
    TenOrMore = 'ten_or_more',
    ConsultPlanner = 'consult_planner'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersMeetingCheckItemsEnum {
    MonthlyRealCost = 'monthly_real_cost',
    VacancyCost = 'vacancy_cost',
    InterestRateRise = 'interest_rate_rise',
    RentDecline = 'rent_decline',
    RepairCost = 'repair_cost',
    SalePrice = 'sale_price',
    TaxEffect = 'tax_effect',
    UnfitCase = 'unfit_case',
    Comparison = 'comparison',
    LoanConsult = 'loan_consult',
    SupportDetail = 'support_detail'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersExplanationStylesEnum {
    BeginnerFriendly = 'beginner_friendly',
    WithNumbers = 'with_numbers',
    RiskFirst = 'risk_first',
    ProsCons = 'pros_cons',
    NoJargon = 'no_jargon',
    VsOtherInvestments = 'vs_other_investments',
    WithRationale = 'with_rationale',
    ConcisePoints = 'concise_points',
    OwnPace = 'own_pace',
    ProactiveSuggestion = 'proactive_suggestion'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersAnxietyLoanEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersAnxietyVacancyEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersAnxietyExitEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersAnxietyRepairEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersAnxietySalesPressureEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPlannerAnswersAvoidSalesStylesEnum {
    Overpriced = 'overpriced',
    TaxOnly = 'tax_only',
    PushyImmediate = 'pushy_immediate',
    HighManagement = 'high_management',
    ExcessiveLoan = 'excessive_loan'
}

/**
 * 本人・管理者だけが扱う生活設計の回答。agent向けモデルには合成しない。
 * @export
 * @interface InvestmentStyleDiagnosisPrivateAnswers
 */
export interface InvestmentStyleDiagnosisPrivateAnswers {
    /**
     * 家賃収入の使いみち。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPrivateAnswers
     */
    rental_income_use?: InvestmentStyleDiagnosisPrivateAnswersRentalIncomeUseEnum;
    /**
     * 働き方の見通し。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisPrivateAnswers
     */
    work_outlook?: InvestmentStyleDiagnosisPrivateAnswersWorkOutlookEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPrivateAnswersRentalIncomeUseEnum {
    Savings = 'savings',
    LivingExpenses = 'living_expenses',
    LoanPrepayment = 'loan_prepayment',
    Family = 'family',
    NextProperty = 'next_property'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisPrivateAnswersWorkOutlookEnum {
    Until60 = 'until_60',
    Until65 = 'until_65',
    Until70 = 'until_70',
    AsLongAsAble = 'as_long_as_able',
    Undecided = 'undecided'
}

/**
 * 
 * @export
 * @interface InvestmentStyleDiagnosisRequest
 */
export interface InvestmentStyleDiagnosisRequest {
    /**
     * 投資目的（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    purposes: Array<InvestmentStyleDiagnosisRequestPurposesEnum>;
    /**
     * 最も重要な投資目的
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    primary_purpose: InvestmentStyleDiagnosisRequestPrimaryPurposeEnum;
    /**
     * 理想の状態（自由記述）。旧設問。現行の入力画面では target_monthly_income に置き換え、過去の回答のために残す
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    ideal_text?: string | null;
    /**
     * 将来の不動産収入（月額）。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    target_monthly_income?: InvestmentStyleDiagnosisRequestTargetMonthlyIncomeEnum;
    /**
     * 関心事項1位
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    interest_1st: InvestmentStyleDiagnosisRequestInterest1stEnum;
    /**
     * 関心事項2位
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    interest_2nd?: InvestmentStyleDiagnosisRequestInterest2ndEnum;
    /**
     * 関心事項3位
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    interest_3rd?: InvestmentStyleDiagnosisRequestInterest3rdEnum;
    /**
     * 成功条件（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    success_conditions: Array<InvestmentStyleDiagnosisRequestSuccessConditionsEnum>;
    /**
     * 毎月の持ち出し許容額
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    monthly_out_of_pocket: InvestmentStyleDiagnosisRequestMonthlyOutOfPocketEnum;
    /**
     * 借入についての考え方。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    borrowing_stance?: InvestmentStyleDiagnosisRequestBorrowingStanceEnum;
    /**
     * 保有期間の想定
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    holding_period: InvestmentStyleDiagnosisRequestHoldingPeriodEnum;
    /**
     * 立地⇔利回りの選好（1:立地重視〜5:利回り重視）
     * @type {number}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    location_yield_preference: number;
    /**
     * 運用スタイル
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    management_style: InvestmentStyleDiagnosisRequestManagementStyleEnum;
    /**
     * 売却タイミングの考え方
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    short_term_sale_intent: InvestmentStyleDiagnosisRequestShortTermSaleIntentEnum;
    /**
     * 1件目の時期。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    first_purchase_timing?: InvestmentStyleDiagnosisRequestFirstPurchaseTimingEnum;
    /**
     * 比べたいプランナーの人数。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    planner_comparison_count?: InvestmentStyleDiagnosisRequestPlannerComparisonCountEnum;
    /**
     * 面談で確認したいこと（複数選択・配列順が選択順）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    meeting_check_items: Array<InvestmentStyleDiagnosisRequestMeetingCheckItemsEnum>;
    /**
     * 希望する説明方法（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    explanation_styles: Array<InvestmentStyleDiagnosisRequestExplanationStylesEnum>;
    /**
     * 面談で聞きたいこと（自由記述）
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    meeting_free_text?: string | null;
    /**
     * 不安要素：ローン負担
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    anxiety_loan: InvestmentStyleDiagnosisRequestAnxietyLoanEnum;
    /**
     * 不安要素：空室
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    anxiety_vacancy: InvestmentStyleDiagnosisRequestAnxietyVacancyEnum;
    /**
     * 不安要素：出口・売却
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    anxiety_exit: InvestmentStyleDiagnosisRequestAnxietyExitEnum;
    /**
     * 不安要素：修繕費
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    anxiety_repair: InvestmentStyleDiagnosisRequestAnxietyRepairEnum;
    /**
     * 不安要素：営業に流されること
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    anxiety_sales_pressure: InvestmentStyleDiagnosisRequestAnxietySalesPressureEnum;
    /**
     * 避けたい営業スタイル（複数選択）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    avoid_sales_styles: Array<InvestmentStyleDiagnosisRequestAvoidSalesStylesEnum>;
    /**
     * 家賃収入の使いみち。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    rental_income_use?: InvestmentStyleDiagnosisRequestRentalIncomeUseEnum;
    /**
     * 働き方の見通し。旧アプリからの回答・既存データは null
     * @type {string}
     * @memberof InvestmentStyleDiagnosisRequest
     */
    work_outlook?: InvestmentStyleDiagnosisRequestWorkOutlookEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestPurposesEnum {
    RetirementIncome = 'retirement_income',
    InflationHedge = 'inflation_hedge',
    LifeInsurance = 'life_insurance',
    TaxSaving = 'tax_saving',
    SideIncome = 'side_income',
    ShortTermGain = 'short_term_gain'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestPrimaryPurposeEnum {
    RetirementIncome = 'retirement_income',
    InflationHedge = 'inflation_hedge',
    LifeInsurance = 'life_insurance',
    TaxSaving = 'tax_saving',
    SideIncome = 'side_income',
    ShortTermGain = 'short_term_gain'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestTargetMonthlyIncomeEnum {
    Plus30k = 'plus_30k',
    Plus50k = 'plus_50k',
    Plus100k = 'plus_100k',
    Plus150kOrMore = 'plus_150k_or_more',
    Undecided = 'undecided'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestInterest1stEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestInterest2ndEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestInterest3rdEnum {
    StableIncome = 'stable_income',
    LongTermAsset = 'long_term_asset',
    LowEffort = 'low_effort',
    HighYield = 'high_yield',
    ShortTermGain = 'short_term_gain',
    TaxSaving = 'tax_saving',
    LossAvoidanceSafety = 'loss_avoidance_safety',
    LossAvoidanceLowInitial = 'loss_avoidance_low_initial',
    LossAvoidanceTrusted = 'loss_avoidance_trusted'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestSuccessConditionsEnum {
    RetirementMonthly = 'retirement_monthly',
    DebtFreeAsset = 'debt_free_asset',
    AvoidBigLoss = 'avoid_big_loss',
    AbleToExpand = 'able_to_expand',
    TaxAchieved = 'tax_achieved'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestMonthlyOutOfPocketEnum {
    NearZero = 'near_zero',
    Within5k = 'within_5k',
    Within10k = 'within_10k',
    Within30k = 'within_30k',
    Within50k = 'within_50k',
    Over50k = 'over_50k'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestBorrowingStanceEnum {
    StartSmallFirstLoan = 'start_small_first_loan',
    OkIfRentCovers = 'ok_if_rent_covers',
    AnxiousWithMortgage = 'anxious_with_mortgage',
    StartBigIfPossible = 'start_big_if_possible',
    UnsureEligibility = 'unsure_eligibility'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestHoldingPeriodEnum {
    Within5y = 'within_5y',
    About10y = 'about_10y',
    About20y = 'about_20y',
    About30y = 'about_30y',
    AfterPayoff = 'after_payoff'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestManagementStyleEnum {
    FullyDelegated = 'fully_delegated',
    DelegatedWithReport = 'delegated_with_report',
    KeyDecisionsOnly = 'key_decisions_only',
    SelfDirected = 'self_directed',
    ActiveLandlord = 'active_landlord'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestShortTermSaleIntentEnum {
    Yes = 'yes',
    Conditional = 'conditional',
    No = 'no',
    Neutral = 'neutral'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestFirstPurchaseTimingEnum {
    Within1m = 'within_1m',
    Within3m = 'within_3m',
    Within6m = 'within_6m',
    Within1y = 'within_1y',
    ConsultPlanner = 'consult_planner'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestPlannerComparisonCountEnum {
    One = 'one',
    TwoToThree = 'two_to_three',
    FiveOrMore = 'five_or_more',
    TenOrMore = 'ten_or_more',
    ConsultPlanner = 'consult_planner'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestMeetingCheckItemsEnum {
    MonthlyRealCost = 'monthly_real_cost',
    VacancyCost = 'vacancy_cost',
    InterestRateRise = 'interest_rate_rise',
    RentDecline = 'rent_decline',
    RepairCost = 'repair_cost',
    SalePrice = 'sale_price',
    TaxEffect = 'tax_effect',
    UnfitCase = 'unfit_case',
    Comparison = 'comparison',
    LoanConsult = 'loan_consult',
    SupportDetail = 'support_detail'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestExplanationStylesEnum {
    BeginnerFriendly = 'beginner_friendly',
    WithNumbers = 'with_numbers',
    RiskFirst = 'risk_first',
    ProsCons = 'pros_cons',
    NoJargon = 'no_jargon',
    VsOtherInvestments = 'vs_other_investments',
    WithRationale = 'with_rationale',
    ConcisePoints = 'concise_points',
    OwnPace = 'own_pace',
    ProactiveSuggestion = 'proactive_suggestion'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestAnxietyLoanEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestAnxietyVacancyEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestAnxietyExitEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestAnxietyRepairEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestAnxietySalesPressureEnum {
    Strong = 'strong',
    Normal = 'normal',
    Weak = 'weak'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestAvoidSalesStylesEnum {
    Overpriced = 'overpriced',
    TaxOnly = 'tax_only',
    PushyImmediate = 'pushy_immediate',
    HighManagement = 'high_management',
    ExcessiveLoan = 'excessive_loan'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestRentalIncomeUseEnum {
    Savings = 'savings',
    LivingExpenses = 'living_expenses',
    LoanPrepayment = 'loan_prepayment',
    Family = 'family',
    NextProperty = 'next_property'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisRequestWorkOutlookEnum {
    Until60 = 'until_60',
    Until65 = 'until_65',
    Until70 = 'until_70',
    AsLongAsAble = 'as_long_as_able',
    Undecided = 'undecided'
}

/**
 * 各閲覧先で共通の診断結果・ID・作成日時。
 * @export
 * @interface InvestmentStyleDiagnosisResult
 */
export interface InvestmentStyleDiagnosisResult {
    /**
     * 
     * @type {number}
     * @memberof InvestmentStyleDiagnosisResult
     */
    id?: number;
    /**
     * お客様タイプ
     * @type {string}
     * @memberof InvestmentStyleDiagnosisResult
     */
    customer_type?: InvestmentStyleDiagnosisResultCustomerTypeEnum;
    /**
     * 診断から導出した中心的な投資目的
     * @type {string}
     * @memberof InvestmentStyleDiagnosisResult
     */
    core_goal?: InvestmentStyleDiagnosisResultCoreGoalEnum;
    /**
     * 関心グラフ（スコア降順）
     * @type {Array<InvestmentStyleDiagnosisInterestScore>}
     * @memberof InvestmentStyleDiagnosisResult
     */
    interest_scores?: Array<InvestmentStyleDiagnosisInterestScore>;
    /**
     * 向いているアセット（おすすめ順）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisResult
     */
    suited_assets?: Array<InvestmentStyleDiagnosisResultSuitedAssetsEnum>;
    /**
     * 面談で聞くと良い質問（最大5件・表示順）
     * @type {Array<InvestmentStyleDiagnosisMeetingQuestion>}
     * @memberof InvestmentStyleDiagnosisResult
     */
    meeting_questions?: Array<InvestmentStyleDiagnosisMeetingQuestion>;
    /**
     * 不安項目（降順）
     * @type {Array<InvestmentStyleDiagnosisAnxietyScore>}
     * @memberof InvestmentStyleDiagnosisResult
     */
    anxiety_scores?: Array<InvestmentStyleDiagnosisAnxietyScore>;
    /**
     * 避けるべき進め方の警告（重要度順・最大2件）
     * @type {Array<string>}
     * @memberof InvestmentStyleDiagnosisResult
     */
    avoid_sales_style_warnings?: Array<InvestmentStyleDiagnosisResultAvoidSalesStyleWarningsEnum>;
    /**
     * 安全装置フラグ（強い不安が3つ以上）
     * @type {boolean}
     * @memberof InvestmentStyleDiagnosisResult
     */
    needs_safety_content?: boolean;
    /**
     * 診断完了日時（作成日時）
     * @type {string}
     * @memberof InvestmentStyleDiagnosisResult
     */
    created_at?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisResultCustomerTypeEnum {
    ShortTermGain = 'short_term_gain',
    LongTermHold = 'long_term_hold',
    LocationFocused = 'location_focused',
    YieldFocused = 'yield_focused'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisResultCoreGoalEnum {
    RetirementIncome = 'retirement_income',
    LongTermAsset = 'long_term_asset',
    FamilyProtection = 'family_protection',
    SideIncome = 'side_income',
    LowEffort = 'low_effort',
    YieldImprovement = 'yield_improvement',
    LossAvoidance = 'loss_avoidance',
    ShortTermGain = 'short_term_gain'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisResultSuitedAssetsEnum {
    UrbanUsedKubun = 'urban_used_kubun',
    NewKubun = 'new_kubun',
    RenovatedKubun = 'renovated_kubun',
    UrbanOldIttou = 'urban_old_ittou',
    UrbanNewIttou = 'urban_new_ittou',
    RuralOldIttou = 'rural_old_ittou',
    RuralNewIttou = 'rural_new_ittou'
}
/**
    * @export
    * @enum {string}
    */
export enum InvestmentStyleDiagnosisResultAvoidSalesStyleWarningsEnum {
    Overpriced = 'overpriced',
    TaxOnly = 'tax_only',
    PushyImmediate = 'pushy_immediate',
    HighManagement = 'high_management',
    ExcessiveLoan = 'excessive_loan'
}

/**
 * 職業
 * @export
 * @enum {string}
 */
export enum JobCategory {
    会社員上場 = '会社員（上場）',
    会社員非上場 = '会社員（非上場）',
    会社員外資系企業 = '会社員（外資系企業）',
    会社役員 = '会社役員',
    公務員 = '公務員',
    士業 = '士業',
    医師歯科医師 = '医師・歯科医師',
    薬剤師看護師 = '薬剤師・看護師',
    自営業 = '自営業',
    その他 = 'その他',
    入力なし = '入力なし'
}

/**
 * 業界
 * @export
 * @enum {string}
 */
export enum JobIndustry {
    It通信系 = 'IT・通信系',
    サービス系 = 'サービス系',
    メーカー系電気機械 = 'メーカー系(電気・機械)',
    メーカー系素材医薬品他 = 'メーカー系(素材・医薬品他)',
    メーカー系自動車輸送用機器 = 'メーカー系(自動車・輸送用機器)',
    専門コンサル系 = '専門コンサル系',
    商社系電気機械系 = '商社系(電気・機械系)',
    商社系総合素材医薬品他 = '商社系(総合・素材・医薬品他)',
    金融系 = '金融系',
    不動産系 = '不動産系',
    建設系 = '建設系',
    マスコミ系 = 'マスコミ系',
    流通小売系 = '流通・小売系',
    インターネットWeb業界 = 'インターネット・Web業界',
    ゲーム業界 = 'ゲーム業界',
    広告マーケティング系 = '広告・マーケティング系',
    教育学校系 = '教育・学校系',
    医療福祉系 = '医療・福祉系',
    エネルギー環境系 = 'エネルギー・環境系',
    官公庁公共サービス系 = '官公庁・公共サービス系',
    運輸物流倉庫系 = '運輸・物流・倉庫系',
    飲食フード系 = '飲食・フード系',
    その他 = 'その他'
}

/**
 * 
 * @export
 * @interface LearningArticleStatus
 */
export interface LearningArticleStatus {
    /**
     * 
     * @type {string}
     * @memberof LearningArticleStatus
     */
    article_id?: string;
    /**
     * 
     * @type {string}
     * @memberof LearningArticleStatus
     */
    completed_at?: string | null;
}
/**
 * 
 * @export
 * @interface LeaseContract
 */
export interface LeaseContract {
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    property_id?: number;
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    monthly_fee: number;
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    monthly_management_fee: number;
    /**
     * その他収入（月額）
     * @type {number}
     * @memberof LeaseContract
     */
    other_monthly_income?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    starts_at: string;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    ends_at: string;
    /**
     * 新規賃貸契約手数料 (賃料のN倍)
     * @type {number}
     * @memberof LeaseContract
     */
    outsourcing_fee_rate_of_new_lease_contract?: number | null;
    /**
     * 賃貸契約更新手数料（賃料のN倍)
     * @type {number}
     * @memberof LeaseContract
     */
    outsourcing_fee_rate_of_updating_lease_contract?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    key_money?: number | null;
    /**
     * 
     * @type {number}
     * @memberof LeaseContract
     */
    security_deposit?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    type_of_the_income_of_the_beginning_of_contract?: LeaseContractTypeOfTheIncomeOfTheBeginningOfContractEnum;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof LeaseContract
     */
    discarded_at?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum LeaseContractTypeOfTheIncomeOfTheBeginningOfContractEnum {
    KeyMoney = 'KeyMoney',
    SecurityDeposit = 'SecurityDeposit'
}

/**
 * 
 * @export
 * @interface LimitedProperties
 */
export interface LimitedProperties {
    /**
     * 
     * @type {number}
     * @memberof LimitedProperties
     */
    agent_id?: number;
    /**
     * 
     * @type {string}
     * @memberof LimitedProperties
     */
    property_name?: string;
    /**
     * 
     * @type {string}
     * @memberof LimitedProperties
     */
    property_area?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LimitedProperties
     */
    property_price?: number;
    /**
     * 
     * @type {number}
     * @memberof LimitedProperties
     */
    property_monthly_rent?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LimitedProperties
     */
    property_nearest_station?: string | null;
    /**
     * 
     * @type {number}
     * @memberof LimitedProperties
     */
    property_building_age?: number | null;
    /**
     * 
     * @type {string}
     * @memberof LimitedProperties
     */
    file_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LimitedProperties
     */
    object_storage_path?: string | null;
}
/**
 * 
 * @export
 * @interface LoanHistoryError
 */
export interface LoanHistoryError {
    /**
     * 
     * @type {string}
     * @memberof LoanHistoryError
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof LoanHistoryError
     */
    reason?: LoanHistoryErrorReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof LoanHistoryError
     */
    message?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum LoanHistoryErrorReasonEnum {
    InvalidHistory = 'invalid_history',
    RepaymentBeforePurchase = 'repayment_before_purchase',
    MissingInitialRate = 'missing_initial_rate',
    InvalidPaymentPeriod = 'invalid_payment_period'
}

/**
 * 
 * @export
 * @interface LoanInterestRateUpdate
 */
export interface LoanInterestRateUpdate {
    /**
     * 
     * @type {string}
     * @memberof LoanInterestRateUpdate
     */
    operation: LoanInterestRateUpdateOperationEnum;
    /**
     * 適用開始月（月初）。削除の場合は削除対象月。
     * @type {string}
     * @memberof LoanInterestRateUpdate
     */
    month: string;
    /**
     * 訂正時に必須の元の適用開始月（月初）。
     * @type {string}
     * @memberof LoanInterestRateUpdate
     */
    original_month?: string;
    /**
     * 登録・訂正時に必須の年利（%）。0%も有効。
     * @type {number}
     * @memberof LoanInterestRateUpdate
     */
    loan_interest_rate_percentage?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum LoanInterestRateUpdateOperationEnum {
    Register = 'register',
    Correct = 'correct',
    Delete = 'delete'
}

/**
 * マスタテーブル全般用の汎用schema型
 * @export
 * @interface Master
 */
export interface Master {
    /**
     * 
     * @type {number}
     * @memberof Master
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Master
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof Master
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof Master
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Master
     */
    updated_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Master
     */
    is_active?: boolean | null;
}
/**
 * 
 * @export
 * @interface MasterAgentSearchTag
 */
export interface MasterAgentSearchTag {
    /**
     * 
     * @type {number}
     * @memberof MasterAgentSearchTag
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MasterAgentSearchTag
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof MasterAgentSearchTag
     */
    order?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum MatchingType {
    投資 = '投資',
    査定 = '査定',
    手動 = '手動',
    ユーザ = 'ユーザ'
}

/**
 * 金融資産
 * @export
 * @enum {string}
 */
export enum MoneyAmount {
    未選択 = '未選択',
    なし = 'なし',
    _500万円 = '〜500万円',
    _5001000万円 = '500〜1,000万円',
    _10002000万円 = '1,000〜2,000万円',
    _20003000万円 = '2,000〜3,000万円',
    _30005000万円 = '3,000〜5,000万円',
    _5000万円1億円 = '5,000万円〜1億円',
    _12億円 = '1〜2億円',
    _23億円 = '2〜3億円',
    _35億円 = '3〜5億円',
    _510億円 = '5〜10億円',
    _10億円 = '10億円〜'
}

/**
 * 
 * @export
 * @interface MonthlyCashflowResult
 */
export interface MonthlyCashflowResult {
    /**
     * 
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    property_id?: number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    month?: string;
    /**
     * 賃料収入
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    rent_income?: number | null;
    /**
     * 管理費収入
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    management_fee_income?: number | null;
    /**
     * 通信費
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    communication_cost?: number | null;
    /**
     * 賃貸管理費
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    management_cost?: number | null;
    /**
     * 物件管理費
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    building_management_cost?: number | null;
    /**
     * 修繕積立金
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    repair_fund_cost?: number | null;
    /**
     * その他経費（毎月発生するもの)
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    misc_cost?: number | null;
    /**
     * ローン支払い（金利分）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    loan_interest?: number | null;
    /**
     * ローン利率（当月からの）（％）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    loan_interest_rate_percentage?: number | null;
    /**
     * ローン支払い（元金分）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    loan_principal?: number | null;
    /**
     * ローン支払い（元金に対する繰上返済）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    loan_prepayment?: number | null;
    /**
     * ローン支払い（元金に対する繰上返済方式） * ReduceLoanAmount: 返済額軽減型 * ReduceLoanPaymentPeriod: 期間短縮型 
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    loan_prepayment_method?: MonthlyCashflowResultLoanPrepaymentMethodEnum;
    /**
     * 礼金
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    key_money?: number | null;
    /**
     * 更新料
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    security_deposit?: number | null;
    /**
     * 固定資産税
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    property_tax?: number | null;
    /**
     * 火災保険料
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    fire_insurance_cost?: number | null;
    /**
     * 火災保険料保有期間
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    fire_insurance_holding_period?: number | null;
    /**
     * 地震保険料
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    earthquake_insurance_cost?: number | null;
    /**
     * 地震保険料保有期間
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    earthquake_insurance_holding_period?: number | null;
    /**
     * 大規模修繕費用
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    large_scale_repair_fund_cost?: number | null;
    /**
     * 消耗品費
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    supplies_cost?: number | null;
    /**
     * その他一過性の費用
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    misc_onetime_cost?: number | null;
    /**
     * その他一過性の費用(内容)
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    misc_onetime_cost_contents?: string | null;
    /**
     * 不動産所得にかかる税金
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    tax_on_real_estates?: number | null;
    /**
     * 新規賃貸契約手数料（金額）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    outsourcing_fee_of_new_lease_contract?: number | null;
    /**
     * 賃貸契約更新手数料（金額）
     * @type {number}
     * @memberof MonthlyCashflowResult
     */
    outsourcing_fee_of_updating_lease_contract?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResult
     */
    discarded_at?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum MonthlyCashflowResultLoanPrepaymentMethodEnum {
    ReduceLoanAmount = 'ReduceLoanAmount',
    ReduceLoanPaymentPeriod = 'ReduceLoanPaymentPeriod'
}

/**
 * 各項目ごとの合計
 * @export
 * @interface MonthlyCashflowResultSumByItem
 */
export interface MonthlyCashflowResultSumByItem {
    /**
     * 
     * @type {number}
     * @memberof MonthlyCashflowResultSumByItem
     */
    property_tax_sum: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyCashflowResultSumByItem
     */
    large_scale_repair_fund_cost_sum: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyCashflowResultSumByItem
     */
    misc_onetime_cost_sum: number;
}
/**
 * 
 * @export
 * @interface MonthlyCashflowResultUpdate
 */
export interface MonthlyCashflowResultUpdate {
    /**
     * 
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    property_id?: number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResultUpdate
     */
    month: string;
    /**
     * 賃料収入
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    rent_income?: number | null;
    /**
     * 管理費収入
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    management_fee_income?: number | null;
    /**
     * 通信費
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    communication_cost?: number | null;
    /**
     * 賃貸管理費
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    management_cost?: number | null;
    /**
     * 物件管理費
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    building_management_cost?: number | null;
    /**
     * 修繕積立金
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    repair_fund_cost?: number | null;
    /**
     * その他経費（毎月発生するもの)
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    misc_cost?: number | null;
    /**
     * ローン支払い（金利分）
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    loan_interest?: number | null;
    /**
     * ローン利率（当月からの）（％）
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    loan_interest_rate_percentage?: number | null;
    /**
     * ローン支払い（元金分）
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    loan_principal?: number | null;
    /**
     * ローン支払い（元金に対する繰上返済）
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    loan_prepayment?: number | null;
    /**
     * ローン支払い（元金に対する繰上返済方式） * ReduceLoanAmount: 返済額軽減型 * ReduceLoanPaymentPeriod: 期間短縮型 
     * @type {string}
     * @memberof MonthlyCashflowResultUpdate
     */
    loan_prepayment_method?: MonthlyCashflowResultUpdateLoanPrepaymentMethodEnum;
    /**
     * 礼金
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    key_money?: number | null;
    /**
     * 更新料
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    security_deposit?: number | null;
    /**
     * 固定資産税
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    property_tax?: number | null;
    /**
     * 火災保険料
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    fire_insurance_cost?: number | null;
    /**
     * 火災保険料保有期間
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    fire_insurance_holding_period?: number | null;
    /**
     * 地震保険料
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    earthquake_insurance_cost?: number | null;
    /**
     * 地震保険料保有期間
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    earthquake_insurance_holding_period?: number | null;
    /**
     * 大規模修繕費用
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    large_scale_repair_fund_cost?: number | null;
    /**
     * 消耗品費
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    supplies_cost?: number | null;
    /**
     * その他一過性の費用
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    misc_onetime_cost?: number | null;
    /**
     * その他一過性の費用(内容)
     * @type {string}
     * @memberof MonthlyCashflowResultUpdate
     */
    misc_onetime_cost_contents?: string | null;
    /**
     * 不動産所得にかかる税金
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    tax_on_real_estates?: number | null;
    /**
     * 新規賃貸契約手数料（金額）
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    outsourcing_fee_of_new_lease_contract?: number | null;
    /**
     * 賃貸契約更新手数料（金額）
     * @type {number}
     * @memberof MonthlyCashflowResultUpdate
     */
    outsourcing_fee_of_updating_lease_contract?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResultUpdate
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResultUpdate
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyCashflowResultUpdate
     */
    discarded_at?: string | null;
}

/**
    * @export
    * @enum {string}
    */
export enum MonthlyCashflowResultUpdateLoanPrepaymentMethodEnum {
    ReduceLoanAmount = 'ReduceLoanAmount',
    ReduceLoanPaymentPeriod = 'ReduceLoanPaymentPeriod'
}

/**
 * 
 * @export
 * @interface MsinsLeadEntry
 */
export interface MsinsLeadEntry {
    /**
     * リード獲得の種類
     * @type {string}
     * @memberof MsinsLeadEntry
     */
    source: MsinsLeadEntrySourceEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum MsinsLeadEntrySourceEnum {
    保有者向けバナー = '保有者向けバナー',
    検討者向けバナー = '検討者向けバナー',
    興味を持って登録 = '興味を持って登録'
}

/**
 * 
 * @export
 * @interface OfferScore
 */
export interface OfferScore {
    /**
     * 
     * @type {number}
     * @memberof OfferScore
     */
    id?: number;
    /**
     * ユーザーが提案を閲覧する推定確率
     * @type {number}
     * @memberof OfferScore
     */
    read_probability?: number;
    /**
     * ユーザーが提案を承認・マッチする推定確率
     * @type {number}
     * @memberof OfferScore
     */
    match_probability?: number;
    /**
     * 表示や並び替えに利用する総合スコア
     * @type {number}
     * @memberof OfferScore
     */
    score?: number;
    /**
     * スコア算出に利用したモデルバージョン
     * @type {string}
     * @memberof OfferScore
     */
    model_version?: string;
    /**
     * スコア算出日時
     * @type {string}
     * @memberof OfferScore
     */
    scored_at?: string;
    /**
     * スコア算出時に利用した特徴量
     * @type {object}
     * @memberof OfferScore
     */
    features?: object | null;
}
/**
 * エージェント一覧のページングレスポンス。現状はuser v1系とadmin v1系で同じschemaを共有しているため、 user v1系の page/total と admin v1系の current_page/total_count をどちらも許容している。 将来的にはUserPaginatedAgentsResponseとAdminPaginatedAgentsResponseに分離、またはレスポンスキーを統一する。 
 * @export
 * @interface PaginatedAgentsResponse
 */
export interface PaginatedAgentsResponse {
    /**
     * 全エージェント数（user v1系）
     * @type {number}
     * @memberof PaginatedAgentsResponse
     */
    total?: number;
    /**
     * 全エージェント数（admin v1系）
     * @type {number}
     * @memberof PaginatedAgentsResponse
     */
    total_count?: number;
    /**
     * 現在のページ（user v1系）
     * @type {number}
     * @memberof PaginatedAgentsResponse
     */
    page?: number;
    /**
     * 現在のページ（admin v1系）
     * @type {number}
     * @memberof PaginatedAgentsResponse
     */
    current_page?: number;
    /**
     * 1ページあたりの件数
     * @type {number}
     * @memberof PaginatedAgentsResponse
     */
    per_page?: number;
    /**
     * 総ページ数
     * @type {number}
     * @memberof PaginatedAgentsResponse
     */
    total_pages?: number;
    /**
     * 
     * @type {Array<Agent>}
     * @memberof PaginatedAgentsResponse
     */
    agents?: Array<Agent>;
}
/**
 * 今までの面談回数
 * @export
 * @enum {string}
 */
export enum PastMeetingCountEnum {
    _1回 = '1回',
    _2回 = '2回',
    _3回 = '3回',
    それ以上 = 'それ以上'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum Period {
    _6ヶ月未満 = '6ヶ月未満',
    _6ヶ月以上1年未満 = '6ヶ月以上1年未満',
    _1年以上3年未満 = '1年以上3年未満',
    _3年以上 = '3年以上'
}

/**
 * 
 * @export
 * @interface PrivacyPolicy
 */
export interface PrivacyPolicy {
    /**
     * 
     * @type {number}
     * @memberof PrivacyPolicy
     */
    id: number;
    /**
     * markdown原文の全文（フロントはmarkdownとして描画する。生HTMLは描画しない。タイトルは返さずフロント側で固定表示する）
     * @type {string}
     * @memberof PrivacyPolicy
     */
    body: string;
}
/**
 * policy は is_agreed=false のときのみ同梱する （同意済み・現行版なし=機能OFFのときは policy キー自体を含めない） 
 * @export
 * @interface PrivacyPolicyConsent
 */
export interface PrivacyPolicyConsent {
    /**
     * 現行版に status=agreed の記録が存在するか。 未回答・不同意は false。現行版が存在しない（機能OFF）場合は true 
     * @type {boolean}
     * @memberof PrivacyPolicyConsent
     */
    is_agreed: boolean;
    /**
     * 
     * @type {PrivacyPolicy}
     * @memberof PrivacyPolicyConsent
     */
    policy?: PrivacyPolicy;
}
/**
 * 
 * @export
 * @interface PrivacyPolicyConsentCreateRequest
 */
export interface PrivacyPolicyConsentCreateRequest {
    /**
     * 
     * @type {PrivacyPolicyConsentStatusEnum}
     * @memberof PrivacyPolicyConsentCreateRequest
     */
    status: PrivacyPolicyConsentStatusEnum;
    /**
     * ユーザーに表示した版のid。現行版と不一致なら400
     * @type {number}
     * @memberof PrivacyPolicyConsentCreateRequest
     */
    privacy_policy_id: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum PrivacyPolicyConsentStatusEnum {
    Agreed = 'agreed'
}

/**
 * 
 * @export
 * @interface Property
 */
export interface Property {
    /**
     * 
     * @type {number}
     * @memberof Property
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof Property
     */
    user_id?: number;
    /**
     * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
     * @type {number}
     * @memberof Property
     */
    score?: number | null;
    /**
     * 
     * @type {PropertyType}
     * @memberof Property
     */
    property_type?: PropertyType;
    /**
     * 
     * @type {PropertyCategory}
     * @memberof Property
     */
    property_category?: PropertyCategory;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    prefecture?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    town?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    block?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    railway?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    station?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Property
     */
    walk?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    bought_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    built_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    structure?: PropertyStructureEnum;
    /**
     * 購入価格 (下記priceof_* の合計)
     * @type {number}
     * @memberof Property
     */
    total_price_of_property?: number;
    /**
     * うち建物
     * @type {number}
     * @memberof Property
     */
    priceof_building?: number | null;
    /**
     * うち設備
     * @type {number}
     * @memberof Property
     */
    priceof_facilities?: number | null;
    /**
     * うち土地
     * @type {number}
     * @memberof Property
     */
    priceof_land?: number | null;
    /**
     * うち消費税
     * @type {any}
     * @memberof Property
     */
    priceof_tax?: any | null;
    /**
     * ローン総額
     * @type {number}
     * @memberof Property
     */
    loan_amount?: number;
    /**
     * 支払い開始月
     * @type {string}
     * @memberof Property
     */
    payment_starts_at?: string;
    /**
     * 支払い期間（年）
     * @type {number}
     * @memberof Property
     */
    payment_period?: number;
    /**
     * 賃貸管理会社
     * @type {string}
     * @memberof Property
     */
    rental_management_company?: string | null;
    /**
     * 管理形態
     * @type {string}
     * @memberof Property
     */
    management_type?: PropertyManagementTypeEnum;
    /**
     * 売却状況
     * @type {string}
     * @memberof Property
     */
    sales_status?: PropertySalesStatusEnum;
    /**
     * 不動産取得税
     * @type {number}
     * @memberof Property
     */
    property_acquisition_tax?: number | null;
    /**
     * 不動産取得税の支払い月
     * @type {string}
     * @memberof Property
     */
    property_acquisition_tax_payment_month?: string | null;
    /**
     * 購入時諸費用
     * @type {number}
     * @memberof Property
     */
    misc_expences_at_bought?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Property
     */
    discarded_at?: string | null;
    /**
     * 希望売却価格（あれば）
     * @type {number}
     * @memberof Property
     */
    asking_price?: number | null;
    /**
     * 
     * @type {UnitDetail}
     * @memberof Property
     */
    unit_detail?: UnitDetail;
    /**
     * 
     * @type {BuildingDetail}
     * @memberof Property
     */
    building_detail?: BuildingDetail;
    /**
     * 
     * @type {Array<Image>}
     * @memberof Property
     */
    images?: Array<Image>;
    /**
     * 
     * @type {Array<LeaseContract>}
     * @memberof Property
     */
    lease_contracts?: Array<LeaseContract>;
    /**
     * 
     * @type {Array<MonthlyCashflowResult>}
     * @memberof Property
     */
    monthly_cashflow_results?: Array<MonthlyCashflowResult>;
    /**
     * 
     * @type {User}
     * @memberof Property
     */
    user?: User;
    /**
     * 
     * @type {Image}
     * @memberof Property
     */
    image?: Image;
    /**
     * 
     * @type {LeaseContract}
     * @memberof Property
     */
    lease_contract_latest?: LeaseContract;
    /**
     * 
     * @type {LeaseContract}
     * @memberof Property
     */
    lease_contract_current?: LeaseContract;
    /**
     * 
     * @type {MonthlyCashflowResult}
     * @memberof Property
     */
    monthly_cashflow_result_latest?: MonthlyCashflowResult;
    /**
     * 新着物件かどうか
     * @type {boolean}
     * @memberof Property
     */
    is_new_label?: boolean;
    /**
     * AIおまかせ入力で作成した物件についてのお知らせが必要かどうか
     * @type {boolean}
     * @memberof Property
     */
    is_need_ai_create_notification?: boolean | null;
    /**
     * AIおまかせ入力で作成した物件のお知らせを閉じたかどうか
     * @type {boolean}
     * @memberof Property
     */
    is_ai_create_notification_dismissed?: boolean;
    /**
     * お気に入り登録済みかどうか
     * @type {boolean}
     * @memberof Property
     */
    is_favorite?: boolean;
    /**
     * ローン残債
     * @type {number}
     * @memberof Property
     */
    remain_loan_amount?: number | null;
    /**
     * 所有ユーザーの売却希望タグ有無
     * @type {boolean}
     * @memberof Property
     */
    has_sell_tag?: boolean;
    /**
     * 月額家賃収入 + 月額管理費収入
     * @type {number}
     * @memberof Property
     */
    monthly_total_fee?: number | null;
    /**
     * 月額建物管理費 + 月額修繕積立金
     * @type {number}
     * @memberof Property
     */
    monthly_building_total_cost?: number | null;
}

/**
    * @export
    * @enum {string}
    */
export enum PropertyStructureEnum {
    未選択 = '未選択',
    Src造鉄骨鉄筋コンクリート造 = 'SRC造(鉄骨鉄筋コンクリート造)',
    Rc造鉄筋コンクリート造 = 'RC造(鉄筋コンクリート造)',
    S造重量鉄骨造 = 'S造(重量鉄骨造)',
    木造 = '木造'
}
/**
    * @export
    * @enum {string}
    */
export enum PropertyManagementTypeEnum {
    NotSelected = 'NotSelected',
    Outsourcing = 'Outsourcing',
    MoneyCollectionAgency = 'MoneyCollectionAgency',
    SelfManagement = 'SelfManagement',
    Subleasing = 'Subleasing'
}
/**
    * @export
    * @enum {string}
    */
export enum PropertySalesStatusEnum {
    未選択 = '未選択',
    売りに出していない = '売りに出していない',
    売却希望 = '売却希望',
    一般媒介契約締結済み = '一般媒介契約締結済み',
    専任媒介契約締結済み = '専任媒介契約締結済み',
    専属専任媒介締結済み = '専属専任媒介締結済み'
}

/**
 * 
 * @export
 * @interface PropertyAiCreateNotificationDismissedRequest
 */
export interface PropertyAiCreateNotificationDismissedRequest {
    /**
     * 
     * @type {boolean}
     * @memberof PropertyAiCreateNotificationDismissedRequest
     */
    is_ai_create_notification_dismissed: boolean;
}
/**
 * 
 * @export
 * @interface PropertyAiCreateNotificationDismissedResponse
 */
export interface PropertyAiCreateNotificationDismissedResponse {
    /**
     * 
     * @type {number}
     * @memberof PropertyAiCreateNotificationDismissedResponse
     */
    property_id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PropertyAiCreateNotificationDismissedResponse
     */
    is_ai_create_notification_dismissed?: boolean;
}
/**
 * 
 * @export
 * @interface PropertyBuilder
 */
export interface PropertyBuilder {
    /**
     * 
     * @type {number}
     * @memberof PropertyBuilder
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyBuilder
     */
    user_id?: number;
    /**
     * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
     * @type {number}
     * @memberof PropertyBuilder
     */
    score?: number | null;
    /**
     * 
     * @type {PropertyType}
     * @memberof PropertyBuilder
     */
    property_type?: PropertyType;
    /**
     * 
     * @type {PropertyCategory}
     * @memberof PropertyBuilder
     */
    property_category?: PropertyCategory;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    prefecture?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    town?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    block?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    railway?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    station?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyBuilder
     */
    walk?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    bought_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    built_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    structure?: PropertyBuilderStructureEnum;
    /**
     * 購入価格 (下記priceof_* の合計)
     * @type {number}
     * @memberof PropertyBuilder
     */
    total_price_of_property?: number;
    /**
     * うち建物
     * @type {number}
     * @memberof PropertyBuilder
     */
    priceof_building?: number | null;
    /**
     * うち設備
     * @type {number}
     * @memberof PropertyBuilder
     */
    priceof_facilities?: number | null;
    /**
     * うち土地
     * @type {number}
     * @memberof PropertyBuilder
     */
    priceof_land?: number | null;
    /**
     * うち消費税
     * @type {any}
     * @memberof PropertyBuilder
     */
    priceof_tax?: any | null;
    /**
     * ローン総額
     * @type {number}
     * @memberof PropertyBuilder
     */
    loan_amount?: number;
    /**
     * 支払い開始月
     * @type {string}
     * @memberof PropertyBuilder
     */
    payment_starts_at?: string;
    /**
     * 支払い期間（年）
     * @type {number}
     * @memberof PropertyBuilder
     */
    payment_period?: number;
    /**
     * 賃貸管理会社
     * @type {string}
     * @memberof PropertyBuilder
     */
    rental_management_company?: string | null;
    /**
     * 管理形態
     * @type {string}
     * @memberof PropertyBuilder
     */
    management_type?: PropertyBuilderManagementTypeEnum;
    /**
     * 売却状況
     * @type {string}
     * @memberof PropertyBuilder
     */
    sales_status?: PropertyBuilderSalesStatusEnum;
    /**
     * 不動産取得税
     * @type {number}
     * @memberof PropertyBuilder
     */
    property_acquisition_tax?: number | null;
    /**
     * 不動産取得税の支払い月
     * @type {string}
     * @memberof PropertyBuilder
     */
    property_acquisition_tax_payment_month?: string | null;
    /**
     * 購入時諸費用
     * @type {number}
     * @memberof PropertyBuilder
     */
    misc_expences_at_bought?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyBuilder
     */
    discarded_at?: string | null;
    /**
     * 希望売却価格（あれば）
     * @type {number}
     * @memberof PropertyBuilder
     */
    asking_price?: number | null;
    /**
     * 
     * @type {UnitDetail}
     * @memberof PropertyBuilder
     */
    unit_detail?: UnitDetail;
    /**
     * 
     * @type {BuildingDetail}
     * @memberof PropertyBuilder
     */
    building_detail?: BuildingDetail;
    /**
     * 
     * @type {Array<Image>}
     * @memberof PropertyBuilder
     */
    images?: Array<Image>;
    /**
     * 
     * @type {Array<LeaseContract>}
     * @memberof PropertyBuilder
     */
    lease_contracts?: Array<LeaseContract>;
    /**
     * 
     * @type {Array<MonthlyCashflowResult>}
     * @memberof PropertyBuilder
     */
    monthly_cashflow_results?: Array<MonthlyCashflowResult>;
    /**
     * 
     * @type {User}
     * @memberof PropertyBuilder
     */
    user?: User;
    /**
     * 
     * @type {Image}
     * @memberof PropertyBuilder
     */
    image?: Image;
    /**
     * 
     * @type {LeaseContract}
     * @memberof PropertyBuilder
     */
    lease_contract_latest?: LeaseContract;
    /**
     * 
     * @type {LeaseContract}
     * @memberof PropertyBuilder
     */
    lease_contract_current?: LeaseContract;
    /**
     * 
     * @type {MonthlyCashflowResult}
     * @memberof PropertyBuilder
     */
    monthly_cashflow_result_latest?: MonthlyCashflowResult;
    /**
     * 新着物件かどうか
     * @type {boolean}
     * @memberof PropertyBuilder
     */
    is_new_label?: boolean;
    /**
     * AIおまかせ入力で作成した物件についてのお知らせが必要かどうか
     * @type {boolean}
     * @memberof PropertyBuilder
     */
    is_need_ai_create_notification?: boolean | null;
    /**
     * AIおまかせ入力で作成した物件のお知らせを閉じたかどうか
     * @type {boolean}
     * @memberof PropertyBuilder
     */
    is_ai_create_notification_dismissed?: boolean;
    /**
     * お気に入り登録済みかどうか
     * @type {boolean}
     * @memberof PropertyBuilder
     */
    is_favorite?: boolean;
    /**
     * ローン残債
     * @type {number}
     * @memberof PropertyBuilder
     */
    remain_loan_amount?: number | null;
    /**
     * 所有ユーザーの売却希望タグ有無
     * @type {boolean}
     * @memberof PropertyBuilder
     */
    has_sell_tag?: boolean;
    /**
     * 月額家賃収入 + 月額管理費収入
     * @type {number}
     * @memberof PropertyBuilder
     */
    monthly_total_fee?: number | null;
    /**
     * 月額建物管理費 + 月額修繕積立金
     * @type {number}
     * @memberof PropertyBuilder
     */
    monthly_building_total_cost?: number | null;
    /**
     * 
     * @type {LeaseContract}
     * @memberof PropertyBuilder
     */
    lease_contract?: LeaseContract;
    /**
     * 
     * @type {BuildingRoom}
     * @memberof PropertyBuilder
     */
    building_room?: BuildingRoom;
    /**
     * 
     * @type {MonthlyCashflowResult}
     * @memberof PropertyBuilder
     */
    cashflow_result_of_the_first_month?: MonthlyCashflowResult;
}

/**
    * @export
    * @enum {string}
    */
export enum PropertyBuilderStructureEnum {
    未選択 = '未選択',
    Src造鉄骨鉄筋コンクリート造 = 'SRC造(鉄骨鉄筋コンクリート造)',
    Rc造鉄筋コンクリート造 = 'RC造(鉄筋コンクリート造)',
    S造重量鉄骨造 = 'S造(重量鉄骨造)',
    木造 = '木造'
}
/**
    * @export
    * @enum {string}
    */
export enum PropertyBuilderManagementTypeEnum {
    NotSelected = 'NotSelected',
    Outsourcing = 'Outsourcing',
    MoneyCollectionAgency = 'MoneyCollectionAgency',
    SelfManagement = 'SelfManagement',
    Subleasing = 'Subleasing'
}
/**
    * @export
    * @enum {string}
    */
export enum PropertyBuilderSalesStatusEnum {
    未選択 = '未選択',
    売りに出していない = '売りに出していない',
    売却希望 = '売却希望',
    一般媒介契約締結済み = '一般媒介契約締結済み',
    専任媒介契約締結済み = '専任媒介契約締結済み',
    専属専任媒介締結済み = '専属専任媒介締結済み'
}

/**
 * 
 * @export
 * @interface PropertyBuilderAllOf
 */
export interface PropertyBuilderAllOf {
    /**
     * 
     * @type {UnitDetail}
     * @memberof PropertyBuilderAllOf
     */
    unit_detail?: UnitDetail;
    /**
     * 
     * @type {LeaseContract}
     * @memberof PropertyBuilderAllOf
     */
    lease_contract?: LeaseContract;
    /**
     * 
     * @type {BuildingRoom}
     * @memberof PropertyBuilderAllOf
     */
    building_room?: BuildingRoom;
    /**
     * 
     * @type {MonthlyCashflowResult}
     * @memberof PropertyBuilderAllOf
     */
    cashflow_result_of_the_first_month?: MonthlyCashflowResult;
}
/**
 * 物件構造種別 
 * @export
 * @enum {string}
 */
export enum PropertyCategory {
    区分マンション = '区分マンション',
    一棟物件 = '一棟物件',
    戸建 = '戸建'
}

/**
 * 
 * @export
 * @interface PropertyTemporary
 */
export interface PropertyTemporary {
    /**
     * 
     * @type {number}
     * @memberof PropertyTemporary
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof PropertyTemporary
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyTemporary
     */
    updated_at?: string;
}
/**
 * 物件種別 0: 保有物件 1: 検討中物件 2: 提案物件 3: サンプル保有物件 
 * @export
 * @enum {string}
 */
export enum PropertyType {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2,
    NUMBER_3 = 3
}

/**
 * 
 * @export
 * @interface PropertyUpdate
 */
export interface PropertyUpdate {
    /**
     * 
     * @type {number}
     * @memberof PropertyUpdate
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyUpdate
     */
    user_id?: number;
    /**
     * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
     * @type {number}
     * @memberof PropertyUpdate
     */
    score?: number | null;
    /**
     * 
     * @type {PropertyType}
     * @memberof PropertyUpdate
     */
    property_type?: PropertyType;
    /**
     * 
     * @type {PropertyCategory}
     * @memberof PropertyUpdate
     */
    property_category?: PropertyCategory;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    prefecture?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    town?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    block?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    railway?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    station?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyUpdate
     */
    walk?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    bought_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    built_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    structure?: PropertyUpdateStructureEnum;
    /**
     * 購入価格 (下記priceof_* の合計)
     * @type {number}
     * @memberof PropertyUpdate
     */
    total_price_of_property?: number;
    /**
     * うち建物
     * @type {number}
     * @memberof PropertyUpdate
     */
    priceof_building?: number | null;
    /**
     * うち設備
     * @type {number}
     * @memberof PropertyUpdate
     */
    priceof_facilities?: number | null;
    /**
     * うち土地
     * @type {number}
     * @memberof PropertyUpdate
     */
    priceof_land?: number | null;
    /**
     * うち消費税
     * @type {any}
     * @memberof PropertyUpdate
     */
    priceof_tax?: any | null;
    /**
     * ローン総額
     * @type {number}
     * @memberof PropertyUpdate
     */
    loan_amount?: number;
    /**
     * 支払い開始月
     * @type {string}
     * @memberof PropertyUpdate
     */
    payment_starts_at?: string;
    /**
     * 支払い期間（年）
     * @type {number}
     * @memberof PropertyUpdate
     */
    payment_period?: number;
    /**
     * 賃貸管理会社
     * @type {string}
     * @memberof PropertyUpdate
     */
    rental_management_company?: string | null;
    /**
     * 管理形態
     * @type {string}
     * @memberof PropertyUpdate
     */
    management_type?: PropertyUpdateManagementTypeEnum;
    /**
     * 売却状況
     * @type {string}
     * @memberof PropertyUpdate
     */
    sales_status?: PropertyUpdateSalesStatusEnum;
    /**
     * 不動産取得税
     * @type {number}
     * @memberof PropertyUpdate
     */
    property_acquisition_tax?: number | null;
    /**
     * 不動産取得税の支払い月
     * @type {string}
     * @memberof PropertyUpdate
     */
    property_acquisition_tax_payment_month?: string | null;
    /**
     * 購入時諸費用
     * @type {number}
     * @memberof PropertyUpdate
     */
    misc_expences_at_bought?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof PropertyUpdate
     */
    discarded_at?: string | null;
    /**
     * 希望売却価格（あれば）
     * @type {number}
     * @memberof PropertyUpdate
     */
    asking_price?: number | null;
    /**
     * 
     * @type {UnitDetail}
     * @memberof PropertyUpdate
     */
    unit_detail?: UnitDetail;
    /**
     * 
     * @type {BuildingDetail}
     * @memberof PropertyUpdate
     */
    building_detail?: BuildingDetail;
    /**
     * 
     * @type {Array<Image>}
     * @memberof PropertyUpdate
     */
    images?: Array<Image>;
    /**
     * 
     * @type {Array<LeaseContract>}
     * @memberof PropertyUpdate
     */
    lease_contracts?: Array<LeaseContract>;
    /**
     * 
     * @type {Array<MonthlyCashflowResult>}
     * @memberof PropertyUpdate
     */
    monthly_cashflow_results?: Array<MonthlyCashflowResult>;
    /**
     * 
     * @type {User}
     * @memberof PropertyUpdate
     */
    user?: User;
    /**
     * 
     * @type {Image}
     * @memberof PropertyUpdate
     */
    image?: Image;
    /**
     * 
     * @type {LeaseContract}
     * @memberof PropertyUpdate
     */
    lease_contract_latest?: LeaseContract;
    /**
     * 
     * @type {LeaseContract}
     * @memberof PropertyUpdate
     */
    lease_contract_current?: LeaseContract;
    /**
     * 
     * @type {MonthlyCashflowResult}
     * @memberof PropertyUpdate
     */
    monthly_cashflow_result_latest?: MonthlyCashflowResult;
    /**
     * 新着物件かどうか
     * @type {boolean}
     * @memberof PropertyUpdate
     */
    is_new_label?: boolean;
    /**
     * AIおまかせ入力で作成した物件についてのお知らせが必要かどうか
     * @type {boolean}
     * @memberof PropertyUpdate
     */
    is_need_ai_create_notification?: boolean | null;
    /**
     * AIおまかせ入力で作成した物件のお知らせを閉じたかどうか
     * @type {boolean}
     * @memberof PropertyUpdate
     */
    is_ai_create_notification_dismissed?: boolean;
    /**
     * お気に入り登録済みかどうか
     * @type {boolean}
     * @memberof PropertyUpdate
     */
    is_favorite?: boolean;
    /**
     * ローン残債
     * @type {number}
     * @memberof PropertyUpdate
     */
    remain_loan_amount?: number | null;
    /**
     * 所有ユーザーの売却希望タグ有無
     * @type {boolean}
     * @memberof PropertyUpdate
     */
    has_sell_tag?: boolean;
    /**
     * 月額家賃収入 + 月額管理費収入
     * @type {number}
     * @memberof PropertyUpdate
     */
    monthly_total_fee?: number | null;
    /**
     * 月額建物管理費 + 月額修繕積立金
     * @type {number}
     * @memberof PropertyUpdate
     */
    monthly_building_total_cost?: number | null;
    /**
     * 修復用。変更後の初回返済月に適用できる金利がない場合のみ、その月へ初期金利を追加する。物件更新と一括保存。
     * @type {number}
     * @memberof PropertyUpdate
     */
    initial_loan_interest_rate_percentage?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum PropertyUpdateStructureEnum {
    未選択 = '未選択',
    Src造鉄骨鉄筋コンクリート造 = 'SRC造(鉄骨鉄筋コンクリート造)',
    Rc造鉄筋コンクリート造 = 'RC造(鉄筋コンクリート造)',
    S造重量鉄骨造 = 'S造(重量鉄骨造)',
    木造 = '木造'
}
/**
    * @export
    * @enum {string}
    */
export enum PropertyUpdateManagementTypeEnum {
    NotSelected = 'NotSelected',
    Outsourcing = 'Outsourcing',
    MoneyCollectionAgency = 'MoneyCollectionAgency',
    SelfManagement = 'SelfManagement',
    Subleasing = 'Subleasing'
}
/**
    * @export
    * @enum {string}
    */
export enum PropertyUpdateSalesStatusEnum {
    未選択 = '未選択',
    売りに出していない = '売りに出していない',
    売却希望 = '売却希望',
    一般媒介契約締結済み = '一般媒介契約締結済み',
    専任媒介契約締結済み = '専任媒介契約締結済み',
    専属専任媒介締結済み = '専属専任媒介締結済み'
}

/**
 * 
 * @export
 * @interface PropertyUpdateAllOf
 */
export interface PropertyUpdateAllOf {
    /**
     * 修復用。変更後の初回返済月に適用できる金利がない場合のみ、その月へ初期金利を追加する。物件更新と一括保存。
     * @type {number}
     * @memberof PropertyUpdateAllOf
     */
    initial_loan_interest_rate_percentage?: number;
}
/**
 * 
 * @export
 * @interface ProposalApprovedRequest
 */
export interface ProposalApprovedRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ProposalApprovedRequest
     */
    is_approved: boolean;
}
/**
 * オファー送信状態。scheduled=予約中、sent=送信済み、failed=送信失敗、canceled=キャンセル済み
 * @export
 * @enum {string}
 */
export enum ProposalDeliveryStatus {
    Scheduled = 'scheduled',
    Sent = 'sent',
    Failed = 'failed',
    Canceled = 'canceled'
}

/**
 * 
 * @export
 * @interface ProposalMatching
 */
export interface ProposalMatching {
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProposalMatching
     */
    discarded_at?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalMatching
     */
    is_invalid?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    agent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    user_id?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    assessment_proposal_id?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    investment_proposal_id?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalMatching
     */
    is_manual_match?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalMatching
     */
    is_agent_read?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProposalMatching
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalMatching
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalMatching
     */
    user_registered_at?: string | null;
    /**
     * 第一希望日
     * @type {string}
     * @memberof ProposalMatching
     */
    first_preferred_contact_date?: string | null;
    /**
     * 第一希望時間帯
     * @type {string}
     * @memberof ProposalMatching
     */
    first_preferred_contact_time_slot?: ProposalMatchingFirstPreferredContactTimeSlotEnum;
    /**
     * 第二希望日
     * @type {string}
     * @memberof ProposalMatching
     */
    second_preferred_contact_date?: string | null;
    /**
     * 第二希望時間帯
     * @type {string}
     * @memberof ProposalMatching
     */
    second_preferred_contact_time_slot?: ProposalMatchingSecondPreferredContactTimeSlotEnum;
    /**
     * 
     * @type {Agent}
     * @memberof ProposalMatching
     */
    agent?: Agent;
    /**
     * 
     * @type {User}
     * @memberof ProposalMatching
     */
    user?: User;
    /**
     * 
     * @type {InvestmentProposal}
     * @memberof ProposalMatching
     */
    investment_proposal?: InvestmentProposal;
    /**
     * 
     * @type {AssessmentProposal}
     * @memberof ProposalMatching
     */
    assessment_proposal?: AssessmentProposal;
    /**
     * 
     * @type {UserProposal}
     * @memberof ProposalMatching
     */
    user_proposal?: UserProposal;
    /**
     * 対象ユーザの成約申請済みが1件以上あるかどうか
     * @type {boolean}
     * @memberof ProposalMatching
     */
    is_contract_applied?: boolean;
    /**
     * 
     * @type {MatchingType}
     * @memberof ProposalMatching
     */
    matching_type?: MatchingType;
    /**
     * ユーザーマッチ時の内訳（プロ検索 or 限定物件）
     * @type {string}
     * @memberof ProposalMatching
     */
    user_matching_type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProposalMatching
     */
    matching_counts?: number;
    /**
     * 累計マッチ数の合計
     * @type {number}
     * @memberof ProposalMatching
     */
    matched_count_sum?: number;
    /**
     * マッチ種別「ユーザ」の累計マッチ数
     * @type {number}
     * @memberof ProposalMatching
     */
    matched_count_user?: number | null;
    /**
     * マッチ種別「投資」の累計マッチ数
     * @type {number}
     * @memberof ProposalMatching
     */
    matched_count_investment?: number | null;
    /**
     * マッチ種別「査定」の累計マッチ数
     * @type {number}
     * @memberof ProposalMatching
     */
    matched_count_assessment?: number | null;
    /**
     * マッチ種別「手動」の累計マッチ数
     * @type {number}
     * @memberof ProposalMatching
     */
    matched_count_manual?: number | null;
    /**
     * 
     * @type {SalesNoteProspectLankEnum}
     * @memberof ProposalMatching
     */
    prospect_lank?: SalesNoteProspectLankEnum | null;
    /**
     * 
     * @type {SalesNoteStatusEnum}
     * @memberof ProposalMatching
     */
    status?: SalesNoteStatusEnum | null;
    /**
     * 
     * @type {SalesNoteCompleteReasonEnum}
     * @memberof ProposalMatching
     */
    complete_reason?: SalesNoteCompleteReasonEnum | null;
    /**
     * 
     * @type {string}
     * @memberof ProposalMatching
     */
    progress?: string | null;
    /**
     * アポ取得ボタンで登録した最新のアポ日
     * @type {string}
     * @memberof ProposalMatching
     */
    appointment_date?: string | null;
    /**
     * 進捗メモの最終更新日時（楽観的排他制御用）
     * @type {string}
     * @memberof ProposalMatching
     */
    sales_note_updated_at?: string | null;
    /**
     * 
     * @type {UserOfferSourceCategoryEnum}
     * @memberof ProposalMatching
     */
    user_offer_source_category?: UserOfferSourceCategoryEnum | null;
    /**
     * 
     * @type {UserOfferSourceAnalysisItemSourceEnum}
     * @memberof ProposalMatching
     */
    user_offer_source?: UserOfferSourceAnalysisItemSourceEnum;
    /**
     * 学習コンテンツ既読数
     * @type {number}
     * @memberof ProposalMatching
     */
    learning_completed_count?: number | null;
    /**
     * 学習進捗率（既読数/全記事数）
     * @type {number}
     * @memberof ProposalMatching
     */
    learning_progress_rate?: number | null;
    /**
     * エージェントの対象条件に合致しているか
     * @type {boolean}
     * @memberof ProposalMatching
     */
    is_target?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum ProposalMatchingFirstPreferredContactTimeSlotEnum {
    Morning = 'morning',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Slot911 = 'slot_9_11',
    Slot1113 = 'slot_11_13',
    Slot1315 = 'slot_13_15',
    Slot1517 = 'slot_15_17',
    Slot1719 = 'slot_17_19',
    Slot1921 = 'slot_19_21'
}
/**
    * @export
    * @enum {string}
    */
export enum ProposalMatchingSecondPreferredContactTimeSlotEnum {
    Morning = 'morning',
    Afternoon = 'afternoon',
    Evening = 'evening',
    Slot911 = 'slot_9_11',
    Slot1113 = 'slot_11_13',
    Slot1315 = 'slot_13_15',
    Slot1517 = 'slot_15_17',
    Slot1719 = 'slot_17_19',
    Slot1921 = 'slot_19_21'
}

/**
 * 
 * @export
 * @interface ProposalMatchingRequest
 */
export interface ProposalMatchingRequest {
    /**
     * 
     * @type {number}
     * @memberof ProposalMatchingRequest
     */
    agent_id?: number;
    /**
     * マッチした提案IDがどちらかに入る
     * @type {number}
     * @memberof ProposalMatchingRequest
     */
    assessment_proposal_id?: number;
    /**
     * マッチした提案IDがどちらかに入る
     * @type {number}
     * @memberof ProposalMatchingRequest
     */
    investment_proposal_id?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum ProposalStatusEnum {
    提案済み = '提案済み',
    取り消し済み = '取り消し済み',
    マッチ = 'マッチ',
    成約済み = '成約済み',
    予約中 = '予約中',
    送信失敗 = '送信失敗',
    予約取消 = '予約取消'
}

/**
 * 紹介キャンペーンID（referral_ref） - regular: 通常特典（デフォルト値） - email_gift: メール特典 
 * @export
 * @enum {string}
 */
export enum ReferralRefEnum {
    Regular = 'regular',
    EmailGift = 'email_gift'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum RegisteredStatusEnum {
    Registration = 'Registration',
    Account = 'Account',
    Property = 'Property'
}

/**
 * 登録方法 (email, google, appleなど)
 * @export
 * @enum {string}
 */
export enum RegistrationMethod {
    Email = 'email',
    Google = 'google',
    Apple = 'apple',
    X = 'x',
    Facebook = 'facebook'
}

/**
 * reinfolib(外部API)_価格情報APIレスポンスの型
 * @export
 * @interface ReinfolibPrice
 */
export interface ReinfolibPrice {
    /**
     * 価格情報種類
     * @type {string}
     * @memberof ReinfolibPrice
     */
    PriceCategory?: string;
    /**
     * 取引の種類
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Type?: string;
    /**
     * 地区
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Region?: string;
    /**
     * 市区町村コード
     * @type {string}
     * @memberof ReinfolibPrice
     */
    MunicipalityCode?: string;
    /**
     * 都道府県名
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Prefecture?: string;
    /**
     * 市区町村名
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Municipality?: string;
    /**
     * 地区名
     * @type {string}
     * @memberof ReinfolibPrice
     */
    DistrictName?: string;
    /**
     * 取引価格
     * @type {string}
     * @memberof ReinfolibPrice
     */
    TradePrice?: string;
    /**
     * 坪単価
     * @type {string}
     * @memberof ReinfolibPrice
     */
    PricePerUnit?: string;
    /**
     * 間取り
     * @type {string}
     * @memberof ReinfolibPrice
     */
    FloorPlan?: string;
    /**
     * 面積（平方メートル）
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Area?: string;
    /**
     * 取引価格（平方メートル単価）
     * @type {string}
     * @memberof ReinfolibPrice
     */
    UnitPrice?: string;
    /**
     * 土地の形状
     * @type {string}
     * @memberof ReinfolibPrice
     */
    LandShape?: string;
    /**
     * 間口
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Frontage?: string;
    /**
     * 延床面積（平方メートル）
     * @type {string}
     * @memberof ReinfolibPrice
     */
    TotalFloorArea?: string;
    /**
     * 建築年
     * @type {string}
     * @memberof ReinfolibPrice
     */
    BuildingYear?: string;
    /**
     * 建物の構造
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Structure?: string;
    /**
     * 用途
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Use?: string;
    /**
     * 今後の利用目的
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Purpose?: string;
    /**
     * 前面道路：方位
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Direction?: string;
    /**
     * 前面道路：種類
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Classification?: string;
    /**
     * 前面道路：幅員
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Breadth?: string;
    /**
     * 都市計画
     * @type {string}
     * @memberof ReinfolibPrice
     */
    CityPlanning?: string;
    /**
     * 建蔽率（%）
     * @type {string}
     * @memberof ReinfolibPrice
     */
    CoverageRatio?: string;
    /**
     * 容積率（%）
     * @type {string}
     * @memberof ReinfolibPrice
     */
    FloorAreaRatio?: string;
    /**
     * 取引時点
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Period?: string;
    /**
     * 改装
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Renovation?: string;
    /**
     * 取引の事情等
     * @type {string}
     * @memberof ReinfolibPrice
     */
    Remarks?: string;
}
/**
 * 
 * @export
 * @interface ReserveFundPriceChange
 */
export interface ReserveFundPriceChange {
    /**
     * 修繕積立金変動の発生月
     * @type {string}
     * @memberof ReserveFundPriceChange
     */
    month?: string;
    /**
     * 修繕積立金変動の金額
     * @type {number}
     * @memberof ReserveFundPriceChange
     */
    amount?: number;
}
/**
 * 
 * @export
 * @interface ResponseMessage
 */
export interface ResponseMessage {
    /**
     * 
     * @type {string}
     * @memberof ResponseMessage
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface SalesAchievements
 */
export interface SalesAchievements {
    /**
     * 
     * @type {string}
     * @memberof SalesAchievements
     */
    achievement_name?: string;
    /**
     * 
     * @type {string}
     * @memberof SalesAchievements
     */
    achievement_area?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SalesAchievements
     */
    achievement_price?: number;
    /**
     * 
     * @type {string}
     * @memberof SalesAchievements
     */
    file_url?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SalesAchievements
     */
    object_storage_path?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesNoteCompleteReasonEnum {
    未完了 = '未完了',
    ローンアウト = 'ローンアウト',
    他社購入 = '他社購入',
    成約 = '成約',
    その他 = 'その他'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesNoteProspectLankEnum {
    A = 'A',
    B = 'B',
    C = 'C',
    D = 'D'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SalesNoteStatusEnum {
    電話不通 = '電話不通',
    日程調整中 = '日程調整中',
    アポ取得済み = 'アポ取得済み',
    初回面談完了 = '初回面談完了',
    申込完了 = '申込完了',
    契約完了 = '契約完了',
    ローン審査通過 = 'ローン審査通過',
    決済完了 = '決済完了',
    断念 = '断念',
    短期追客 = '短期追客',
    長期追客 = '長期追客'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ScreenNameEnum {
    Top = 'TOP',
    AgentDetail = 'AGENT_DETAIL'
}

/**
 * 
 * @export
 * @interface SimulationConfig
 */
export interface SimulationConfig {
    /**
     * 
     * @type {string}
     * @memberof SimulationConfig
     */
    proposed_by?: SimulationConfigProposedByEnum;
    /**
     * 
     * @type {SimulationPatternEnum}
     * @memberof SimulationConfig
     */
    simulation_pattern?: SimulationPatternEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationConfig
     */
    market_price_mode: SimulationConfigMarketPriceModeEnum;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfig
     */
    market_price_change_ends_at: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfig
     */
    market_price_change_down_value: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationConfig
     */
    market_price_change_at_bought_mode: SimulationConfigMarketPriceChangeAtBoughtModeEnum;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfig
     */
    market_price_change_at_bought_value: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationConfig
     */
    house_rent_mode: SimulationConfigHouseRentModeEnum;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfig
     */
    house_rent_price_change_ends_at: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfig
     */
    house_rent_price_change_down_value: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfig
     */
    house_rent_spare_months: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfig
     */
    house_rent_spare_months_for_N_contracts: number;
    /**
     * 
     * @type {Array<ReserveFundPriceChange>}
     * @memberof SimulationConfig
     */
    reserve_fund_price_changes?: Array<ReserveFundPriceChange>;
}

/**
    * @export
    * @enum {string}
    */
export enum SimulationConfigProposedByEnum {
    Realtor = 'Realtor'
}
/**
    * @export
    * @enum {string}
    */
export enum SimulationConfigMarketPriceModeEnum {
    Real = 'Real',
    Percentage = 'Percentage'
}
/**
    * @export
    * @enum {string}
    */
export enum SimulationConfigMarketPriceChangeAtBoughtModeEnum {
    Real = 'Real',
    Percentage = 'Percentage'
}
/**
    * @export
    * @enum {string}
    */
export enum SimulationConfigHouseRentModeEnum {
    Real = 'Real',
    Percentage = 'Percentage'
}

/**
 * 
 * @export
 * @interface SimulationConfigWithId
 */
export interface SimulationConfigWithId {
    /**
     * 
     * @type {number}
     * @memberof SimulationConfigWithId
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationConfigWithId
     */
    proposed_by?: SimulationConfigWithIdProposedByEnum;
    /**
     * 
     * @type {SimulationPatternEnum}
     * @memberof SimulationConfigWithId
     */
    simulation_pattern?: SimulationPatternEnum | null;
    /**
     * 
     * @type {string}
     * @memberof SimulationConfigWithId
     */
    market_price_mode: SimulationConfigWithIdMarketPriceModeEnum;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfigWithId
     */
    market_price_change_ends_at: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfigWithId
     */
    market_price_change_down_value: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationConfigWithId
     */
    market_price_change_at_bought_mode: SimulationConfigWithIdMarketPriceChangeAtBoughtModeEnum;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfigWithId
     */
    market_price_change_at_bought_value: number;
    /**
     * 
     * @type {string}
     * @memberof SimulationConfigWithId
     */
    house_rent_mode: SimulationConfigWithIdHouseRentModeEnum;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfigWithId
     */
    house_rent_price_change_ends_at: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfigWithId
     */
    house_rent_price_change_down_value: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfigWithId
     */
    house_rent_spare_months: number;
    /**
     * 
     * @type {number}
     * @memberof SimulationConfigWithId
     */
    house_rent_spare_months_for_N_contracts: number;
    /**
     * 
     * @type {Array<ReserveFundPriceChange>}
     * @memberof SimulationConfigWithId
     */
    reserve_fund_price_changes?: Array<ReserveFundPriceChange>;
}

/**
    * @export
    * @enum {string}
    */
export enum SimulationConfigWithIdProposedByEnum {
    Realtor = 'Realtor'
}
/**
    * @export
    * @enum {string}
    */
export enum SimulationConfigWithIdMarketPriceModeEnum {
    Real = 'Real',
    Percentage = 'Percentage'
}
/**
    * @export
    * @enum {string}
    */
export enum SimulationConfigWithIdMarketPriceChangeAtBoughtModeEnum {
    Real = 'Real',
    Percentage = 'Percentage'
}
/**
    * @export
    * @enum {string}
    */
export enum SimulationConfigWithIdHouseRentModeEnum {
    Real = 'Real',
    Percentage = 'Percentage'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum SimulationPatternEnum {
    楽観的 = '楽観的',
    中立 = '中立',
    悲観的 = '悲観的',
    カスタム = 'カスタム'
}

/**
 * 
 * @export
 * @interface SmaulLeadV1Request
 */
export interface SmaulLeadV1Request {
    /**
     * マンション名
     * @type {string}
     * @memberof SmaulLeadV1Request
     */
    mansion_name: string;
    /**
     * 部屋番号
     * @type {string}
     * @memberof SmaulLeadV1Request
     */
    room_number: string;
}
/**
 * 
 * @export
 * @interface TotalReadAndMatchCountResponse
 */
export interface TotalReadAndMatchCountResponse {
    /**
     * 累計既読件数
     * @type {number}
     * @memberof TotalReadAndMatchCountResponse
     */
    read_offers_count: number;
    /**
     * 累計マッチング件数
     * @type {number}
     * @memberof TotalReadAndMatchCountResponse
     */
    matched_offers_count: number;
}
/**
 * 
 * @export
 * @interface UnitDetail
 */
export interface UnitDetail {
    /**
     * 
     * @type {string}
     * @memberof UnitDetail
     */
    room_number?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitDetail
     */
    floor?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitDetail
     */
    occupied_area_m2?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitDetail
     */
    layout?: UnitDetailLayoutEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum UnitDetailLayoutEnum {
    未選択 = '未選択',
    _1R = '1R',
    _1K = '1K',
    _1Lk1Ldk = '1LK/1LDK',
    _2L2Dk = '2L/2DK',
    _2Lk2Ldk = '2LK/2LDK',
    _3K3Dk = '3K/3DK',
    _3Lk3Ldk = '3LK/3LDK',
    _4K4Dk = '4K/4DK',
    _4Lk4Ldk = '4LK/4LDK',
    _5K5Dk = '5K/5DK',
    _5Lk5Ldk = '5LK/5LDK',
    _6K6Dk = '6K/6DK'
}

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id?: number;
    /**
     * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
     * @type {number}
     * @memberof User
     */
    score?: number | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    family_name?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    family_name_kana?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    first_name_kana?: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    is_enabled_email_notification?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    is_enabled_sms_notification?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    is_enabled_push_notification?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    birthday?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    income_tax_rate?: number | null;
    /**
     * 
     * @type {JobCategory}
     * @memberof User
     */
    job_category?: JobCategory | null;
    /**
     * 住所（都道府県）
     * @type {string}
     * @memberof User
     */
    address_prefecture?: string | null;
    /**
     * 
     * @type {JobIndustry}
     * @memberof User
     */
    job_industry?: JobIndustry | null;
    /**
     * 
     * @type {Period}
     * @memberof User
     */
    job_continuous_period?: Period | null;
    /**
     * 登録日から現在までの経過期間を加味した推定勤続年数カテゴリ
     * @type {Period}
     * @memberof User
     */
    estimated_job_continuous_period?: Period | null;
    /**
     * 推定勤続年数カテゴリが実値と異なる場合にtrue
     * @type {boolean}
     * @memberof User
     */
    is_job_continuous_period_estimated?: boolean;
    /**
     * 
     * @type {MoneyAmount}
     * @memberof User
     */
    financial_asset?: MoneyAmount | null;
    /**
     * 年収
     * @type {number}
     * @memberof User
     */
    annual_income?: number | null;
    /**
     * 保有物件数(登録時の申告数)
     * @type {number}
     * @memberof User
     */
    holding_property_count?: number | null;
    /**
     * 保有物件数(アプリ内登録数)
     * @type {number}
     * @memberof User
     */
    registered_holding_property_count?: number | null;
    /**
     * 検討物件数(アプリ内登録数)
     * @type {number}
     * @memberof User
     */
    registered_considering_property_count?: number | null;
    /**
     * 不動産投資ローン残高合計
     * @type {number}
     * @memberof User
     */
    real_estate_loan_amount?: number | null;
    /**
     * 現在のお住まいマスタデータID
     * @type {number}
     * @memberof User
     */
    current_residence_type_id?: number | null;
    /**
     * 自宅毎月家賃額
     * @type {number}
     * @memberof User
     */
    monthly_rent_payment_amount?: number | null;
    /**
     * 住宅ローン残債合計
     * @type {number}
     * @memberof User
     */
    home_loan_amount?: number | null;
    /**
     * 
     * @type {ConsiderationPeriodEnum}
     * @memberof User
     */
    consideration_period?: ConsiderationPeriodEnum | null;
    /**
     * 
     * @type {PastMeetingCountEnum}
     * @memberof User
     */
    past_meeting_count?: PastMeetingCountEnum | null;
    /**
     * 検討中の物件
     * @type {string}
     * @memberof User
     */
    considering_property?: string | null;
    /**
     * 承認済みの金融機関
     * @type {string}
     * @memberof User
     */
    approved_financial_institutions?: string | null;
    /**
     * その他ご要望
     * @type {string}
     * @memberof User
     */
    other_request_text?: string | null;
    /**
     * 
     * @type {RegisteredStatusEnum}
     * @memberof User
     */
    data_first_registered_status?: RegisteredStatusEnum;
    /**
     * 不動産会社からの提案希望 false:希望しない true:希望する 
     * @type {boolean}
     * @memberof User
     */
    request_the_proposal?: boolean;
    /**
     * 提案の連絡方法 0:メール 1:LINE 
     * @type {number}
     * @memberof User
     */
    way_to_propose?: UserWayToProposeEnum;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof User
     */
    degree_of_consideration_for_investment?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof User
     */
    degree_of_consideration_for_sale?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    purpose_of_use_free_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    inflow_route_free_text?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    email_confirmed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    last_seen_announcement_id?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    has_unread_announcements?: boolean;
    /**
     * 投資力診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof User
     */
    is_diagnosis_complete?: boolean | null;
    /**
     * 投資スタイル診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof User
     */
    is_investment_style_diagnosis_complete?: boolean | null;
    /**
     * 広告計測確認用の登録なら true（プランナー通知・事務局オファー・プランナー一覧・登録KPIから除外。広告成果送信は維持し、確認完了後にIDを指定して物理削除する）
     * @type {boolean}
     * @memberof User
     */
    is_ad_measurement_test?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    password_confirmation?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    withdrawal_intended_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    last_accessed_at?: string | null;
    /**
     * ≒仮登録日
     * @type {string}
     * @memberof User
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    account_updated_at?: string;
    /**
     * 本登録日
     * @type {string}
     * @memberof User
     */
    account_registered_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    discarded_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    first_match_at?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    read_offers_count?: number;
    /**
     * 累計アクセス数（全月の合計）
     * @type {number}
     * @memberof User
     */
    total_access_count?: number | null;
    /**
     * 選択月のアクセス数
     * @type {number}
     * @memberof User
     */
    monthly_access_count?: number | null;
    /**
     * 選択月の日毎重複排除アクセス数
     * @type {number}
     * @memberof User
     */
    monthly_deduplication_access_count?: number | null;
    /**
     * 累計マッチ数の合計
     * @type {number}
     * @memberof User
     */
    matched_count_sum?: number;
    /**
     * マッチ種別「ユーザ」の累計マッチ数
     * @type {number}
     * @memberof User
     */
    matched_count_user?: number | null;
    /**
     * マッチ種別「投資」の累計マッチ数
     * @type {number}
     * @memberof User
     */
    matched_count_investment?: number | null;
    /**
     * マッチ種別「査定」の累計マッチ数
     * @type {number}
     * @memberof User
     */
    matched_count_assessment?: number | null;
    /**
     * マッチ種別「手動」の累計マッチ数
     * @type {number}
     * @memberof User
     */
    matched_count_manual?: number | null;
    /**
     * 学習コンテンツ既読数
     * @type {number}
     * @memberof User
     */
    learning_completed_count?: number | null;
    /**
     * 学習進捗率（既読数/全記事数）
     * @type {number}
     * @memberof User
     */
    learning_progress_rate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    adjust_network?: string | null;
    /**
     * 
     * @type {AdjustTracker}
     * @memberof User
     */
    adjust_tracker?: AdjustTracker;
    /**
     * 
     * @type {ReferralRefEnum}
     * @memberof User
     */
    referral_ref?: ReferralRefEnum | null;
    /**
     * 本登録日時(regular含む)
     * @type {string}
     * @memberof User
     */
    account_register_date?: string | null;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    phone_number_auth_code?: number;
    /**
     * 
     * @type {Array<AssessmentProposal>}
     * @memberof User
     */
    assessment_proposals?: Array<AssessmentProposal>;
    /**
     * 
     * @type {Array<InvestmentProposal>}
     * @memberof User
     */
    investment_proposals?: Array<InvestmentProposal>;
    /**
     * 
     * @type {Array<ProposalMatching>}
     * @memberof User
     */
    proposal_matchings?: Array<ProposalMatching>;
    /**
     * ユーザーがメッセージ詳細で「お断り」したプランナー（admin の fields=refusals で返す）
     * @type {Array<AgentMessageRefusal>}
     * @memberof User
     */
    agent_message_refusals?: Array<AgentMessageRefusal>;
    /**
     * 
     * @type {Array<ContractApplication>}
     * @memberof User
     */
    contract_applications?: Array<ContractApplication>;
    /**
     * 
     * @type {AdminUserMemo}
     * @memberof User
     */
    admin_user_memo?: AdminUserMemo;
    /**
     * 
     * @type {Array<Master>}
     * @memberof User
     */
    master_tags?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof User
     */
    master_purpose_of_uses?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof User
     */
    master_interested_property_types?: Array<Master>;
    /**
     * 関心のあるタグIDリスト
     * @type {Array<number>}
     * @memberof User
     */
    interest_tag_ids?: Array<number>;
    /**
     * 投資経験の有無（true/false）。2025-09-23(JST)以前に作成された既存データはNULL
     * @type {boolean}
     * @memberof User
     */
    has_investment_experience?: boolean | null;
    /**
     * 
     * @type {Array<Master>}
     * @memberof User
     */
    master_inflow_routes?: Array<Master>;
    /**
     * 
     * @type {Master}
     * @memberof User
     */
    current_residence_type?: Master | null;
    /**
     * 利用目的IDリスト
     * @type {Array<number>}
     * @memberof User
     */
    purpose_of_use_ids?: Array<number>;
    /**
     * 興味のある物件タイプIDリスト
     * @type {Array<number>}
     * @memberof User
     */
    interested_property_type_ids?: Array<number>;
    /**
     * 流入経路IDリスト
     * @type {Array<number>}
     * @memberof User
     */
    inflow_route_ids?: Array<number>;
    /**
     * 
     * @type {UserDeviceToken}
     * @memberof User
     */
    user_device_token?: UserDeviceToken;
    /**
     * 
     * @type {Array<UserAccessScreenLogMonthlySummary>}
     * @memberof User
     */
    user_access_screen_log_monthly_summaries?: Array<UserAccessScreenLogMonthlySummary>;
    /**
     * birthday から算出した年齢。birthday 未入力の場合は null
     * @type {number}
     * @memberof User
     */
    age?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    is_new_label?: boolean;
    /**
     * アクティブユーザーかどうか（最終ログインが3日以内）
     * @type {boolean}
     * @memberof User
     */
    is_active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    is_favorite?: boolean;
    /**
     * ローン残高合計
     * @type {number}
     * @memberof User
     */
    loan_amount?: number | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UserWayToProposeEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * 
 * @export
 * @interface UserAccessScreenLog
 */
export interface UserAccessScreenLog {
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLog
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLog
     */
    user_id?: number;
    /**
     * 
     * @type {ScreenNameEnum}
     * @memberof UserAccessScreenLog
     */
    screen_name?: ScreenNameEnum;
    /**
     * 
     * @type {string}
     * @memberof UserAccessScreenLog
     */
    accessed_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAccessScreenLog
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAccessScreenLog
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface UserAccessScreenLogMonthlySummary
 */
export interface UserAccessScreenLogMonthlySummary {
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    user_id?: number;
    /**
     * 
     * @type {ScreenNameEnum}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    screen_name?: ScreenNameEnum;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    year?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    month?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    total_access_count?: number;
    /**
     * 
     * @type {number}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    daily_deduplication_access_count?: number;
    /**
     * 
     * @type {string}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAccessScreenLogMonthlySummary
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface UserDataFirstRegisteredStatus
 */
export interface UserDataFirstRegisteredStatus {
    /**
     * 
     * @type {RegisteredStatusEnum}
     * @memberof UserDataFirstRegisteredStatus
     */
    status?: RegisteredStatusEnum;
    /**
     * 
     * @type {ReferralRefEnum}
     * @memberof UserDataFirstRegisteredStatus
     */
    referral_ref?: ReferralRefEnum | null;
}
/**
 * 
 * @export
 * @interface UserDeviceToken
 */
export interface UserDeviceToken {
    /**
     * 
     * @type {number}
     * @memberof UserDeviceToken
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    device_token: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserDeviceToken
     */
    user_id?: number;
    /**
     * 
     * @type {DeviceTypeEnum}
     * @memberof UserDeviceToken
     */
    device_type?: DeviceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    updated_at?: string;
}
/**
 * 
 * @export
 * @interface UserInputError
 */
export interface UserInputError {
    /**
     * 
     * @type {string}
     * @memberof UserInputError
     */
    message?: string;
    /**
     * 年収の範囲外の場合はINVALID_ANNUAL_INCOME。
     * @type {string}
     * @memberof UserInputError
     */
    code?: string;
}
/**
 * ユーザーオファー発生元ソース
 * @export
 * @enum {string}
 */
export enum UserOfferSourceAnalysisItemSourceEnum {
    Top = 'top',
    AgentSearch = 'agent_search',
    SearchResult = 'search_result',
    TopViaDetail = 'top_via_detail',
    AgentSearchViaDetail = 'agent_search_via_detail',
    SearchResultViaDetail = 'search_result_via_detail',
    LimitedProperty = 'limited_property',
    LimitedPropertyViaDetail = 'limited_property_via_detail',
    LearningArticle = 'learning_article',
    LearningArticleViaDetail = 'learning_article_via_detail',
    SimilarAgentViaDetail = 'similar_agent_via_detail',
    DiagnosisCompatibilityAgentsViaDetail = 'diagnosis_compatibility_agents_via_detail',
    RegistrationCompatibilityAgents = 'registration_compatibility_agents',
    RegistrationCompatibilityAgentsViaDetail = 'registration_compatibility_agents_via_detail',
    DiagnosisCompatibilityAgents = 'diagnosis_compatibility_agents'
}

/**
 * ユーザーオファーの経路カテゴリ
 * @export
 * @enum {string}
 */
export enum UserOfferSourceCategoryEnum {
    DirectBeforeSearch = 'direct_before_search',
    DirectAfterSearch = 'direct_after_search',
    AgentDetail = 'agent_detail'
}

/**
 * 
 * @export
 * @interface UserProposal
 */
export interface UserProposal {
    /**
     * 
     * @type {number}
     * @memberof UserProposal
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProposal
     */
    agent_id?: number;
    /**
     * 
     * @type {number}
     * @memberof UserProposal
     */
    user_id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserProposal
     */
    proposal_date?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProposal
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProposal
     */
    user_registered_at?: string | null;
}
/**
 * 
 * @export
 * @interface UserProposalRequest
 */
export interface UserProposalRequest {
    /**
     * エージェントID
     * @type {number}
     * @memberof UserProposalRequest
     */
    agent_id?: number;
    /**
     * オファー発生経路
     * @type {string}
     * @memberof UserProposalRequest
     */
    source?: string;
}
/**
 * 
 * @export
 * @interface UserProposalResponse
 */
export interface UserProposalResponse {
    /**
     * 
     * @type {number}
     * @memberof UserProposalResponse
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserProposalResponse
     */
    is_target?: boolean | null;
}
/**
 * 
 * @export
 * @interface UserProposalWithRecommendationsResponse
 */
export interface UserProposalWithRecommendationsResponse {
    /**
     * 
     * @type {number}
     * @memberof UserProposalWithRecommendationsResponse
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserProposalWithRecommendationsResponse
     */
    is_target?: boolean | null;
    /**
     * 
     * @type {Array<Agent>}
     * @memberof UserProposalWithRecommendationsResponse
     */
    recommend_agents?: Array<Agent> | null;
}
/**
 * 
 * @export
 * @interface UserRegistrations
 */
export interface UserRegistrations {
    /**
     * 
     * @type {number}
     * @memberof UserRegistrations
     */
    id?: number;
    /**
     * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
     * @type {number}
     * @memberof UserRegistrations
     */
    score?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    family_name: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    family_name_kana: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    first_name_kana: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    is_enabled_email_notification?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    is_enabled_sms_notification?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    is_enabled_push_notification?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    phone_number: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    birthday?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserRegistrations
     */
    income_tax_rate?: number | null;
    /**
     * 
     * @type {JobCategory}
     * @memberof UserRegistrations
     */
    job_category?: JobCategory | null;
    /**
     * 住所（都道府県）
     * @type {string}
     * @memberof UserRegistrations
     */
    address_prefecture?: string | null;
    /**
     * 
     * @type {JobIndustry}
     * @memberof UserRegistrations
     */
    job_industry?: JobIndustry | null;
    /**
     * 
     * @type {Period}
     * @memberof UserRegistrations
     */
    job_continuous_period?: Period | null;
    /**
     * 登録日から現在までの経過期間を加味した推定勤続年数カテゴリ
     * @type {Period}
     * @memberof UserRegistrations
     */
    estimated_job_continuous_period?: Period | null;
    /**
     * 推定勤続年数カテゴリが実値と異なる場合にtrue
     * @type {boolean}
     * @memberof UserRegistrations
     */
    is_job_continuous_period_estimated?: boolean;
    /**
     * 
     * @type {MoneyAmount}
     * @memberof UserRegistrations
     */
    financial_asset?: MoneyAmount | null;
    /**
     * 年収
     * @type {number}
     * @memberof UserRegistrations
     */
    annual_income?: number | null;
    /**
     * 保有物件数(登録時の申告数)
     * @type {number}
     * @memberof UserRegistrations
     */
    holding_property_count?: number | null;
    /**
     * 保有物件数(アプリ内登録数)
     * @type {number}
     * @memberof UserRegistrations
     */
    registered_holding_property_count?: number | null;
    /**
     * 検討物件数(アプリ内登録数)
     * @type {number}
     * @memberof UserRegistrations
     */
    registered_considering_property_count?: number | null;
    /**
     * 不動産投資ローン残高合計
     * @type {number}
     * @memberof UserRegistrations
     */
    real_estate_loan_amount?: number | null;
    /**
     * 現在のお住まいマスタデータID
     * @type {number}
     * @memberof UserRegistrations
     */
    current_residence_type_id?: number | null;
    /**
     * 自宅毎月家賃額
     * @type {number}
     * @memberof UserRegistrations
     */
    monthly_rent_payment_amount?: number | null;
    /**
     * 住宅ローン残債合計
     * @type {number}
     * @memberof UserRegistrations
     */
    home_loan_amount?: number | null;
    /**
     * 
     * @type {ConsiderationPeriodEnum}
     * @memberof UserRegistrations
     */
    consideration_period?: ConsiderationPeriodEnum | null;
    /**
     * 
     * @type {PastMeetingCountEnum}
     * @memberof UserRegistrations
     */
    past_meeting_count?: PastMeetingCountEnum | null;
    /**
     * 検討中の物件
     * @type {string}
     * @memberof UserRegistrations
     */
    considering_property?: string | null;
    /**
     * 承認済みの金融機関
     * @type {string}
     * @memberof UserRegistrations
     */
    approved_financial_institutions?: string | null;
    /**
     * その他ご要望
     * @type {string}
     * @memberof UserRegistrations
     */
    other_request_text?: string | null;
    /**
     * 
     * @type {RegisteredStatusEnum}
     * @memberof UserRegistrations
     */
    data_first_registered_status?: RegisteredStatusEnum;
    /**
     * 不動産会社からの提案希望 false:希望しない true:希望する 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    request_the_proposal: boolean;
    /**
     * 提案の連絡方法 0:メール 1:LINE 
     * @type {number}
     * @memberof UserRegistrations
     */
    way_to_propose?: UserRegistrationsWayToProposeEnum;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof UserRegistrations
     */
    degree_of_consideration_for_investment?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof UserRegistrations
     */
    degree_of_consideration_for_sale?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    purpose_of_use_free_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    inflow_route_free_text?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    email_confirmed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserRegistrations
     */
    last_seen_announcement_id?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    has_unread_announcements?: boolean;
    /**
     * 投資力診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof UserRegistrations
     */
    is_diagnosis_complete?: boolean | null;
    /**
     * 投資スタイル診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof UserRegistrations
     */
    is_investment_style_diagnosis_complete?: boolean | null;
    /**
     * 広告計測確認用の登録なら true（プランナー通知・事務局オファー・プランナー一覧・登録KPIから除外。広告成果送信は維持し、確認完了後にIDを指定して物理削除する）
     * @type {boolean}
     * @memberof UserRegistrations
     */
    is_ad_measurement_test?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    password_confirmation: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    withdrawal_intended_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    last_accessed_at?: string | null;
    /**
     * ≒仮登録日
     * @type {string}
     * @memberof UserRegistrations
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    account_updated_at?: string;
    /**
     * 本登録日
     * @type {string}
     * @memberof UserRegistrations
     */
    account_registered_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    discarded_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    first_match_at?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserRegistrations
     */
    read_offers_count?: number;
    /**
     * 累計アクセス数（全月の合計）
     * @type {number}
     * @memberof UserRegistrations
     */
    total_access_count?: number | null;
    /**
     * 選択月のアクセス数
     * @type {number}
     * @memberof UserRegistrations
     */
    monthly_access_count?: number | null;
    /**
     * 選択月の日毎重複排除アクセス数
     * @type {number}
     * @memberof UserRegistrations
     */
    monthly_deduplication_access_count?: number | null;
    /**
     * 累計マッチ数の合計
     * @type {number}
     * @memberof UserRegistrations
     */
    matched_count_sum?: number;
    /**
     * マッチ種別「ユーザ」の累計マッチ数
     * @type {number}
     * @memberof UserRegistrations
     */
    matched_count_user?: number | null;
    /**
     * マッチ種別「投資」の累計マッチ数
     * @type {number}
     * @memberof UserRegistrations
     */
    matched_count_investment?: number | null;
    /**
     * マッチ種別「査定」の累計マッチ数
     * @type {number}
     * @memberof UserRegistrations
     */
    matched_count_assessment?: number | null;
    /**
     * マッチ種別「手動」の累計マッチ数
     * @type {number}
     * @memberof UserRegistrations
     */
    matched_count_manual?: number | null;
    /**
     * 学習コンテンツ既読数
     * @type {number}
     * @memberof UserRegistrations
     */
    learning_completed_count?: number | null;
    /**
     * 学習進捗率（既読数/全記事数）
     * @type {number}
     * @memberof UserRegistrations
     */
    learning_progress_rate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrations
     */
    adjust_network?: string | null;
    /**
     * 
     * @type {AdjustTracker}
     * @memberof UserRegistrations
     */
    adjust_tracker?: AdjustTracker;
    /**
     * 
     * @type {ReferralRefEnum}
     * @memberof UserRegistrations
     */
    referral_ref?: ReferralRefEnum | null;
    /**
     * 本登録日時(regular含む)
     * @type {string}
     * @memberof UserRegistrations
     */
    account_register_date?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserRegistrations
     */
    phone_number_auth_code: number;
    /**
     * 
     * @type {Array<AssessmentProposal>}
     * @memberof UserRegistrations
     */
    assessment_proposals?: Array<AssessmentProposal>;
    /**
     * 
     * @type {Array<InvestmentProposal>}
     * @memberof UserRegistrations
     */
    investment_proposals?: Array<InvestmentProposal>;
    /**
     * 
     * @type {Array<ProposalMatching>}
     * @memberof UserRegistrations
     */
    proposal_matchings?: Array<ProposalMatching>;
    /**
     * ユーザーがメッセージ詳細で「お断り」したプランナー（admin の fields=refusals で返す）
     * @type {Array<AgentMessageRefusal>}
     * @memberof UserRegistrations
     */
    agent_message_refusals?: Array<AgentMessageRefusal>;
    /**
     * 
     * @type {Array<ContractApplication>}
     * @memberof UserRegistrations
     */
    contract_applications?: Array<ContractApplication>;
    /**
     * 
     * @type {AdminUserMemo}
     * @memberof UserRegistrations
     */
    admin_user_memo?: AdminUserMemo;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserRegistrations
     */
    master_tags?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserRegistrations
     */
    master_purpose_of_uses?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserRegistrations
     */
    master_interested_property_types?: Array<Master>;
    /**
     * 関心のあるタグIDリスト
     * @type {Array<number>}
     * @memberof UserRegistrations
     */
    interest_tag_ids?: Array<number>;
    /**
     * 投資経験の有無（true/false）。2025-09-23(JST)以前に作成された既存データはNULL
     * @type {boolean}
     * @memberof UserRegistrations
     */
    has_investment_experience?: boolean | null;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserRegistrations
     */
    master_inflow_routes?: Array<Master>;
    /**
     * 
     * @type {Master}
     * @memberof UserRegistrations
     */
    current_residence_type?: Master | null;
    /**
     * 利用目的IDリスト
     * @type {Array<number>}
     * @memberof UserRegistrations
     */
    purpose_of_use_ids?: Array<number>;
    /**
     * 興味のある物件タイプIDリスト
     * @type {Array<number>}
     * @memberof UserRegistrations
     */
    interested_property_type_ids?: Array<number>;
    /**
     * 流入経路IDリスト
     * @type {Array<number>}
     * @memberof UserRegistrations
     */
    inflow_route_ids?: Array<number>;
    /**
     * 
     * @type {UserDeviceToken}
     * @memberof UserRegistrations
     */
    user_device_token?: UserDeviceToken;
    /**
     * 
     * @type {Array<UserAccessScreenLogMonthlySummary>}
     * @memberof UserRegistrations
     */
    user_access_screen_log_monthly_summaries?: Array<UserAccessScreenLogMonthlySummary>;
    /**
     * birthday から算出した年齢。birthday 未入力の場合は null
     * @type {number}
     * @memberof UserRegistrations
     */
    age?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    is_new_label?: boolean;
    /**
     * アクティブユーザーかどうか（最終ログインが3日以内）
     * @type {boolean}
     * @memberof UserRegistrations
     */
    is_active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserRegistrations
     */
    is_favorite?: boolean;
    /**
     * ローン残高合計
     * @type {number}
     * @memberof UserRegistrations
     */
    loan_amount?: number | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UserRegistrationsWayToProposeEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * 
 * @export
 * @interface UserRegistrationsApple
 */
export interface UserRegistrationsApple {
    /**
     * ソーシャルログイン時に受け取るレスポンス一式
     * @type {object}
     * @memberof UserRegistrationsApple
     */
    social_login_response: object;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrationsApple
     */
    phone_number: string;
    /**
     * 
     * @type {number}
     * @memberof UserRegistrationsApple
     */
    phone_number_auth_code: number;
}
/**
 * 
 * @export
 * @interface UserRegistrationsGoogle
 */
export interface UserRegistrationsGoogle {
    /**
     * ソーシャルログイン時に受け取るレスポンス一式
     * @type {object}
     * @memberof UserRegistrationsGoogle
     */
    social_login_response: object;
    /**
     * 
     * @type {string}
     * @memberof UserRegistrationsGoogle
     */
    phone_number: string;
    /**
     * 
     * @type {number}
     * @memberof UserRegistrationsGoogle
     */
    phone_number_auth_code: number;
}
/**
 * 
 * @export
 * @interface UserUpdate
 */
export interface UserUpdate {
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    id?: number;
    /**
     * Agent間で共有される評価点（1〜5）。 Adminの代理ログインでAgent APIを利用した場合、およびAdmin APIで返却される。 
     * @type {number}
     * @memberof UserUpdate
     */
    score?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    identifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    family_name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    family_name_kana?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    first_name_kana?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_enabled_email_notification?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_enabled_sms_notification?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_enabled_push_notification?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    phone_number?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    birthday?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    income_tax_rate?: number | null;
    /**
     * 
     * @type {JobCategory}
     * @memberof UserUpdate
     */
    job_category?: JobCategory | null;
    /**
     * 住所（都道府県）
     * @type {string}
     * @memberof UserUpdate
     */
    address_prefecture?: string | null;
    /**
     * 
     * @type {JobIndustry}
     * @memberof UserUpdate
     */
    job_industry?: JobIndustry | null;
    /**
     * 
     * @type {Period}
     * @memberof UserUpdate
     */
    job_continuous_period?: Period | null;
    /**
     * 登録日から現在までの経過期間を加味した推定勤続年数カテゴリ
     * @type {Period}
     * @memberof UserUpdate
     */
    estimated_job_continuous_period?: Period | null;
    /**
     * 推定勤続年数カテゴリが実値と異なる場合にtrue
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_job_continuous_period_estimated?: boolean;
    /**
     * 
     * @type {MoneyAmount}
     * @memberof UserUpdate
     */
    financial_asset?: MoneyAmount | null;
    /**
     * 年収
     * @type {number}
     * @memberof UserUpdate
     */
    annual_income?: number | null;
    /**
     * 保有物件数(登録時の申告数)
     * @type {number}
     * @memberof UserUpdate
     */
    holding_property_count?: number | null;
    /**
     * 保有物件数(アプリ内登録数)
     * @type {number}
     * @memberof UserUpdate
     */
    registered_holding_property_count?: number | null;
    /**
     * 検討物件数(アプリ内登録数)
     * @type {number}
     * @memberof UserUpdate
     */
    registered_considering_property_count?: number | null;
    /**
     * 不動産投資ローン残高合計
     * @type {number}
     * @memberof UserUpdate
     */
    real_estate_loan_amount?: number | null;
    /**
     * 現在のお住まいマスタデータID
     * @type {number}
     * @memberof UserUpdate
     */
    current_residence_type_id?: number | null;
    /**
     * 自宅毎月家賃額
     * @type {number}
     * @memberof UserUpdate
     */
    monthly_rent_payment_amount?: number | null;
    /**
     * 住宅ローン残債合計
     * @type {number}
     * @memberof UserUpdate
     */
    home_loan_amount?: number | null;
    /**
     * 
     * @type {ConsiderationPeriodEnum}
     * @memberof UserUpdate
     */
    consideration_period?: ConsiderationPeriodEnum | null;
    /**
     * 
     * @type {PastMeetingCountEnum}
     * @memberof UserUpdate
     */
    past_meeting_count?: PastMeetingCountEnum | null;
    /**
     * 検討中の物件
     * @type {string}
     * @memberof UserUpdate
     */
    considering_property?: string | null;
    /**
     * 承認済みの金融機関
     * @type {string}
     * @memberof UserUpdate
     */
    approved_financial_institutions?: string | null;
    /**
     * その他ご要望
     * @type {string}
     * @memberof UserUpdate
     */
    other_request_text?: string | null;
    /**
     * 
     * @type {RegisteredStatusEnum}
     * @memberof UserUpdate
     */
    data_first_registered_status?: RegisteredStatusEnum;
    /**
     * 不動産会社からの提案希望 false:希望しない true:希望する 
     * @type {boolean}
     * @memberof UserUpdate
     */
    request_the_proposal?: boolean;
    /**
     * 提案の連絡方法 0:メール 1:LINE 
     * @type {number}
     * @memberof UserUpdate
     */
    way_to_propose?: UserUpdateWayToProposeEnum;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof UserUpdate
     */
    degree_of_consideration_for_investment?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {DegreeOfConsiderationEnum}
     * @memberof UserUpdate
     */
    degree_of_consideration_for_sale?: DegreeOfConsiderationEnum | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    purpose_of_use_free_text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    inflow_route_free_text?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    email_confirmed?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    last_seen_announcement_id?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    has_unread_announcements?: boolean;
    /**
     * 投資力診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_diagnosis_complete?: boolean | null;
    /**
     * 投資スタイル診断完了フラグ(null=既存ユーザー, false=未完了, true=完了)
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_investment_style_diagnosis_complete?: boolean | null;
    /**
     * 広告計測確認用の登録なら true（プランナー通知・事務局オファー・プランナー一覧・登録KPIから除外。広告成果送信は維持し、確認完了後にIDを指定して物理削除する）
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_ad_measurement_test?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    password_confirmation?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    withdrawal_intended_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    last_accessed_at?: string | null;
    /**
     * ≒仮登録日
     * @type {string}
     * @memberof UserUpdate
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    updated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    account_updated_at?: string;
    /**
     * 本登録日
     * @type {string}
     * @memberof UserUpdate
     */
    account_registered_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    discarded_at?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    first_match_at?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    read_offers_count?: number;
    /**
     * 累計アクセス数（全月の合計）
     * @type {number}
     * @memberof UserUpdate
     */
    total_access_count?: number | null;
    /**
     * 選択月のアクセス数
     * @type {number}
     * @memberof UserUpdate
     */
    monthly_access_count?: number | null;
    /**
     * 選択月の日毎重複排除アクセス数
     * @type {number}
     * @memberof UserUpdate
     */
    monthly_deduplication_access_count?: number | null;
    /**
     * 累計マッチ数の合計
     * @type {number}
     * @memberof UserUpdate
     */
    matched_count_sum?: number;
    /**
     * マッチ種別「ユーザ」の累計マッチ数
     * @type {number}
     * @memberof UserUpdate
     */
    matched_count_user?: number | null;
    /**
     * マッチ種別「投資」の累計マッチ数
     * @type {number}
     * @memberof UserUpdate
     */
    matched_count_investment?: number | null;
    /**
     * マッチ種別「査定」の累計マッチ数
     * @type {number}
     * @memberof UserUpdate
     */
    matched_count_assessment?: number | null;
    /**
     * マッチ種別「手動」の累計マッチ数
     * @type {number}
     * @memberof UserUpdate
     */
    matched_count_manual?: number | null;
    /**
     * 学習コンテンツ既読数
     * @type {number}
     * @memberof UserUpdate
     */
    learning_completed_count?: number | null;
    /**
     * 学習進捗率（既読数/全記事数）
     * @type {number}
     * @memberof UserUpdate
     */
    learning_progress_rate?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UserUpdate
     */
    adjust_network?: string | null;
    /**
     * 
     * @type {AdjustTracker}
     * @memberof UserUpdate
     */
    adjust_tracker?: AdjustTracker;
    /**
     * 
     * @type {ReferralRefEnum}
     * @memberof UserUpdate
     */
    referral_ref?: ReferralRefEnum | null;
    /**
     * 本登録日時(regular含む)
     * @type {string}
     * @memberof UserUpdate
     */
    account_register_date?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UserUpdate
     */
    phone_number_auth_code?: number;
    /**
     * 
     * @type {Array<AssessmentProposal>}
     * @memberof UserUpdate
     */
    assessment_proposals?: Array<AssessmentProposal>;
    /**
     * 
     * @type {Array<InvestmentProposal>}
     * @memberof UserUpdate
     */
    investment_proposals?: Array<InvestmentProposal>;
    /**
     * 
     * @type {Array<ProposalMatching>}
     * @memberof UserUpdate
     */
    proposal_matchings?: Array<ProposalMatching>;
    /**
     * ユーザーがメッセージ詳細で「お断り」したプランナー（admin の fields=refusals で返す）
     * @type {Array<AgentMessageRefusal>}
     * @memberof UserUpdate
     */
    agent_message_refusals?: Array<AgentMessageRefusal>;
    /**
     * 
     * @type {Array<ContractApplication>}
     * @memberof UserUpdate
     */
    contract_applications?: Array<ContractApplication>;
    /**
     * 
     * @type {AdminUserMemo}
     * @memberof UserUpdate
     */
    admin_user_memo?: AdminUserMemo;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserUpdate
     */
    master_tags?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserUpdate
     */
    master_purpose_of_uses?: Array<Master>;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserUpdate
     */
    master_interested_property_types?: Array<Master>;
    /**
     * 関心のあるタグIDリスト
     * @type {Array<number>}
     * @memberof UserUpdate
     */
    interest_tag_ids?: Array<number>;
    /**
     * 投資経験の有無（true/false）。2025-09-23(JST)以前に作成された既存データはNULL
     * @type {boolean}
     * @memberof UserUpdate
     */
    has_investment_experience?: boolean | null;
    /**
     * 
     * @type {Array<Master>}
     * @memberof UserUpdate
     */
    master_inflow_routes?: Array<Master>;
    /**
     * 
     * @type {Master}
     * @memberof UserUpdate
     */
    current_residence_type?: Master | null;
    /**
     * 利用目的IDリスト
     * @type {Array<number>}
     * @memberof UserUpdate
     */
    purpose_of_use_ids?: Array<number>;
    /**
     * 興味のある物件タイプIDリスト
     * @type {Array<number>}
     * @memberof UserUpdate
     */
    interested_property_type_ids?: Array<number>;
    /**
     * 流入経路IDリスト
     * @type {Array<number>}
     * @memberof UserUpdate
     */
    inflow_route_ids?: Array<number>;
    /**
     * 
     * @type {UserDeviceToken}
     * @memberof UserUpdate
     */
    user_device_token?: UserDeviceToken;
    /**
     * 
     * @type {Array<UserAccessScreenLogMonthlySummary>}
     * @memberof UserUpdate
     */
    user_access_screen_log_monthly_summaries?: Array<UserAccessScreenLogMonthlySummary>;
    /**
     * birthday から算出した年齢。birthday 未入力の場合は null
     * @type {number}
     * @memberof UserUpdate
     */
    age?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_new_label?: boolean;
    /**
     * アクティブユーザーかどうか（最終ログインが3日以内）
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserUpdate
     */
    is_favorite?: boolean;
    /**
     * ローン残高合計
     * @type {number}
     * @memberof UserUpdate
     */
    loan_amount?: number | null;
}

/**
    * @export
    * @enum {string}
    */
export enum UserUpdateWayToProposeEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

/**
 * 
 * @export
 * @interface WebinarDetail
 */
export interface WebinarDetail {
    /**
     * 
     * @type {string}
     * @memberof WebinarDetail
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarDetail
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarDetail
     */
    description?: string | null;
    /**
     * 動画種別（youtube を優先。youtube_video_id があれば youtube）
     * @type {string}
     * @memberof WebinarDetail
     */
    video_type: WebinarDetailVideoTypeEnum;
    /**
     * YouTube動画ID（11文字）
     * @type {string}
     * @memberof WebinarDetail
     */
    youtube_video_id?: string | null;
    /**
     * 動画URL。video_type が s3 の場合は S3 の署名付き動画URL（15分有効）、youtube の場合は youtube-nocookie の embed ページURL。再生方法が異なるため、利用側は video_type で分岐すること
     * @type {string}
     * @memberof WebinarDetail
     */
    video_url?: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarDetail
     */
    thumbnail_url?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof WebinarDetail
     */
    highlight?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WebinarDetail
     */
    published_at?: string;
    /**
     * ウェビナーの属性タグ
     * @type {string}
     * @memberof WebinarDetail
     */
    tag?: WebinarDetailTagEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum WebinarDetailVideoTypeEnum {
    Youtube = 'youtube',
    S3 = 's3'
}
/**
    * @export
    * @enum {string}
    */
export enum WebinarDetailTagEnum {
    Beginner = 'beginner',
    Intermediate = 'intermediate',
    Advanced = 'advanced'
}

/**
 * 
 * @export
 * @interface WebinarSummary
 */
export interface WebinarSummary {
    /**
     * 
     * @type {string}
     * @memberof WebinarSummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarSummary
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarSummary
     */
    thumbnail_url?: string | null;
    /**
     * ウェビナーの属性タグ
     * @type {string}
     * @memberof WebinarSummary
     */
    tag?: WebinarSummaryTagEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum WebinarSummaryTagEnum {
    Beginner = 'beginner',
    Intermediate = 'intermediate',
    Advanced = 'advanced'
}

/**
 * 
 * @export
 * @interface WebinarViewing
 */
export interface WebinarViewing {
    /**
     * 
     * @type {string}
     * @memberof WebinarViewing
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WebinarViewing
     */
    webinar_id: string;
    /**
     * 
     * @type {number}
     * @memberof WebinarViewing
     */
    last_position_seconds: number;
    /**
     * 
     * @type {number}
     * @memberof WebinarViewing
     */
    furthest_position_seconds: number;
    /**
     * 
     * @type {number}
     * @memberof WebinarViewing
     */
    total_watched_seconds: number;
    /**
     * 
     * @type {boolean}
     * @memberof WebinarViewing
     */
    completed: boolean;
    /**
     * 
     * @type {string}
     * @memberof WebinarViewing
     */
    last_event_type?: WebinarViewingLastEventTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum WebinarViewingLastEventTypeEnum {
    Pause = 'pause',
    Ended = 'ended',
    Hidden = 'hidden',
    Progress = 'progress',
    Manual = 'manual',
    Conversion = 'conversion'
}

/**
 * 
 * @export
 * @interface WebinarViewingCreateRequest
 */
export interface WebinarViewingCreateRequest {
    /**
     * 視聴開始位置（今後の拡張用）
     * @type {number}
     * @memberof WebinarViewingCreateRequest
     */
    position_seconds?: number;
    /**
     * 動画尺（今後の拡張用）
     * @type {number}
     * @memberof WebinarViewingCreateRequest
     */
    duration_seconds?: number | null;
    /**
     * 既知の到達位置（今後の拡張用）
     * @type {number}
     * @memberof WebinarViewingCreateRequest
     */
    furthest_position_seconds?: number | null;
}
/**
 * 
 * @export
 * @interface WebinarViewingUpdateRequest
 */
export interface WebinarViewingUpdateRequest {
    /**
     * 
     * @type {number}
     * @memberof WebinarViewingUpdateRequest
     */
    position_seconds: number;
    /**
     * 
     * @type {number}
     * @memberof WebinarViewingUpdateRequest
     */
    total_watched_seconds?: number;
    /**
     * 
     * @type {boolean}
     * @memberof WebinarViewingUpdateRequest
     */
    completed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WebinarViewingUpdateRequest
     */
    event_type?: WebinarViewingUpdateRequestEventTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum WebinarViewingUpdateRequestEventTypeEnum {
    Pause = 'pause',
    Ended = 'ended',
    Hidden = 'hidden',
    Progress = 'progress',
    Manual = 'manual',
    Conversion = 'conversion'
}


/**
 * PropallyV1Api - axios parameter creator
 * @export
 */
export const PropallyV1ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ヘルスチェックエンドポイント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthzGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthz`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary エージェント詳細画面アクセス登録
         * @param {AgentDetailAccessLogRequest} agentDetailAccessLogRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentDetailAccessLogsPost: async (agentDetailAccessLogRequest: AgentDetailAccessLogRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentDetailAccessLogRequest' is not null or undefined
            if (agentDetailAccessLogRequest === null || agentDetailAccessLogRequest === undefined) {
                throw new RequiredError('agentDetailAccessLogRequest','Required parameter agentDetailAccessLogRequest was null or undefined when calling v1AgentDetailAccessLogsPost.');
            }
            const localVarPath = `/v1/agent_detail_access_logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof agentDetailAccessLogRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(agentDetailAccessLogRequest !== undefined ? agentDetailAccessLogRequest : {})
                : (agentDetailAccessLogRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary エージェント別投資提案サマリー一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentInvestmentProposalSummariesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/agent_investment_proposal_summaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary エージェントの連絡対応可能枠取得
         * @param {number} agentId エージェント ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsAgentIdAvailableContactSlotsGet: async (agentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            if (agentId === null || agentId === undefined) {
                throw new RequiredError('agentId','Required parameter agentId was null or undefined when calling v1AgentsAgentIdAvailableContactSlotsGet.');
            }
            const localVarPath = `/v1/agents/{agent_id}/available_contact_slots`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary エージェント取得
         * @param {number} agentId エージェント ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsAgentIdGet: async (agentId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            if (agentId === null || agentId === undefined) {
                throw new RequiredError('agentId','Required parameter agentId was null or undefined when calling v1AgentsAgentIdGet.');
            }
            const localVarPath = `/v1/agents/{agent_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 「入力内容にマッチ」「直近で高評価」「直近でアクティブ」の3セクションをまとめて取得する 
         * @summary 初回ロード用のエージェント検索結果をまとめて取得
         * @param {number} [perSectionPerPage] 各セクションの1ページあたり件数（初回）
         * @param {AgentSearchRequest} [agentSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsFeedsPost: async (perSectionPerPage?: number, agentSearchRequest?: AgentSearchRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/agents_feeds`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (perSectionPerPage !== undefined) {
                localVarQueryParameter['per_section_per_page'] = perSectionPerPage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof agentSearchRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(agentSearchRequest !== undefined ? agentSearchRequest : {})
                : (agentSearchRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary セクション毎の検索結果を追加で取得する
         * @param {'match' | 'top_rated' | 'active'} section セクション名
         * @param {number} [page] 取得したいページ番号（範囲外・型不一致はリクエスト検証により 400）
         * @param {number} [perPage] 1ページあたりの件数（範囲外・型不一致はリクエスト検証により 400）
         * @param {AgentsSortOptionEnum} [sort] 並び順。match セクションでのみ有効で、compatibility 指定時はログインユーザーとの相性順 （相性が算出できないエージェントは最後尾）。絞り込み後の母集団全体を相性順に並べたうえで ページングするため、ページを跨いでも並びが崩れない。 未指定時は従来の並び順（タグ指定ありはタグ一致数順、なしは id 降順）。 match 以外のセクションに指定した場合は無視する。enum 外の値はリクエスト検証により 400。 
         * @param {AgentSearchRequest} [agentSearchRequest] 検索条件。 match の追加ロードで正しく is_search を記録するには、クライアントが検索時の company_agent_search_tag_ids を再送する必要がある（再送しないと検索由来の表示が is_search: false になる） 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsFeedsSectionPost: async (section: 'match' | 'top_rated' | 'active', page?: number, perPage?: number, sort?: AgentsSortOptionEnum, agentSearchRequest?: AgentSearchRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'section' is not null or undefined
            if (section === null || section === undefined) {
                throw new RequiredError('section','Required parameter section was null or undefined when calling v1AgentsFeedsSectionPost.');
            }
            const localVarPath = `/v1/agents_feeds/{section}`
                .replace(`{${"section"}}`, encodeURIComponent(String(section)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof agentSearchRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(agentSearchRequest !== undefined ? agentSearchRequest : {})
                : (agentSearchRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary エージェント取得
         * @param {number} [page] 取得したいページ番号
         * @param {number} [perPage] 1ページあたりの件数（範囲外・型不一致はリクエスト検証により 400）
         * @param {AgentsSortOptionEnum} [sort] 並び順。compatibility 指定時はログインユーザーとの相性順（相性が算出できないエージェントは最後尾）。 未指定時は従来の並び順（id 降順）。enum 外の値はリクエスト検証により 400。 
         * @param {boolean} [includeAllPublic] 診断後のプランナー選択用。true かつ sort&#x3D;compatibility の場合、相性面・詳細条件検索の個別表示設定が両方ONの公開対象全員を相性順で返す。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsGet: async (page?: number, perPage?: number, sort?: AgentsSortOptionEnum, includeAllPublic?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (includeAllPublic !== undefined) {
                localVarQueryParameter['include_all_public'] = includeAllPublic;
            }


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary エージェント検索
         * @param {number} [page] 表示したいページ番号
         * @param {number} [perPage] 1ページあたりの件数
         * @param {AgentSearchRequest} [agentSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsSearchPost: async (page?: number, perPage?: number, agentSearchRequest?: AgentSearchRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/agents/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof agentSearchRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(agentSearchRequest !== undefined ? agentSearchRequest : {})
                : (agentSearchRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary アナウンス既読更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AnnouncementsReadPatch: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/announcements/read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 査定提案未読数取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalUnreadCountGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/assessment_proposal_unread_count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 査定提案承認or否承認実行
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {ProposalApprovedRequest} proposalApprovedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalsAssessmentProposalIdApprovedPatch: async (assessmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentProposalId' is not null or undefined
            if (assessmentProposalId === null || assessmentProposalId === undefined) {
                throw new RequiredError('assessmentProposalId','Required parameter assessmentProposalId was null or undefined when calling v1AssessmentProposalsAssessmentProposalIdApprovedPatch.');
            }
            // verify required parameter 'proposalApprovedRequest' is not null or undefined
            if (proposalApprovedRequest === null || proposalApprovedRequest === undefined) {
                throw new RequiredError('proposalApprovedRequest','Required parameter proposalApprovedRequest was null or undefined when calling v1AssessmentProposalsAssessmentProposalIdApprovedPatch.');
            }
            const localVarPath = `/v1/assessment_proposals/{assessment_proposal_id}/approved`
                .replace(`{${"assessment_proposal_id"}}`, encodeURIComponent(String(assessmentProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof proposalApprovedRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(proposalApprovedRequest !== undefined ? proposalApprovedRequest : {})
                : (proposalApprovedRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary エージェント・企業情報を含む査定提案詳細1件取得
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalsAssessmentProposalIdGet: async (assessmentProposalId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentProposalId' is not null or undefined
            if (assessmentProposalId === null || assessmentProposalId === undefined) {
                throw new RequiredError('assessmentProposalId','Required parameter assessmentProposalId was null or undefined when calling v1AssessmentProposalsAssessmentProposalIdGet.');
            }
            const localVarPath = `/v1/assessment_proposals/{assessment_proposal_id}`
                .replace(`{${"assessment_proposal_id"}}`, encodeURIComponent(String(assessmentProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 査定提案の希望連絡日程更新
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalsAssessmentProposalIdPreferredContactSchedulesPatch: async (assessmentProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentProposalId' is not null or undefined
            if (assessmentProposalId === null || assessmentProposalId === undefined) {
                throw new RequiredError('assessmentProposalId','Required parameter assessmentProposalId was null or undefined when calling v1AssessmentProposalsAssessmentProposalIdPreferredContactSchedulesPatch.');
            }
            // verify required parameter 'investmentProposalPreferredContactSchedulesRequest' is not null or undefined
            if (investmentProposalPreferredContactSchedulesRequest === null || investmentProposalPreferredContactSchedulesRequest === undefined) {
                throw new RequiredError('investmentProposalPreferredContactSchedulesRequest','Required parameter investmentProposalPreferredContactSchedulesRequest was null or undefined when calling v1AssessmentProposalsAssessmentProposalIdPreferredContactSchedulesPatch.');
            }
            const localVarPath = `/v1/assessment_proposals/{assessment_proposal_id}/preferred_contact_schedules`
                .replace(`{${"assessment_proposal_id"}}`, encodeURIComponent(String(assessmentProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof investmentProposalPreferredContactSchedulesRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(investmentProposalPreferredContactSchedulesRequest !== undefined ? investmentProposalPreferredContactSchedulesRequest : {})
                : (investmentProposalPreferredContactSchedulesRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 査定提案既読更新
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalsAssessmentProposalIdReadPatch: async (assessmentProposalId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'assessmentProposalId' is not null or undefined
            if (assessmentProposalId === null || assessmentProposalId === undefined) {
                throw new RequiredError('assessmentProposalId','Required parameter assessmentProposalId was null or undefined when calling v1AssessmentProposalsAssessmentProposalIdReadPatch.');
            }
            const localVarPath = `/v1/assessment_proposals/{assessment_proposal_id}/read`
                .replace(`{${"assessment_proposal_id"}}`, encodeURIComponent(String(assessmentProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 査定提案一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/assessment_proposals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Propally限定物件一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CompanyLimitedPropertiesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/company_limited_properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary メールアドレス確認
         * @param {InlineObject3} inlineObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1EmailConfirmationsPost: async (inlineObject3: InlineObject3, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject3' is not null or undefined
            if (inlineObject3 === null || inlineObject3 === undefined) {
                throw new RequiredError('inlineObject3','Required parameter inlineObject3 was null or undefined when calling v1EmailConfirmationsPost.');
            }
            const localVarPath = `/v1/email_confirmations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject3 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject3 !== undefined ? inlineObject3 : {})
                : (inlineObject3 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary HowMa(外部API)物件詳細(部屋情報一覧)API
         * @param {number} buildingId (HowMa管理の)マンションID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1HowmaBuildingsBuildingIdGet: async (buildingId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'buildingId' is not null or undefined
            if (buildingId === null || buildingId === undefined) {
                throw new RequiredError('buildingId','Required parameter buildingId was null or undefined when calling v1HowmaBuildingsBuildingIdGet.');
            }
            const localVarPath = `/v1/howma/buildings/{building_id}`
                .replace(`{${"building_id"}}`, encodeURIComponent(String(buildingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary HowMa(外部API)物件検索API
         * @param {HowMaBuildingsSearchRequest} howMaBuildingsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1HowmaBuildingsPost: async (howMaBuildingsSearchRequest: HowMaBuildingsSearchRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'howMaBuildingsSearchRequest' is not null or undefined
            if (howMaBuildingsSearchRequest === null || howMaBuildingsSearchRequest === undefined) {
                throw new RequiredError('howMaBuildingsSearchRequest','Required parameter howMaBuildingsSearchRequest was null or undefined when calling v1HowmaBuildingsPost.');
            }
            const localVarPath = `/v1/howma/buildings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof howMaBuildingsSearchRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(howMaBuildingsSearchRequest !== undefined ? howMaBuildingsSearchRequest : {})
                : (howMaBuildingsSearchRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 投資提案の対エージェントステータス更新
         * @param {InvestmentProposalStatusUpdateRequest} investmentProposalStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalStatusPatch: async (investmentProposalStatusUpdateRequest: InvestmentProposalStatusUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investmentProposalStatusUpdateRequest' is not null or undefined
            if (investmentProposalStatusUpdateRequest === null || investmentProposalStatusUpdateRequest === undefined) {
                throw new RequiredError('investmentProposalStatusUpdateRequest','Required parameter investmentProposalStatusUpdateRequest was null or undefined when calling v1InvestmentProposalStatusPatch.');
            }
            const localVarPath = `/v1/investment_proposal_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof investmentProposalStatusUpdateRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(investmentProposalStatusUpdateRequest !== undefined ? investmentProposalStatusUpdateRequest : {})
                : (investmentProposalStatusUpdateRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 投資提案未読数取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalUnreadCountGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/investment_proposal_unread_count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 投資提案一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/investment_proposals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 投資提案承認or否承認実行
         * @param {number} investmentProposalId 投資提案 ID
         * @param {ProposalApprovedRequest} proposalApprovedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdApprovedPatch: async (investmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investmentProposalId' is not null or undefined
            if (investmentProposalId === null || investmentProposalId === undefined) {
                throw new RequiredError('investmentProposalId','Required parameter investmentProposalId was null or undefined when calling v1InvestmentProposalsInvestmentProposalIdApprovedPatch.');
            }
            // verify required parameter 'proposalApprovedRequest' is not null or undefined
            if (proposalApprovedRequest === null || proposalApprovedRequest === undefined) {
                throw new RequiredError('proposalApprovedRequest','Required parameter proposalApprovedRequest was null or undefined when calling v1InvestmentProposalsInvestmentProposalIdApprovedPatch.');
            }
            const localVarPath = `/v1/investment_proposals/{investment_proposal_id}/approved`
                .replace(`{${"investment_proposal_id"}}`, encodeURIComponent(String(investmentProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof proposalApprovedRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(proposalApprovedRequest !== undefined ? proposalApprovedRequest : {})
                : (proposalApprovedRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 投資提案承認or否承認実行（追加マッチング候補付き）
         * @param {number} investmentProposalId 投資提案 ID
         * @param {ProposalApprovedRequest} proposalApprovedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdApprovedWithRecommendationsPatch: async (investmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investmentProposalId' is not null or undefined
            if (investmentProposalId === null || investmentProposalId === undefined) {
                throw new RequiredError('investmentProposalId','Required parameter investmentProposalId was null or undefined when calling v1InvestmentProposalsInvestmentProposalIdApprovedWithRecommendationsPatch.');
            }
            // verify required parameter 'proposalApprovedRequest' is not null or undefined
            if (proposalApprovedRequest === null || proposalApprovedRequest === undefined) {
                throw new RequiredError('proposalApprovedRequest','Required parameter proposalApprovedRequest was null or undefined when calling v1InvestmentProposalsInvestmentProposalIdApprovedWithRecommendationsPatch.');
            }
            const localVarPath = `/v1/investment_proposals/{investment_proposal_id}/approved_with_recommendations`
                .replace(`{${"investment_proposal_id"}}`, encodeURIComponent(String(investmentProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof proposalApprovedRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(proposalApprovedRequest !== undefined ? proposalApprovedRequest : {})
                : (proposalApprovedRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 投資提案詳細1件取得
         * @param {number} investmentProposalId 投資提案 ID
         * @param {boolean} [hasHistory] 過去の投資提案も取得するフラグ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdGet: async (investmentProposalId: number, hasHistory?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investmentProposalId' is not null or undefined
            if (investmentProposalId === null || investmentProposalId === undefined) {
                throw new RequiredError('investmentProposalId','Required parameter investmentProposalId was null or undefined when calling v1InvestmentProposalsInvestmentProposalIdGet.');
            }
            const localVarPath = `/v1/investment_proposals/{investment_proposal_id}`
                .replace(`{${"investment_proposal_id"}}`, encodeURIComponent(String(investmentProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (hasHistory !== undefined) {
                localVarQueryParameter['has_history'] = hasHistory;
            }


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 投資提案の希望連絡日程更新
         * @param {number} investmentProposalId 投資提案 ID
         * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdPreferredContactSchedulesPatch: async (investmentProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investmentProposalId' is not null or undefined
            if (investmentProposalId === null || investmentProposalId === undefined) {
                throw new RequiredError('investmentProposalId','Required parameter investmentProposalId was null or undefined when calling v1InvestmentProposalsInvestmentProposalIdPreferredContactSchedulesPatch.');
            }
            // verify required parameter 'investmentProposalPreferredContactSchedulesRequest' is not null or undefined
            if (investmentProposalPreferredContactSchedulesRequest === null || investmentProposalPreferredContactSchedulesRequest === undefined) {
                throw new RequiredError('investmentProposalPreferredContactSchedulesRequest','Required parameter investmentProposalPreferredContactSchedulesRequest was null or undefined when calling v1InvestmentProposalsInvestmentProposalIdPreferredContactSchedulesPatch.');
            }
            const localVarPath = `/v1/investment_proposals/{investment_proposal_id}/preferred_contact_schedules`
                .replace(`{${"investment_proposal_id"}}`, encodeURIComponent(String(investmentProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof investmentProposalPreferredContactSchedulesRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(investmentProposalPreferredContactSchedulesRequest !== undefined ? investmentProposalPreferredContactSchedulesRequest : {})
                : (investmentProposalPreferredContactSchedulesRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 投資提案既読更新
         * @param {number} investmentProposalId 投資提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdReadPatch: async (investmentProposalId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investmentProposalId' is not null or undefined
            if (investmentProposalId === null || investmentProposalId === undefined) {
                throw new RequiredError('investmentProposalId','Required parameter investmentProposalId was null or undefined when calling v1InvestmentProposalsInvestmentProposalIdReadPatch.');
            }
            const localVarPath = `/v1/investment_proposals/{investment_proposal_id}/read`
                .replace(`{${"investment_proposal_id"}}`, encodeURIComponent(String(investmentProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * メッセージ詳細の「お断り」。お断りの単位はメッセージではなくプランナーで、 以後そのプランナーからのメッセージ（過去分も含む）は一覧・詳細・未読件数・通知に出なくなる。解除はできない。 お断り済みのプランナーのメッセージに再度呼んでも 200 を返す（冪等）。 
         * @summary 投資提案の送信元プランナーをお断り
         * @param {number} investmentProposalId 投資提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdRefusalPost: async (investmentProposalId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investmentProposalId' is not null or undefined
            if (investmentProposalId === null || investmentProposalId === undefined) {
                throw new RequiredError('investmentProposalId','Required parameter investmentProposalId was null or undefined when calling v1InvestmentProposalsInvestmentProposalIdRefusalPost.');
            }
            const localVarPath = `/v1/investment_proposals/{investment_proposal_id}/refusal`
                .replace(`{${"investment_proposal_id"}}`, encodeURIComponent(String(investmentProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 投資スタイル診断の結果取得（本人）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentStyleDiagnosisGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/investment_style_diagnosis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 投資スタイル診断の回答送信・結果取得
         * @param {InvestmentStyleDiagnosisRequest} investmentStyleDiagnosisRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentStyleDiagnosisPost: async (investmentStyleDiagnosisRequest: InvestmentStyleDiagnosisRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'investmentStyleDiagnosisRequest' is not null or undefined
            if (investmentStyleDiagnosisRequest === null || investmentStyleDiagnosisRequest === undefined) {
                throw new RequiredError('investmentStyleDiagnosisRequest','Required parameter investmentStyleDiagnosisRequest was null or undefined when calling v1InvestmentStyleDiagnosisPost.');
            }
            const localVarPath = `/v1/investment_style_diagnosis`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof investmentStyleDiagnosisRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(investmentStyleDiagnosisRequest !== undefined ? investmentStyleDiagnosisRequest : {})
                : (investmentStyleDiagnosisRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 学習記事を達成済みに登録
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LearningArticlesArticleIdCompletePost: async (articleId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            if (articleId === null || articleId === undefined) {
                throw new RequiredError('articleId','Required parameter articleId was null or undefined when calling v1LearningArticlesArticleIdCompletePost.');
            }
            const localVarPath = `/v1/learning_articles/{article_id}/complete`
                .replace(`{${"article_id"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 学習記事の達成状況を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LearningArticlesStatusesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/learning_articles/statuses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Appleアカウントでログイン
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LoginApplePost: async (inlineObject2: InlineObject2, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject2' is not null or undefined
            if (inlineObject2 === null || inlineObject2 === undefined) {
                throw new RequiredError('inlineObject2','Required parameter inlineObject2 was null or undefined when calling v1LoginApplePost.');
            }
            const localVarPath = `/v1/login_apple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject2 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject2 !== undefined ? inlineObject2 : {})
                : (inlineObject2 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Googleアカウントでログイン
         * @param {InlineObject1} inlineObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LoginGooglePost: async (inlineObject1: InlineObject1, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject1' is not null or undefined
            if (inlineObject1 === null || inlineObject1 === undefined) {
                throw new RequiredError('inlineObject1','Required parameter inlineObject1 was null or undefined when calling v1LoginGooglePost.');
            }
            const localVarPath = `/v1/login_google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject1 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject1 !== undefined ? inlineObject1 : {})
                : (inlineObject1 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログイン
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LoginPost: async (inlineObject: InlineObject, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject' is not null or undefined
            if (inlineObject === null || inlineObject === undefined) {
                throw new RequiredError('inlineObject','Required parameter inlineObject was null or undefined when calling v1LoginPost.');
            }
            const localVarPath = `/v1/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject !== undefined ? inlineObject : {})
                : (inlineObject || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LogoutPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary エージェント検索タグマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataAgentSearchTagsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/master_data/agent_search_tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 流入経路マスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataInflowRoutesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/master_data/inflow_routes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 興味のある物件タイプマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataInterestedPropertyTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/master_data/interested_property_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 都道府県一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataPrefecturesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/master_data/prefectures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 町丁目一覧
         * @param {string} prefectureName 都道府県名
         * @param {string} cityName 市区町村名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet: async (prefectureName: string, cityName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefectureName' is not null or undefined
            if (prefectureName === null || prefectureName === undefined) {
                throw new RequiredError('prefectureName','Required parameter prefectureName was null or undefined when calling v1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet.');
            }
            // verify required parameter 'cityName' is not null or undefined
            if (cityName === null || cityName === undefined) {
                throw new RequiredError('cityName','Required parameter cityName was null or undefined when calling v1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet.');
            }
            const localVarPath = `/v1/master_data/prefectures/{prefecture_name}/cities/{city_name}/towns`
                .replace(`{${"prefecture_name"}}`, encodeURIComponent(String(prefectureName)))
                .replace(`{${"city_name"}}`, encodeURIComponent(String(cityName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 市区町村一覧
         * @param {string} prefectureName 都道府県名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataPrefecturesPrefectureNameCitiesGet: async (prefectureName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'prefectureName' is not null or undefined
            if (prefectureName === null || prefectureName === undefined) {
                throw new RequiredError('prefectureName','Required parameter prefectureName was null or undefined when calling v1MasterDataPrefecturesPrefectureNameCitiesGet.');
            }
            const localVarPath = `/v1/master_data/prefectures/{prefecture_name}/cities`
                .replace(`{${"prefecture_name"}}`, encodeURIComponent(String(prefectureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 利用目的マスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataPurposeOfUsesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/master_data/purpose_of_uses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 鉄道一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataRailwaysGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/master_data/railways`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 駅名一覧
         * @param {string} railwayName 鉄道名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataRailwaysRailwayNameStationsGet: async (railwayName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'railwayName' is not null or undefined
            if (railwayName === null || railwayName === undefined) {
                throw new RequiredError('railwayName','Required parameter railwayName was null or undefined when calling v1MasterDataRailwaysRailwayNameStationsGet.');
            }
            const localVarPath = `/v1/master_data/railways/{railway_name}/stations`
                .replace(`{${"railway_name"}}`, encodeURIComponent(String(railwayName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 居住タイプマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataResidenceTypesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/master_data/residence_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary タグマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataTagsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/master_data/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 最低アプリバージョン取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MinAppVersionGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/min_app_version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 三井住友海上営業リストにユーザを登録
         * @param {MsinsLeadEntry} msinsLeadEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MsinsLeadsPost: async (msinsLeadEntry: MsinsLeadEntry, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'msinsLeadEntry' is not null or undefined
            if (msinsLeadEntry === null || msinsLeadEntry === undefined) {
                throw new RequiredError('msinsLeadEntry','Required parameter msinsLeadEntry was null or undefined when calling v1MsinsLeadsPost.');
            }
            const localVarPath = `/v1/msins_leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof msinsLeadEntry !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(msinsLeadEntry !== undefined ? msinsLeadEntry : {})
                : (msinsLeadEntry || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary リセット後、新しいパスワードの登録
         * @param {InlineObject6} inlineObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1NewPasswordsPost: async (inlineObject6: InlineObject6, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject6' is not null or undefined
            if (inlineObject6 === null || inlineObject6 === undefined) {
                throw new RequiredError('inlineObject6','Required parameter inlineObject6 was null or undefined when calling v1NewPasswordsPost.');
            }
            const localVarPath = `/v1/new_passwords`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject6 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject6 !== undefined ? inlineObject6 : {})
                : (inlineObject6 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 初回物件登録時エージェント通知
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1NotificationsToAgentForNewPropertyPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications/to_agent/for_new_property`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザSTEP1登録時エージェント通知
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1NotificationsToAgentForNewUserPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/notifications/to_agent/for_new_user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary パスワードリセット
         * @param {InlineObject5} inlineObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PasswordResetsPost: async (inlineObject5: InlineObject5, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject5' is not null or undefined
            if (inlineObject5 === null || inlineObject5 === undefined) {
                throw new RequiredError('inlineObject5','Required parameter inlineObject5 was null or undefined when calling v1PasswordResetsPost.');
            }
            const localVarPath = `/v1/password_resets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject5 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject5 !== undefined ? inlineObject5 : {})
                : (inlineObject5 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 現行プライバシーポリシーへの同意状態と本文を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivacyPolicyConsentGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/privacy_policy_consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 現行プライバシーポリシーへの同意を記録
         * @param {PrivacyPolicyConsentCreateRequest} privacyPolicyConsentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivacyPolicyConsentPost: async (privacyPolicyConsentCreateRequest: PrivacyPolicyConsentCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'privacyPolicyConsentCreateRequest' is not null or undefined
            if (privacyPolicyConsentCreateRequest === null || privacyPolicyConsentCreateRequest === undefined) {
                throw new RequiredError('privacyPolicyConsentCreateRequest','Required parameter privacyPolicyConsentCreateRequest was null or undefined when calling v1PrivacyPolicyConsentPost.');
            }
            const localVarPath = `/v1/privacy_policy_consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof privacyPolicyConsentCreateRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(privacyPolicyConsentCreateRequest !== undefined ? privacyPolicyConsentCreateRequest : {})
                : (privacyPolicyConsentCreateRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
         * @summary マンション名からAI補完して検討物件を登録
         * @param {InlineObject9} inlineObject9 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiCreateConsiderationPost: async (inlineObject9: InlineObject9, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject9' is not null or undefined
            if (inlineObject9 === null || inlineObject9 === undefined) {
                throw new RequiredError('inlineObject9','Required parameter inlineObject9 was null or undefined when calling v1PropertiesAiCreateConsiderationPost.');
            }
            const localVarPath = `/v1/properties/ai_create_consideration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject9 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject9 !== undefined ? inlineObject9 : {})
                : (inlineObject9 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
         * @summary マンション名からAI補完して保有物件を登録
         * @param {InlineObject8} inlineObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiCreateOwnPost: async (inlineObject8: InlineObject8, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject8' is not null or undefined
            if (inlineObject8 === null || inlineObject8 === undefined) {
                throw new RequiredError('inlineObject8','Required parameter inlineObject8 was null or undefined when calling v1PropertiesAiCreateOwnPost.');
            }
            const localVarPath = `/v1/properties/ai_create_own`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject8 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject8 !== undefined ? inlineObject8 : {})
                : (inlineObject8 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
         * @summary マンション名からAI補完して物件登録
         * @param {InlineObject7} inlineObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiCreatePost: async (inlineObject7: InlineObject7, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject7' is not null or undefined
            if (inlineObject7 === null || inlineObject7 === undefined) {
                throw new RequiredError('inlineObject7','Required parameter inlineObject7 was null or undefined when calling v1PropertiesAiCreatePost.');
            }
            const localVarPath = `/v1/properties/ai_create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject7 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject7 !== undefined ? inlineObject7 : {})
                : (inlineObject7 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 書類PDF/画像をOCRして検討物件の下書きを作成（推定なし）
         * @param {InlineObject13} inlineObject13 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiDraftConsiderationDocumentPost: async (inlineObject13: InlineObject13, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject13' is not null or undefined
            if (inlineObject13 === null || inlineObject13 === undefined) {
                throw new RequiredError('inlineObject13','Required parameter inlineObject13 was null or undefined when calling v1PropertiesAiDraftConsiderationDocumentPost.');
            }
            const localVarPath = `/v1/properties/ai_draft_consideration_document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject13 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject13 !== undefined ? inlineObject13 : {})
                : (inlineObject13 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary マンション名からAI補完して検討物件の下書きを作成
         * @param {InlineObject12} inlineObject12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiDraftConsiderationPost: async (inlineObject12: InlineObject12, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject12' is not null or undefined
            if (inlineObject12 === null || inlineObject12 === undefined) {
                throw new RequiredError('inlineObject12','Required parameter inlineObject12 was null or undefined when calling v1PropertiesAiDraftConsiderationPost.');
            }
            const localVarPath = `/v1/properties/ai_draft_consideration`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject12 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject12 !== undefined ? inlineObject12 : {})
                : (inlineObject12 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 書類PDF/画像をOCRして保有物件の下書きを作成（推定なし）
         * @param {InlineObject11} inlineObject11 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiDraftOwnDocumentPost: async (inlineObject11: InlineObject11, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject11' is not null or undefined
            if (inlineObject11 === null || inlineObject11 === undefined) {
                throw new RequiredError('inlineObject11','Required parameter inlineObject11 was null or undefined when calling v1PropertiesAiDraftOwnDocumentPost.');
            }
            const localVarPath = `/v1/properties/ai_draft_own_document`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject11 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject11 !== undefined ? inlineObject11 : {})
                : (inlineObject11 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary マンション名からAI補完して保有物件の下書きを作成
         * @param {InlineObject10} inlineObject10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiDraftOwnPost: async (inlineObject10: InlineObject10, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject10' is not null or undefined
            if (inlineObject10 === null || inlineObject10 === undefined) {
                throw new RequiredError('inlineObject10','Required parameter inlineObject10 was null or undefined when calling v1PropertiesAiDraftOwnPost.');
            }
            const localVarPath = `/v1/properties/ai_draft_own`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject10 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject10 !== undefined ? inlineObject10 : {})
                : (inlineObject10 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 返済期間は1〜50年の整数（借入なしの場合のみ0年も可）、金利は0〜100%です。借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。不整合時は関連データも保存せず422を返します。AI補完した登録にも同じ制約を適用します。
         * @summary 物件登録
         * @param {PropertyBuilder} propertyBuilder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPost: async (propertyBuilder: PropertyBuilder, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyBuilder' is not null or undefined
            if (propertyBuilder === null || propertyBuilder === undefined) {
                throw new RequiredError('propertyBuilder','Required parameter propertyBuilder was null or undefined when calling v1PropertiesPost.');
            }
            const localVarPath = `/v1/properties`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof propertyBuilder !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(propertyBuilder !== undefined ? propertyBuilder : {})
                : (propertyBuilder || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary AIおまかせ入力のお知らせ閉じ状態を更新
         * @param {number} propertyId 物件 ID
         * @param {PropertyAiCreateNotificationDismissedRequest} propertyAiCreateNotificationDismissedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdAiCreateNotificationDismissedPatch: async (propertyId: number, propertyAiCreateNotificationDismissedRequest: PropertyAiCreateNotificationDismissedRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdAiCreateNotificationDismissedPatch.');
            }
            // verify required parameter 'propertyAiCreateNotificationDismissedRequest' is not null or undefined
            if (propertyAiCreateNotificationDismissedRequest === null || propertyAiCreateNotificationDismissedRequest === undefined) {
                throw new RequiredError('propertyAiCreateNotificationDismissedRequest','Required parameter propertyAiCreateNotificationDismissedRequest was null or undefined when calling v1PropertiesPropertyIdAiCreateNotificationDismissedPatch.');
            }
            const localVarPath = `/v1/properties/{property_id}/ai_create_notification_dismissed`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof propertyAiCreateNotificationDismissedRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(propertyAiCreateNotificationDismissedRequest !== undefined ? propertyAiCreateNotificationDismissedRequest : {})
                : (propertyAiCreateNotificationDismissedRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 一棟物件の部屋の削除
         * @param {number} propertyId 物件 ID
         * @param {number} buildingRoomId 部屋ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdDelete: async (propertyId: number, buildingRoomId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdDelete.');
            }
            // verify required parameter 'buildingRoomId' is not null or undefined
            if (buildingRoomId === null || buildingRoomId === undefined) {
                throw new RequiredError('buildingRoomId','Required parameter buildingRoomId was null or undefined when calling v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdDelete.');
            }
            const localVarPath = `/v1/properties/{property_id}/building_rooms/{building_room_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"building_room_id"}}`, encodeURIComponent(String(buildingRoomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 一棟物件の部屋ごとの情報更新
         * @param {number} propertyId 物件 ID
         * @param {number} buildingRoomId 部屋ID
         * @param {BuildingRoom} buildingRoom 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdPatch: async (propertyId: number, buildingRoomId: number, buildingRoom: BuildingRoom, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdPatch.');
            }
            // verify required parameter 'buildingRoomId' is not null or undefined
            if (buildingRoomId === null || buildingRoomId === undefined) {
                throw new RequiredError('buildingRoomId','Required parameter buildingRoomId was null or undefined when calling v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdPatch.');
            }
            // verify required parameter 'buildingRoom' is not null or undefined
            if (buildingRoom === null || buildingRoom === undefined) {
                throw new RequiredError('buildingRoom','Required parameter buildingRoom was null or undefined when calling v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdPatch.');
            }
            const localVarPath = `/v1/properties/{property_id}/building_rooms/{building_room_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"building_room_id"}}`, encodeURIComponent(String(buildingRoomId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof buildingRoom !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(buildingRoom !== undefined ? buildingRoom : {})
                : (buildingRoom || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 一棟物件の部屋ごとの情報取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdBuildingRoomsGet: async (propertyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdBuildingRoomsGet.');
            }
            const localVarPath = `/v1/properties/{property_id}/building_rooms`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 一棟物件の部屋ごとの情報登録
         * @param {number} propertyId 物件 ID
         * @param {BuildingRoom} buildingRoom 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdBuildingRoomsPost: async (propertyId: number, buildingRoom: BuildingRoom, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdBuildingRoomsPost.');
            }
            // verify required parameter 'buildingRoom' is not null or undefined
            if (buildingRoom === null || buildingRoom === undefined) {
                throw new RequiredError('buildingRoom','Required parameter buildingRoom was null or undefined when calling v1PropertiesPropertyIdBuildingRoomsPost.');
            }
            const localVarPath = `/v1/properties/{property_id}/building_rooms`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof buildingRoom !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(buildingRoom !== undefined ? buildingRoom : {})
                : (buildingRoom || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件削除
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDelete: async (propertyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdDelete.');
            }
            const localVarPath = `/v1/properties/{property_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントの削除
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdDelete: async (propertyId: number, documentType: DocumentType, fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdDelete.');
            }
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdDelete.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdDelete.');
            }
            const localVarPath = `/v1/properties/{property_id}/documents/{document_type}/files/{file_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"document_type"}}`, encodeURIComponent(String(documentType)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントのファイルバイナリ取得
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdGet: async (propertyId: number, documentType: DocumentType, fileId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdGet.');
            }
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdGet.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdGet.');
            }
            const localVarPath = `/v1/properties/{property_id}/documents/{document_type}/files/{file_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"document_type"}}`, encodeURIComponent(String(documentType)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ドキュメント更新
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {DocumentForm} documentForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch: async (propertyId: number, documentType: DocumentType, fileId: number, documentForm: DocumentForm, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch.');
            }
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch.');
            }
            // verify required parameter 'documentForm' is not null or undefined
            if (documentForm === null || documentForm === undefined) {
                throw new RequiredError('documentForm','Required parameter documentForm was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch.');
            }
            const localVarPath = `/v1/properties/{property_id}/documents/{document_type}/files/{file_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"document_type"}}`, encodeURIComponent(String(documentType)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof documentForm !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(documentForm !== undefined ? documentForm : {})
                : (documentForm || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントのURLを署名とヘッダー付きで取得
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {string} filename ファイル名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet: async (propertyId: number, documentType: DocumentType, fileId: number, filename: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet.');
            }
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet.');
            }
            // verify required parameter 'fileId' is not null or undefined
            if (fileId === null || fileId === undefined) {
                throw new RequiredError('fileId','Required parameter fileId was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet.');
            }
            // verify required parameter 'filename' is not null or undefined
            if (filename === null || filename === undefined) {
                throw new RequiredError('filename','Required parameter filename was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet.');
            }
            const localVarPath = `/v1/properties/{property_id}/documents/{document_type}/files/{file_id}/url`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"document_type"}}`, encodeURIComponent(String(documentType)))
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filename !== undefined) {
                localVarQueryParameter['filename'] = filename;
            }


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントの一覧取得
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesGet: async (propertyId: number, documentType: DocumentType, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesGet.');
            }
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesGet.');
            }
            const localVarPath = `/v1/properties/{property_id}/documents/{document_type}/files`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"document_type"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントの登録
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {Base64EncodedImage} base64EncodedImage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesPost: async (propertyId: number, documentType: DocumentType, base64EncodedImage: Base64EncodedImage, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesPost.');
            }
            // verify required parameter 'documentType' is not null or undefined
            if (documentType === null || documentType === undefined) {
                throw new RequiredError('documentType','Required parameter documentType was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesPost.');
            }
            // verify required parameter 'base64EncodedImage' is not null or undefined
            if (base64EncodedImage === null || base64EncodedImage === undefined) {
                throw new RequiredError('base64EncodedImage','Required parameter base64EncodedImage was null or undefined when calling v1PropertiesPropertyIdDocumentsDocumentTypeFilesPost.');
            }
            const localVarPath = `/v1/properties/{property_id}/documents/{document_type}/files`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"document_type"}}`, encodeURIComponent(String(documentType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof base64EncodedImage !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(base64EncodedImage !== undefined ? base64EncodedImage : {})
                : (base64EncodedImage || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件に紐づく画像の削除
         * @param {number} propertyId 物件 ID
         * @param {number} imageId 画像 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdImagesImageIdDelete: async (propertyId: number, imageId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdImagesImageIdDelete.');
            }
            // verify required parameter 'imageId' is not null or undefined
            if (imageId === null || imageId === undefined) {
                throw new RequiredError('imageId','Required parameter imageId was null or undefined when calling v1PropertiesPropertyIdImagesImageIdDelete.');
            }
            const localVarPath = `/v1/properties/{property_id}/images/{image_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"image_id"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件に紐づく画像ごとの URL 取得
         * @param {number} propertyId 物件 ID
         * @param {number} imageId 画像 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdImagesImageIdUrlGet: async (propertyId: number, imageId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdImagesImageIdUrlGet.');
            }
            // verify required parameter 'imageId' is not null or undefined
            if (imageId === null || imageId === undefined) {
                throw new RequiredError('imageId','Required parameter imageId was null or undefined when calling v1PropertiesPropertyIdImagesImageIdUrlGet.');
            }
            const localVarPath = `/v1/properties/{property_id}/images/{image_id}/url`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"image_id"}}`, encodeURIComponent(String(imageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件ごとの画像登録
         * @param {number} propertyId 物件 ID
         * @param {Base64EncodedImage} base64EncodedImage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdImagesPost: async (propertyId: number, base64EncodedImage: Base64EncodedImage, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdImagesPost.');
            }
            // verify required parameter 'base64EncodedImage' is not null or undefined
            if (base64EncodedImage === null || base64EncodedImage === undefined) {
                throw new RequiredError('base64EncodedImage','Required parameter base64EncodedImage was null or undefined when calling v1PropertiesPropertyIdImagesPost.');
            }
            const localVarPath = `/v1/properties/{property_id}/images`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof base64EncodedImage !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(base64EncodedImage !== undefined ? base64EncodedImage : {})
                : (base64EncodedImage || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdLeaseContractsGet: async (propertyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdLeaseContractsGet.');
            }
            const localVarPath = `/v1/properties/{property_id}/lease_contracts`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約削除
         * @param {number} propertyId 物件 ID
         * @param {number} leaseContractId 賃貸契約ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdLeaseContractsLeaseContractIdDelete: async (propertyId: number, leaseContractId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdLeaseContractsLeaseContractIdDelete.');
            }
            // verify required parameter 'leaseContractId' is not null or undefined
            if (leaseContractId === null || leaseContractId === undefined) {
                throw new RequiredError('leaseContractId','Required parameter leaseContractId was null or undefined when calling v1PropertiesPropertyIdLeaseContractsLeaseContractIdDelete.');
            }
            const localVarPath = `/v1/properties/{property_id}/lease_contracts/{lease_contract_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"lease_contract_id"}}`, encodeURIComponent(String(leaseContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約更新
         * @param {number} propertyId 物件 ID
         * @param {number} leaseContractId 賃貸契約ID
         * @param {LeaseContract} leaseContract 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdLeaseContractsLeaseContractIdPatch: async (propertyId: number, leaseContractId: number, leaseContract: LeaseContract, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdLeaseContractsLeaseContractIdPatch.');
            }
            // verify required parameter 'leaseContractId' is not null or undefined
            if (leaseContractId === null || leaseContractId === undefined) {
                throw new RequiredError('leaseContractId','Required parameter leaseContractId was null or undefined when calling v1PropertiesPropertyIdLeaseContractsLeaseContractIdPatch.');
            }
            // verify required parameter 'leaseContract' is not null or undefined
            if (leaseContract === null || leaseContract === undefined) {
                throw new RequiredError('leaseContract','Required parameter leaseContract was null or undefined when calling v1PropertiesPropertyIdLeaseContractsLeaseContractIdPatch.');
            }
            const localVarPath = `/v1/properties/{property_id}/lease_contracts/{lease_contract_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"lease_contract_id"}}`, encodeURIComponent(String(leaseContractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof leaseContract !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(leaseContract !== undefined ? leaseContract : {})
                : (leaseContract || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約登録
         * @param {number} propertyId 物件 ID
         * @param {LeaseContract} leaseContract 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdLeaseContractsPost: async (propertyId: number, leaseContract: LeaseContract, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdLeaseContractsPost.');
            }
            // verify required parameter 'leaseContract' is not null or undefined
            if (leaseContract === null || leaseContract === undefined) {
                throw new RequiredError('leaseContract','Required parameter leaseContract was null or undefined when calling v1PropertiesPropertyIdLeaseContractsPost.');
            }
            const localVarPath = `/v1/properties/{property_id}/lease_contracts`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof leaseContract !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(leaseContract !== undefined ? leaseContract : {})
                : (leaseContract || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 金利履歴の登録・訂正・削除（訂正は原子的に保存）
         * @param {number} propertyId 
         * @param {LoanInterestRateUpdate} loanInterestRateUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdLoanInterestRatesPatch: async (propertyId: number, loanInterestRateUpdate: LoanInterestRateUpdate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdLoanInterestRatesPatch.');
            }
            // verify required parameter 'loanInterestRateUpdate' is not null or undefined
            if (loanInterestRateUpdate === null || loanInterestRateUpdate === undefined) {
                throw new RequiredError('loanInterestRateUpdate','Required parameter loanInterestRateUpdate was null or undefined when calling v1PropertiesPropertyIdLoanInterestRatesPatch.');
            }
            const localVarPath = `/v1/properties/{property_id}/loan_interest_rates`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof loanInterestRateUpdate !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(loanInterestRateUpdate !== undefined ? loanInterestRateUpdate : {})
                : (loanInterestRateUpdate || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 各項目ごとの合計取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdMonthlyCashflowResultSumByItemGet: async (propertyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdMonthlyCashflowResultSumByItemGet.');
            }
            const localVarPath = `/v1/properties/{property_id}/monthly_cashflow_result_sum_by_item`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 月毎の（ユーザ定義による）実績一覧
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdMonthlyCashflowResultsGet: async (propertyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdMonthlyCashflowResultsGet.');
            }
            const localVarPath = `/v1/properties/{property_id}/monthly_cashflow_results`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 旧アプリとの互換性のため、金利は数値文字列も数値へ変換して受け付ける。有限な0〜100%のみ有効。金利のnull化・行削除でも初回返済月に必要な金利は保護する。
         * @summary 月毎の（ユーザ定義による）実績登録
         * @param {number} propertyId 物件 ID
         * @param {MonthlyCashflowResultUpdate} monthlyCashflowResultUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdMonthlyCashflowResultsPatch: async (propertyId: number, monthlyCashflowResultUpdate: MonthlyCashflowResultUpdate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdMonthlyCashflowResultsPatch.');
            }
            // verify required parameter 'monthlyCashflowResultUpdate' is not null or undefined
            if (monthlyCashflowResultUpdate === null || monthlyCashflowResultUpdate === undefined) {
                throw new RequiredError('monthlyCashflowResultUpdate','Required parameter monthlyCashflowResultUpdate was null or undefined when calling v1PropertiesPropertyIdMonthlyCashflowResultsPatch.');
            }
            const localVarPath = `/v1/properties/{property_id}/monthly_cashflow_results`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof monthlyCashflowResultUpdate !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(monthlyCashflowResultUpdate !== undefined ? monthlyCashflowResultUpdate : {})
                : (monthlyCashflowResultUpdate || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件に紐づく周辺情報(不動価格)取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdNearbyPricesGet: async (propertyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdNearbyPricesGet.');
            }
            const localVarPath = `/v1/properties/{property_id}/nearby/prices`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 返済期間または借入額の変更時は、返済期間を1〜50年の整数（借入なしの場合のみ0年も可）で検証します。範囲外は422を返します。既存の範囲外データでも、無関係な項目の更新は許可します。
         * @summary 物件更新
         * @param {number} propertyId 物件 ID
         * @param {PropertyUpdate} propertyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdPatch: async (propertyId: number, propertyUpdate: PropertyUpdate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdPatch.');
            }
            // verify required parameter 'propertyUpdate' is not null or undefined
            if (propertyUpdate === null || propertyUpdate === undefined) {
                throw new RequiredError('propertyUpdate','Required parameter propertyUpdate was null or undefined when calling v1PropertiesPropertyIdPatch.');
            }
            const localVarPath = `/v1/properties/{property_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof propertyUpdate !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(propertyUpdate !== undefined ? propertyUpdate : {})
                : (propertyUpdate || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdSimulationConfigsGet: async (propertyId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsGet.');
            }
            const localVarPath = `/v1/properties/{property_id}/simulation_configs`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定登録
         * @param {number} propertyId 物件 ID
         * @param {SimulationConfig} simulationConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdSimulationConfigsPost: async (propertyId: number, simulationConfig: SimulationConfig, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsPost.');
            }
            // verify required parameter 'simulationConfig' is not null or undefined
            if (simulationConfig === null || simulationConfig === undefined) {
                throw new RequiredError('simulationConfig','Required parameter simulationConfig was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsPost.');
            }
            const localVarPath = `/v1/properties/{property_id}/simulation_configs`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof simulationConfig !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(simulationConfig !== undefined ? simulationConfig : {})
                : (simulationConfig || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定の削除
         * @param {number} propertyId 物件 ID
         * @param {number} simulationConfigId シミュレーション設定 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdDelete: async (propertyId: number, simulationConfigId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdDelete.');
            }
            // verify required parameter 'simulationConfigId' is not null or undefined
            if (simulationConfigId === null || simulationConfigId === undefined) {
                throw new RequiredError('simulationConfigId','Required parameter simulationConfigId was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdDelete.');
            }
            const localVarPath = `/v1/properties/{property_id}/simulation_configs/{simulation_config_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"simulation_config_id"}}`, encodeURIComponent(String(simulationConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定の更新
         * @param {number} propertyId 物件 ID
         * @param {number} simulationConfigId シミュレーション設定 ID
         * @param {SimulationConfig} simulationConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdPatch: async (propertyId: number, simulationConfigId: number, simulationConfig: SimulationConfig, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdPatch.');
            }
            // verify required parameter 'simulationConfigId' is not null or undefined
            if (simulationConfigId === null || simulationConfigId === undefined) {
                throw new RequiredError('simulationConfigId','Required parameter simulationConfigId was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdPatch.');
            }
            // verify required parameter 'simulationConfig' is not null or undefined
            if (simulationConfig === null || simulationConfig === undefined) {
                throw new RequiredError('simulationConfig','Required parameter simulationConfig was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdPatch.');
            }
            const localVarPath = `/v1/properties/{property_id}/simulation_configs/{simulation_config_id}`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"simulation_config_id"}}`, encodeURIComponent(String(simulationConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof simulationConfig !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(simulationConfig !== undefined ? simulationConfig : {})
                : (simulationConfig || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定における修繕積立金の金額変動の更新
         * @param {number} propertyId 物件 ID
         * @param {number} simulationConfigId シミュレーション設定 ID
         * @param {InlineObject14} inlineObject14 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdReserveFundPriceChangesPost: async (propertyId: number, simulationConfigId: number, inlineObject14: InlineObject14, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'propertyId' is not null or undefined
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId','Required parameter propertyId was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdReserveFundPriceChangesPost.');
            }
            // verify required parameter 'simulationConfigId' is not null or undefined
            if (simulationConfigId === null || simulationConfigId === undefined) {
                throw new RequiredError('simulationConfigId','Required parameter simulationConfigId was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdReserveFundPriceChangesPost.');
            }
            // verify required parameter 'inlineObject14' is not null or undefined
            if (inlineObject14 === null || inlineObject14 === undefined) {
                throw new RequiredError('inlineObject14','Required parameter inlineObject14 was null or undefined when calling v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdReserveFundPriceChangesPost.');
            }
            const localVarPath = `/v1/properties/{property_id}/simulation_configs/{simulation_config_id}/reserve_fund_price_changes`
                .replace(`{${"property_id"}}`, encodeURIComponent(String(propertyId)))
                .replace(`{${"simulation_config_id"}}`, encodeURIComponent(String(simulationConfigId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject14 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject14 !== undefined ? inlineObject14 : {})
                : (inlineObject14 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件一時保存状態削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertyTemporaryDelete: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/property_temporary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件一時保存状態取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertyTemporaryGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/property_temporary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 物件一時保存状態登録・更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertyTemporaryPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/property_temporary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary マッチング一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ProposalMatchingsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/proposal_matchings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary マッチング登録
         * @param {ProposalMatchingRequest} proposalMatchingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ProposalMatchingsPost: async (proposalMatchingRequest: ProposalMatchingRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'proposalMatchingRequest' is not null or undefined
            if (proposalMatchingRequest === null || proposalMatchingRequest === undefined) {
                throw new RequiredError('proposalMatchingRequest','Required parameter proposalMatchingRequest was null or undefined when calling v1ProposalMatchingsPost.');
            }
            const localVarPath = `/v1/proposal_matchings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof proposalMatchingRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(proposalMatchingRequest !== undefined ? proposalMatchingRequest : {})
                : (proposalMatchingRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Appleアカウントでユーザー登録
         * @param {UserRegistrationsApple} userRegistrationsApple 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RegistrationsApplePost: async (userRegistrationsApple: UserRegistrationsApple, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegistrationsApple' is not null or undefined
            if (userRegistrationsApple === null || userRegistrationsApple === undefined) {
                throw new RequiredError('userRegistrationsApple','Required parameter userRegistrationsApple was null or undefined when calling v1RegistrationsApplePost.');
            }
            const localVarPath = `/v1/registrations_apple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof userRegistrationsApple !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(userRegistrationsApple !== undefined ? userRegistrationsApple : {})
                : (userRegistrationsApple || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Googleアカウントでユーザー登録
         * @param {UserRegistrationsGoogle} userRegistrationsGoogle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RegistrationsGooglePost: async (userRegistrationsGoogle: UserRegistrationsGoogle, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegistrationsGoogle' is not null or undefined
            if (userRegistrationsGoogle === null || userRegistrationsGoogle === undefined) {
                throw new RequiredError('userRegistrationsGoogle','Required parameter userRegistrationsGoogle was null or undefined when calling v1RegistrationsGooglePost.');
            }
            const localVarPath = `/v1/registrations_google`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof userRegistrationsGoogle !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(userRegistrationsGoogle !== undefined ? userRegistrationsGoogle : {})
                : (userRegistrationsGoogle || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 年収検証フラグ有効時は万円単位の0〜100,000（10億円）を許可し、範囲外は補正せず422を返します。旧アプリ移行中は既定OFFです。
         * @summary ユーザー登録
         * @param {UserRegistrations} userRegistrations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RegistrationsPost: async (userRegistrations: UserRegistrations, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRegistrations' is not null or undefined
            if (userRegistrations === null || userRegistrations === undefined) {
                throw new RequiredError('userRegistrations','Required parameter userRegistrations was null or undefined when calling v1RegistrationsPost.');
            }
            const localVarPath = `/v1/registrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof userRegistrations !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(userRegistrations !== undefined ? userRegistrations : {})
                : (userRegistrations || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 電話番号認証コード送信
         * @param {InlineObject4} inlineObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SendPhoneNumberAuthCodesPost: async (inlineObject4: InlineObject4, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'inlineObject4' is not null or undefined
            if (inlineObject4 === null || inlineObject4 === undefined) {
                throw new RequiredError('inlineObject4','Required parameter inlineObject4 was null or undefined when calling v1SendPhoneNumberAuthCodesPost.');
            }
            const localVarPath = `/v1/send_phone_number_auth_codes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof inlineObject4 !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(inlineObject4 !== undefined ? inlineObject4 : {})
                : (inlineObject4 || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ログイン状況確認
         * @param {string} [adjustNetwork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SessionGet: async (adjustNetwork?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adjustNetwork !== undefined) {
                localVarQueryParameter['adjust_network'] = adjustNetwork;
            }


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary SMAUL 問い合わせを認証ユーザー情報付きで登録
         * @param {SmaulLeadV1Request} smaulLeadV1Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SmaulLeadsPost: async (smaulLeadV1Request: SmaulLeadV1Request, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'smaulLeadV1Request' is not null or undefined
            if (smaulLeadV1Request === null || smaulLeadV1Request === undefined) {
                throw new RequiredError('smaulLeadV1Request','Required parameter smaulLeadV1Request was null or undefined when calling v1SmaulLeadsPost.');
            }
            const localVarPath = `/v1/smaul_leads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof smaulLeadV1Request !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(smaulLeadV1Request !== undefined ? smaulLeadV1Request : {})
                : (smaulLeadV1Request || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザ画面アクセス登録
         * @param {UserAccessScreenLog} userAccessScreenLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserAccessScreenLogsPost: async (userAccessScreenLog: UserAccessScreenLog, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAccessScreenLog' is not null or undefined
            if (userAccessScreenLog === null || userAccessScreenLog === undefined) {
                throw new RequiredError('userAccessScreenLog','Required parameter userAccessScreenLog was null or undefined when calling v1UserAccessScreenLogsPost.');
            }
            const localVarPath = `/v1/user_access_screen_logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof userAccessScreenLog !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(userAccessScreenLog !== undefined ? userAccessScreenLog : {})
                : (userAccessScreenLog || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザデータ初回登録ステータス取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserDataFirstRegisteredStatusGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user/data_first_registered_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザデータ初回登録ステータス更新
         * @param {UserDataFirstRegisteredStatus} userDataFirstRegisteredStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserDataFirstRegisteredStatusPatch: async (userDataFirstRegisteredStatus: UserDataFirstRegisteredStatus, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDataFirstRegisteredStatus' is not null or undefined
            if (userDataFirstRegisteredStatus === null || userDataFirstRegisteredStatus === undefined) {
                throw new RequiredError('userDataFirstRegisteredStatus','Required parameter userDataFirstRegisteredStatus was null or undefined when calling v1UserDataFirstRegisteredStatusPatch.');
            }
            const localVarPath = `/v1/user/data_first_registered_status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof userDataFirstRegisteredStatus !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(userDataFirstRegisteredStatus !== undefined ? userDataFirstRegisteredStatus : {})
                : (userDataFirstRegisteredStatus || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーデバイストークン登録削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserDeviceTokenDelete: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user_device_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーデバイストークン登録
         * @param {UserDeviceToken} userDeviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserDeviceTokenPost: async (userDeviceToken: UserDeviceToken, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userDeviceToken' is not null or undefined
            if (userDeviceToken === null || userDeviceToken === undefined) {
                throw new RequiredError('userDeviceToken','Required parameter userDeviceToken was null or undefined when calling v1UserDeviceTokenPost.');
            }
            const localVarPath = `/v1/user_device_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof userDeviceToken !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(userDeviceToken !== undefined ? userDeviceToken : {})
                : (userDeviceToken || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザー情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 年収検証フラグ有効時は万円単位の0〜100,000（10億円）を許可します。年収の変更時に検証し、範囲外は補正せず422を返します。旧アプリ移行中は既定OFFです。
         * @summary ユーザー情報更新
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPatch: async (userUpdate: UserUpdate, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUpdate' is not null or undefined
            if (userUpdate === null || userUpdate === undefined) {
                throw new RequiredError('userUpdate','Required parameter userUpdate was null or undefined when calling v1UserPatch.');
            }
            const localVarPath = `/v1/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof userUpdate !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(userUpdate !== undefined ? userUpdate : {})
                : (userUpdate || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーオファー登録
         * @param {UserProposalRequest} userProposalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserProposalsPost: async (userProposalRequest: UserProposalRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userProposalRequest' is not null or undefined
            if (userProposalRequest === null || userProposalRequest === undefined) {
                throw new RequiredError('userProposalRequest','Required parameter userProposalRequest was null or undefined when calling v1UserProposalsPost.');
            }
            const localVarPath = `/v1/user_proposals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof userProposalRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(userProposalRequest !== undefined ? userProposalRequest : {})
                : (userProposalRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーオファーの希望連絡日程更新
         * @param {number} userProposalId ユーザーオファー ID
         * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserProposalsUserProposalIdPreferredContactSchedulesPatch: async (userProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userProposalId' is not null or undefined
            if (userProposalId === null || userProposalId === undefined) {
                throw new RequiredError('userProposalId','Required parameter userProposalId was null or undefined when calling v1UserProposalsUserProposalIdPreferredContactSchedulesPatch.');
            }
            // verify required parameter 'investmentProposalPreferredContactSchedulesRequest' is not null or undefined
            if (investmentProposalPreferredContactSchedulesRequest === null || investmentProposalPreferredContactSchedulesRequest === undefined) {
                throw new RequiredError('investmentProposalPreferredContactSchedulesRequest','Required parameter investmentProposalPreferredContactSchedulesRequest was null or undefined when calling v1UserProposalsUserProposalIdPreferredContactSchedulesPatch.');
            }
            const localVarPath = `/v1/user_proposals/{user_proposal_id}/preferred_contact_schedules`
                .replace(`{${"user_proposal_id"}}`, encodeURIComponent(String(userProposalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof investmentProposalPreferredContactSchedulesRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(investmentProposalPreferredContactSchedulesRequest !== undefined ? investmentProposalPreferredContactSchedulesRequest : {})
                : (investmentProposalPreferredContactSchedulesRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ユーザーオファー登録（追加マッチング候補付き）
         * @param {UserProposalRequest} userProposalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserProposalsWithRecommendationsPost: async (userProposalRequest: UserProposalRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'userProposalRequest' is not null or undefined
            if (userProposalRequest === null || userProposalRequest === undefined) {
                throw new RequiredError('userProposalRequest','Required parameter userProposalRequest was null or undefined when calling v1UserProposalsWithRecommendationsPost.');
            }
            const localVarPath = `/v1/user_proposals_with_recommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof userProposalRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(userProposalRequest !== undefined ? userProposalRequest : {})
                : (userProposalRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 累計既読/マッチング件数取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserTotalReadAndMatchCountGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/user_total_read_and_match_count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary プレミアムウェビナー一覧取得
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [recentOnly] 最近のウェビナーのみ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarsGet: async (page?: number, perPage?: number, recentOnly?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/webinars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (perPage !== undefined) {
                localVarQueryParameter['per_page'] = perPage;
            }

            if (recentOnly !== undefined) {
                localVarQueryParameter['recent_only'] = recentOnly;
            }


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary プレミアムウェビナーのハイライト取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarsHighlightGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/webinars/highlight`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary プレミアムウェビナー詳細取得
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarsIdGet: async (id: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling v1WebinarsIdGet.');
            }
            const localVarPath = `/v1/webinars/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary プレミアムウェビナー視聴ログ作成
         * @param {string} id 
         * @param {WebinarViewingCreateRequest} webinarViewingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarsIdViewHistoriesPost: async (id: string, webinarViewingCreateRequest: WebinarViewingCreateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling v1WebinarsIdViewHistoriesPost.');
            }
            // verify required parameter 'webinarViewingCreateRequest' is not null or undefined
            if (webinarViewingCreateRequest === null || webinarViewingCreateRequest === undefined) {
                throw new RequiredError('webinarViewingCreateRequest','Required parameter webinarViewingCreateRequest was null or undefined when calling v1WebinarsIdViewHistoriesPost.');
            }
            const localVarPath = `/v1/webinars/{id}/view_histories`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof webinarViewingCreateRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(webinarViewingCreateRequest !== undefined ? webinarViewingCreateRequest : {})
                : (webinarViewingCreateRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary プレミアムウェビナー視聴ログ更新
         * @param {string} id 
         * @param {string} viewingId 
         * @param {WebinarViewingUpdateRequest} webinarViewingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarsIdViewHistoriesViewingIdPatch: async (id: string, viewingId: string, webinarViewingUpdateRequest: WebinarViewingUpdateRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling v1WebinarsIdViewHistoriesViewingIdPatch.');
            }
            // verify required parameter 'viewingId' is not null or undefined
            if (viewingId === null || viewingId === undefined) {
                throw new RequiredError('viewingId','Required parameter viewingId was null or undefined when calling v1WebinarsIdViewHistoriesViewingIdPatch.');
            }
            // verify required parameter 'webinarViewingUpdateRequest' is not null or undefined
            if (webinarViewingUpdateRequest === null || webinarViewingUpdateRequest === undefined) {
                throw new RequiredError('webinarViewingUpdateRequest','Required parameter webinarViewingUpdateRequest was null or undefined when calling v1WebinarsIdViewHistoriesViewingIdPatch.');
            }
            const localVarPath = `/v1/webinars/{id}/view_histories/{viewing_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"viewing_id"}}`, encodeURIComponent(String(viewingId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            const queryParameters = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                queryParameters.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                queryParameters.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(queryParameters)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const nonString = typeof webinarViewingUpdateRequest !== 'string';
            const needsSerialization = nonString && configuration && configuration.isJsonMime
                ? configuration.isJsonMime(localVarRequestOptions.headers['Content-Type'])
                : nonString;
            localVarRequestOptions.data =  needsSerialization
                ? JSON.stringify(webinarViewingUpdateRequest !== undefined ? webinarViewingUpdateRequest : {})
                : (webinarViewingUpdateRequest || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PropallyV1Api - functional programming interface
 * @export
 */
export const PropallyV1ApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary ヘルスチェックエンドポイント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthzGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).healthzGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary エージェント詳細画面アクセス登録
         * @param {AgentDetailAccessLogRequest} agentDetailAccessLogRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AgentDetailAccessLogsPost(agentDetailAccessLogRequest: AgentDetailAccessLogRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentDetailAccessLog>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AgentDetailAccessLogsPost(agentDetailAccessLogRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary エージェント別投資提案サマリー一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AgentInvestmentProposalSummariesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AgentInvestmentProposalSummary>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AgentInvestmentProposalSummariesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary エージェントの連絡対応可能枠取得
         * @param {number} agentId エージェント ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AgentsAgentIdAvailableContactSlotsGet(agentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentAvailableContactSlotsResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AgentsAgentIdAvailableContactSlotsGet(agentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary エージェント取得
         * @param {number} agentId エージェント ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AgentsAgentIdGet(agentId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Agent>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AgentsAgentIdGet(agentId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 「入力内容にマッチ」「直近で高評価」「直近でアクティブ」の3セクションをまとめて取得する 
         * @summary 初回ロード用のエージェント検索結果をまとめて取得
         * @param {number} [perSectionPerPage] 各セクションの1ページあたり件数（初回）
         * @param {AgentSearchRequest} [agentSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AgentsFeedsPost(perSectionPerPage?: number, agentSearchRequest?: AgentSearchRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentFeedsResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AgentsFeedsPost(perSectionPerPage, agentSearchRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary セクション毎の検索結果を追加で取得する
         * @param {'match' | 'top_rated' | 'active'} section セクション名
         * @param {number} [page] 取得したいページ番号（範囲外・型不一致はリクエスト検証により 400）
         * @param {number} [perPage] 1ページあたりの件数（範囲外・型不一致はリクエスト検証により 400）
         * @param {AgentsSortOptionEnum} [sort] 並び順。match セクションでのみ有効で、compatibility 指定時はログインユーザーとの相性順 （相性が算出できないエージェントは最後尾）。絞り込み後の母集団全体を相性順に並べたうえで ページングするため、ページを跨いでも並びが崩れない。 未指定時は従来の並び順（タグ指定ありはタグ一致数順、なしは id 降順）。 match 以外のセクションに指定した場合は無視する。enum 外の値はリクエスト検証により 400。 
         * @param {AgentSearchRequest} [agentSearchRequest] 検索条件。 match の追加ロードで正しく is_search を記録するには、クライアントが検索時の company_agent_search_tag_ids を再送する必要がある（再送しないと検索由来の表示が is_search: false になる） 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AgentsFeedsSectionPost(section: 'match' | 'top_rated' | 'active', page?: number, perPage?: number, sort?: AgentsSortOptionEnum, agentSearchRequest?: AgentSearchRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAgentsResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AgentsFeedsSectionPost(section, page, perPage, sort, agentSearchRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary エージェント取得
         * @param {number} [page] 取得したいページ番号
         * @param {number} [perPage] 1ページあたりの件数（範囲外・型不一致はリクエスト検証により 400）
         * @param {AgentsSortOptionEnum} [sort] 並び順。compatibility 指定時はログインユーザーとの相性順（相性が算出できないエージェントは最後尾）。 未指定時は従来の並び順（id 降順）。enum 外の値はリクエスト検証により 400。 
         * @param {boolean} [includeAllPublic] 診断後のプランナー選択用。true かつ sort&#x3D;compatibility の場合、相性面・詳細条件検索の個別表示設定が両方ONの公開対象全員を相性順で返す。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AgentsGet(page?: number, perPage?: number, sort?: AgentsSortOptionEnum, includeAllPublic?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAgentsResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AgentsGet(page, perPage, sort, includeAllPublic, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary エージェント検索
         * @param {number} [page] 表示したいページ番号
         * @param {number} [perPage] 1ページあたりの件数
         * @param {AgentSearchRequest} [agentSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AgentsSearchPost(page?: number, perPage?: number, agentSearchRequest?: AgentSearchRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedAgentsResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AgentsSearchPost(page, perPage, agentSearchRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary アナウンス既読更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AnnouncementsReadPatch(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AnnouncementsReadPatch(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 査定提案未読数取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AssessmentProposalUnreadCountGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentProposalUnreadCountResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AssessmentProposalUnreadCountGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 査定提案承認or否承認実行
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {ProposalApprovedRequest} proposalApprovedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AssessmentProposalsAssessmentProposalIdApprovedPatch(assessmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AssessmentProposalsAssessmentProposalIdApprovedPatch(assessmentProposalId, proposalApprovedRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary エージェント・企業情報を含む査定提案詳細1件取得
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AssessmentProposalsAssessmentProposalIdGet(assessmentProposalId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssessmentProposal>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AssessmentProposalsAssessmentProposalIdGet(assessmentProposalId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 査定提案の希望連絡日程更新
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AssessmentProposalsAssessmentProposalIdPreferredContactSchedulesPatch(assessmentProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AssessmentProposalsAssessmentProposalIdPreferredContactSchedulesPatch(assessmentProposalId, investmentProposalPreferredContactSchedulesRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 査定提案既読更新
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AssessmentProposalsAssessmentProposalIdReadPatch(assessmentProposalId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AssessmentProposalsAssessmentProposalIdReadPatch(assessmentProposalId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 査定提案一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1AssessmentProposalsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssessmentProposal>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1AssessmentProposalsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Propally限定物件一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1CompanyLimitedPropertiesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LimitedProperties>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1CompanyLimitedPropertiesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary メールアドレス確認
         * @param {InlineObject3} inlineObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1EmailConfirmationsPost(inlineObject3: InlineObject3, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1EmailConfirmationsPost(inlineObject3, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary HowMa(外部API)物件詳細(部屋情報一覧)API
         * @param {number} buildingId (HowMa管理の)マンションID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1HowmaBuildingsBuildingIdGet(buildingId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HowMaBuildingDetailResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1HowmaBuildingsBuildingIdGet(buildingId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary HowMa(外部API)物件検索API
         * @param {HowMaBuildingsSearchRequest} howMaBuildingsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1HowmaBuildingsPost(howMaBuildingsSearchRequest: HowMaBuildingsSearchRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HowMaBuildingsResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1HowmaBuildingsPost(howMaBuildingsSearchRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 投資提案の対エージェントステータス更新
         * @param {InvestmentProposalStatusUpdateRequest} investmentProposalStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentProposalStatusPatch(investmentProposalStatusUpdateRequest: InvestmentProposalStatusUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestmentProposalStatusResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentProposalStatusPatch(investmentProposalStatusUpdateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 投資提案未読数取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentProposalUnreadCountGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestmentProposalUnreadCountResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentProposalUnreadCountGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 投資提案一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentProposalsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<InvestmentProposal>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentProposalsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 投資提案承認or否承認実行
         * @param {number} investmentProposalId 投資提案 ID
         * @param {ProposalApprovedRequest} proposalApprovedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentProposalsInvestmentProposalIdApprovedPatch(investmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentProposalsInvestmentProposalIdApprovedPatch(investmentProposalId, proposalApprovedRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 投資提案承認or否承認実行（追加マッチング候補付き）
         * @param {number} investmentProposalId 投資提案 ID
         * @param {ProposalApprovedRequest} proposalApprovedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentProposalsInvestmentProposalIdApprovedWithRecommendationsPatch(investmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestmentProposalApprovedWithRecommendationsResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentProposalsInvestmentProposalIdApprovedWithRecommendationsPatch(investmentProposalId, proposalApprovedRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 投資提案詳細1件取得
         * @param {number} investmentProposalId 投資提案 ID
         * @param {boolean} [hasHistory] 過去の投資提案も取得するフラグ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentProposalsInvestmentProposalIdGet(investmentProposalId: number, hasHistory?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestmentProposal>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentProposalsInvestmentProposalIdGet(investmentProposalId, hasHistory, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 投資提案の希望連絡日程更新
         * @param {number} investmentProposalId 投資提案 ID
         * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentProposalsInvestmentProposalIdPreferredContactSchedulesPatch(investmentProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentProposalsInvestmentProposalIdPreferredContactSchedulesPatch(investmentProposalId, investmentProposalPreferredContactSchedulesRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 投資提案既読更新
         * @param {number} investmentProposalId 投資提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentProposalsInvestmentProposalIdReadPatch(investmentProposalId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentProposalsInvestmentProposalIdReadPatch(investmentProposalId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * メッセージ詳細の「お断り」。お断りの単位はメッセージではなくプランナーで、 以後そのプランナーからのメッセージ（過去分も含む）は一覧・詳細・未読件数・通知に出なくなる。解除はできない。 お断り済みのプランナーのメッセージに再度呼んでも 200 を返す（冪等）。 
         * @summary 投資提案の送信元プランナーをお断り
         * @param {number} investmentProposalId 投資提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentProposalsInvestmentProposalIdRefusalPost(investmentProposalId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentProposalsInvestmentProposalIdRefusalPost(investmentProposalId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 投資スタイル診断の結果取得（本人）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentStyleDiagnosisGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestmentStyleDiagnosis>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentStyleDiagnosisGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 投資スタイル診断の回答送信・結果取得
         * @param {InvestmentStyleDiagnosisRequest} investmentStyleDiagnosisRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1InvestmentStyleDiagnosisPost(investmentStyleDiagnosisRequest: InvestmentStyleDiagnosisRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvestmentStyleDiagnosis>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1InvestmentStyleDiagnosisPost(investmentStyleDiagnosisRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 学習記事を達成済みに登録
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1LearningArticlesArticleIdCompletePost(articleId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LearningArticleStatus>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1LearningArticlesArticleIdCompletePost(articleId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 学習記事の達成状況を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1LearningArticlesStatusesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LearningArticleStatus>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1LearningArticlesStatusesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Appleアカウントでログイン
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1LoginApplePost(inlineObject2: InlineObject2, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1LoginApplePost(inlineObject2, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Googleアカウントでログイン
         * @param {InlineObject1} inlineObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1LoginGooglePost(inlineObject1: InlineObject1, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1LoginGooglePost(inlineObject1, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ログイン
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1LoginPost(inlineObject: InlineObject, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1LoginPost(inlineObject, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1LogoutPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1LogoutPost(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary エージェント検索タグマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataAgentSearchTagsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterAgentSearchTag>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataAgentSearchTagsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 流入経路マスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataInflowRoutesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdName>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataInflowRoutesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 興味のある物件タイプマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataInterestedPropertyTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdName>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataInterestedPropertyTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 都道府県一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataPrefecturesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataPrefecturesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 町丁目一覧
         * @param {string} prefectureName 都道府県名
         * @param {string} cityName 市区町村名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName: string, cityName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName, cityName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 市区町村一覧
         * @param {string} prefectureName 都道府県名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 利用目的マスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataPurposeOfUsesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdName>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataPurposeOfUsesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 鉄道一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataRailwaysGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdName>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataRailwaysGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 駅名一覧
         * @param {string} railwayName 鉄道名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataRailwaysRailwayNameStationsGet(railwayName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataRailwaysRailwayNameStationsGet(railwayName, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 居住タイプマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataResidenceTypesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdName>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataResidenceTypesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary タグマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MasterDataTagsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IdName>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MasterDataTagsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 最低アプリバージョン取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MinAppVersionGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2001>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MinAppVersionGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 三井住友海上営業リストにユーザを登録
         * @param {MsinsLeadEntry} msinsLeadEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1MsinsLeadsPost(msinsLeadEntry: MsinsLeadEntry, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1MsinsLeadsPost(msinsLeadEntry, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary リセット後、新しいパスワードの登録
         * @param {InlineObject6} inlineObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1NewPasswordsPost(inlineObject6: InlineObject6, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1NewPasswordsPost(inlineObject6, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 初回物件登録時エージェント通知
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1NotificationsToAgentForNewPropertyPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1NotificationsToAgentForNewPropertyPost(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ユーザSTEP1登録時エージェント通知
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1NotificationsToAgentForNewUserPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1NotificationsToAgentForNewUserPost(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary パスワードリセット
         * @param {InlineObject5} inlineObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PasswordResetsPost(inlineObject5: InlineObject5, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PasswordResetsPost(inlineObject5, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 現行プライバシーポリシーへの同意状態と本文を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PrivacyPolicyConsentGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrivacyPolicyConsent>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PrivacyPolicyConsentGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 現行プライバシーポリシーへの同意を記録
         * @param {PrivacyPolicyConsentCreateRequest} privacyPolicyConsentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PrivacyPolicyConsentPost(privacyPolicyConsentCreateRequest: PrivacyPolicyConsentCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PrivacyPolicyConsentPost(privacyPolicyConsentCreateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
         * @summary マンション名からAI補完して検討物件を登録
         * @param {InlineObject9} inlineObject9 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesAiCreateConsiderationPost(inlineObject9: InlineObject9, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Property>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesAiCreateConsiderationPost(inlineObject9, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
         * @summary マンション名からAI補完して保有物件を登録
         * @param {InlineObject8} inlineObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesAiCreateOwnPost(inlineObject8: InlineObject8, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Property>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesAiCreateOwnPost(inlineObject8, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
         * @summary マンション名からAI補完して物件登録
         * @param {InlineObject7} inlineObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesAiCreatePost(inlineObject7: InlineObject7, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Property>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesAiCreatePost(inlineObject7, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 書類PDF/画像をOCRして検討物件の下書きを作成（推定なし）
         * @param {InlineObject13} inlineObject13 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesAiDraftConsiderationDocumentPost(inlineObject13: InlineObject13, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyBuilder>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesAiDraftConsiderationDocumentPost(inlineObject13, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary マンション名からAI補完して検討物件の下書きを作成
         * @param {InlineObject12} inlineObject12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesAiDraftConsiderationPost(inlineObject12: InlineObject12, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyBuilder>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesAiDraftConsiderationPost(inlineObject12, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 書類PDF/画像をOCRして保有物件の下書きを作成（推定なし）
         * @param {InlineObject11} inlineObject11 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesAiDraftOwnDocumentPost(inlineObject11: InlineObject11, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyBuilder>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesAiDraftOwnDocumentPost(inlineObject11, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary マンション名からAI補完して保有物件の下書きを作成
         * @param {InlineObject10} inlineObject10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesAiDraftOwnPost(inlineObject10: InlineObject10, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyBuilder>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesAiDraftOwnPost(inlineObject10, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Property>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 返済期間は1〜50年の整数（借入なしの場合のみ0年も可）、金利は0〜100%です。借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。不整合時は関連データも保存せず422を返します。AI補完した登録にも同じ制約を適用します。
         * @summary 物件登録
         * @param {PropertyBuilder} propertyBuilder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPost(propertyBuilder: PropertyBuilder, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Property>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPost(propertyBuilder, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary AIおまかせ入力のお知らせ閉じ状態を更新
         * @param {number} propertyId 物件 ID
         * @param {PropertyAiCreateNotificationDismissedRequest} propertyAiCreateNotificationDismissedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdAiCreateNotificationDismissedPatch(propertyId: number, propertyAiCreateNotificationDismissedRequest: PropertyAiCreateNotificationDismissedRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyAiCreateNotificationDismissedResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdAiCreateNotificationDismissedPatch(propertyId, propertyAiCreateNotificationDismissedRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 一棟物件の部屋の削除
         * @param {number} propertyId 物件 ID
         * @param {number} buildingRoomId 部屋ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdDelete(propertyId: number, buildingRoomId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdDelete(propertyId, buildingRoomId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 一棟物件の部屋ごとの情報更新
         * @param {number} propertyId 物件 ID
         * @param {number} buildingRoomId 部屋ID
         * @param {BuildingRoom} buildingRoom 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdPatch(propertyId: number, buildingRoomId: number, buildingRoom: BuildingRoom, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingRoom>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdPatch(propertyId, buildingRoomId, buildingRoom, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 一棟物件の部屋ごとの情報取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdBuildingRoomsGet(propertyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BuildingRoom>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdBuildingRoomsGet(propertyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 一棟物件の部屋ごとの情報登録
         * @param {number} propertyId 物件 ID
         * @param {BuildingRoom} buildingRoom 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdBuildingRoomsPost(propertyId: number, buildingRoom: BuildingRoom, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BuildingRoom>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdBuildingRoomsPost(propertyId, buildingRoom, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件削除
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdDelete(propertyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdDelete(propertyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントの削除
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdDelete(propertyId: number, documentType: DocumentType, fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdDelete(propertyId, documentType, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントのファイルバイナリ取得
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdGet(propertyId: number, documentType: DocumentType, fileId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdGet(propertyId, documentType, fileId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ドキュメント更新
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {DocumentForm} documentForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch(propertyId: number, documentType: DocumentType, fileId: number, documentForm: DocumentForm, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch(propertyId, documentType, fileId, documentForm, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントのURLを署名とヘッダー付きで取得
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {string} filename ファイル名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet(propertyId: number, documentType: DocumentType, fileId: number, filename: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2004>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet(propertyId, documentType, fileId, filename, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントの一覧取得
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdDocumentsDocumentTypeFilesGet(propertyId: number, documentType: DocumentType, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Document>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesGet(propertyId, documentType, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントの登録
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {Base64EncodedImage} base64EncodedImage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdDocumentsDocumentTypeFilesPost(propertyId: number, documentType: DocumentType, base64EncodedImage: Base64EncodedImage, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesPost(propertyId, documentType, base64EncodedImage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件に紐づく画像の削除
         * @param {number} propertyId 物件 ID
         * @param {number} imageId 画像 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdImagesImageIdDelete(propertyId: number, imageId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdImagesImageIdDelete(propertyId, imageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件に紐づく画像ごとの URL 取得
         * @param {number} propertyId 物件 ID
         * @param {number} imageId 画像 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdImagesImageIdUrlGet(propertyId: number, imageId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2003>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdImagesImageIdUrlGet(propertyId, imageId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件ごとの画像登録
         * @param {number} propertyId 物件 ID
         * @param {Base64EncodedImage} base64EncodedImage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdImagesPost(propertyId: number, base64EncodedImage: Base64EncodedImage, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Id>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdImagesPost(propertyId, base64EncodedImage, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdLeaseContractsGet(propertyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LeaseContract>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdLeaseContractsGet(propertyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約削除
         * @param {number} propertyId 物件 ID
         * @param {number} leaseContractId 賃貸契約ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdLeaseContractsLeaseContractIdDelete(propertyId: number, leaseContractId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdLeaseContractsLeaseContractIdDelete(propertyId, leaseContractId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約更新
         * @param {number} propertyId 物件 ID
         * @param {number} leaseContractId 賃貸契約ID
         * @param {LeaseContract} leaseContract 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdLeaseContractsLeaseContractIdPatch(propertyId: number, leaseContractId: number, leaseContract: LeaseContract, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaseContract>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdLeaseContractsLeaseContractIdPatch(propertyId, leaseContractId, leaseContract, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約登録
         * @param {number} propertyId 物件 ID
         * @param {LeaseContract} leaseContract 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdLeaseContractsPost(propertyId: number, leaseContract: LeaseContract, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaseContract>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdLeaseContractsPost(propertyId, leaseContract, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 金利履歴の登録・訂正・削除（訂正は原子的に保存）
         * @param {number} propertyId 
         * @param {LoanInterestRateUpdate} loanInterestRateUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdLoanInterestRatesPatch(propertyId: number, loanInterestRateUpdate: LoanInterestRateUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdLoanInterestRatesPatch(propertyId, loanInterestRateUpdate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 各項目ごとの合計取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdMonthlyCashflowResultSumByItemGet(propertyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MonthlyCashflowResultSumByItem>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdMonthlyCashflowResultSumByItemGet(propertyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 月毎の（ユーザ定義による）実績一覧
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdMonthlyCashflowResultsGet(propertyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MonthlyCashflowResult>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdMonthlyCashflowResultsGet(propertyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 旧アプリとの互換性のため、金利は数値文字列も数値へ変換して受け付ける。有限な0〜100%のみ有効。金利のnull化・行削除でも初回返済月に必要な金利は保護する。
         * @summary 月毎の（ユーザ定義による）実績登録
         * @param {number} propertyId 物件 ID
         * @param {MonthlyCashflowResultUpdate} monthlyCashflowResultUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdMonthlyCashflowResultsPatch(propertyId: number, monthlyCashflowResultUpdate: MonthlyCashflowResultUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdMonthlyCashflowResultsPatch(propertyId, monthlyCashflowResultUpdate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件に紐づく周辺情報(不動価格)取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdNearbyPricesGet(propertyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReinfolibPrice>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdNearbyPricesGet(propertyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 返済期間または借入額の変更時は、返済期間を1〜50年の整数（借入なしの場合のみ0年も可）で検証します。範囲外は422を返します。既存の範囲外データでも、無関係な項目の更新は許可します。
         * @summary 物件更新
         * @param {number} propertyId 物件 ID
         * @param {PropertyUpdate} propertyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdPatch(propertyId: number, propertyUpdate: PropertyUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Property>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdPatch(propertyId, propertyUpdate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdSimulationConfigsGet(propertyId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SimulationConfigWithId>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdSimulationConfigsGet(propertyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定登録
         * @param {number} propertyId 物件 ID
         * @param {SimulationConfig} simulationConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdSimulationConfigsPost(propertyId: number, simulationConfig: SimulationConfig, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulationConfigWithId>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdSimulationConfigsPost(propertyId, simulationConfig, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定の削除
         * @param {number} propertyId 物件 ID
         * @param {number} simulationConfigId シミュレーション設定 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdDelete(propertyId: number, simulationConfigId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdDelete(propertyId, simulationConfigId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定の更新
         * @param {number} propertyId 物件 ID
         * @param {number} simulationConfigId シミュレーション設定 ID
         * @param {SimulationConfig} simulationConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdPatch(propertyId: number, simulationConfigId: number, simulationConfig: SimulationConfig, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulationConfigWithId>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdPatch(propertyId, simulationConfigId, simulationConfig, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定における修繕積立金の金額変動の更新
         * @param {number} propertyId 物件 ID
         * @param {number} simulationConfigId シミュレーション設定 ID
         * @param {InlineObject14} inlineObject14 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdReserveFundPriceChangesPost(propertyId: number, simulationConfigId: number, inlineObject14: InlineObject14, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReserveFundPriceChange>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdReserveFundPriceChangesPost(propertyId, simulationConfigId, inlineObject14, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件一時保存状態削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertyTemporaryDelete(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertyTemporaryDelete(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件一時保存状態取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertyTemporaryGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PropertyTemporary>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertyTemporaryGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 物件一時保存状態登録・更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1PropertyTemporaryPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1PropertyTemporaryPost(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary マッチング一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1ProposalMatchingsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProposalMatching>>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1ProposalMatchingsGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary マッチング登録
         * @param {ProposalMatchingRequest} proposalMatchingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1ProposalMatchingsPost(proposalMatchingRequest: ProposalMatchingRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1ProposalMatchingsPost(proposalMatchingRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Appleアカウントでユーザー登録
         * @param {UserRegistrationsApple} userRegistrationsApple 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1RegistrationsApplePost(userRegistrationsApple: UserRegistrationsApple, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1RegistrationsApplePost(userRegistrationsApple, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary Googleアカウントでユーザー登録
         * @param {UserRegistrationsGoogle} userRegistrationsGoogle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1RegistrationsGooglePost(userRegistrationsGoogle: UserRegistrationsGoogle, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1RegistrationsGooglePost(userRegistrationsGoogle, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 年収検証フラグ有効時は万円単位の0〜100,000（10億円）を許可し、範囲外は補正せず422を返します。旧アプリ移行中は既定OFFです。
         * @summary ユーザー登録
         * @param {UserRegistrations} userRegistrations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1RegistrationsPost(userRegistrations: UserRegistrations, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1RegistrationsPost(userRegistrations, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 電話番号認証コード送信
         * @param {InlineObject4} inlineObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1SendPhoneNumberAuthCodesPost(inlineObject4: InlineObject4, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2002>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1SendPhoneNumberAuthCodesPost(inlineObject4, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ログイン状況確認
         * @param {string} [adjustNetwork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1SessionGet(adjustNetwork?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1SessionGet(adjustNetwork, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary SMAUL 問い合わせを認証ユーザー情報付きで登録
         * @param {SmaulLeadV1Request} smaulLeadV1Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1SmaulLeadsPost(smaulLeadV1Request: SmaulLeadV1Request, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1SmaulLeadsPost(smaulLeadV1Request, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ユーザ画面アクセス登録
         * @param {UserAccessScreenLog} userAccessScreenLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserAccessScreenLogsPost(userAccessScreenLog: UserAccessScreenLog, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserAccessScreenLogsPost(userAccessScreenLog, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ユーザデータ初回登録ステータス取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserDataFirstRegisteredStatusGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDataFirstRegisteredStatus>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserDataFirstRegisteredStatusGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ユーザデータ初回登録ステータス更新
         * @param {UserDataFirstRegisteredStatus} userDataFirstRegisteredStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus: UserDataFirstRegisteredStatus, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDataFirstRegisteredStatus>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ユーザーデバイストークン登録削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserDeviceTokenDelete(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserDeviceTokenDelete(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ユーザーデバイストークン登録
         * @param {UserDeviceToken} userDeviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserDeviceTokenPost(userDeviceToken: UserDeviceToken, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse401>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserDeviceTokenPost(userDeviceToken, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ユーザー情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 年収検証フラグ有効時は万円単位の0〜100,000（10億円）を許可します。年収の変更時に検証し、範囲外は補正せず422を返します。旧アプリ移行中は既定OFFです。
         * @summary ユーザー情報更新
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserPatch(userUpdate: UserUpdate, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<User>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserPatch(userUpdate, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ユーザーオファー登録
         * @param {UserProposalRequest} userProposalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserProposalsPost(userProposalRequest: UserProposalRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProposalResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserProposalsPost(userProposalRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ユーザーオファーの希望連絡日程更新
         * @param {number} userProposalId ユーザーオファー ID
         * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserProposalsUserProposalIdPreferredContactSchedulesPatch(userProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMessage>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserProposalsUserProposalIdPreferredContactSchedulesPatch(userProposalId, investmentProposalPreferredContactSchedulesRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary ユーザーオファー登録（追加マッチング候補付き）
         * @param {UserProposalRequest} userProposalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserProposalsWithRecommendationsPost(userProposalRequest: UserProposalRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProposalWithRecommendationsResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserProposalsWithRecommendationsPost(userProposalRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary 累計既読/マッチング件数取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1UserTotalReadAndMatchCountGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TotalReadAndMatchCountResponse>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1UserTotalReadAndMatchCountGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary プレミアムウェビナー一覧取得
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [recentOnly] 最近のウェビナーのみ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1WebinarsGet(page?: number, perPage?: number, recentOnly?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1WebinarsGet(page, perPage, recentOnly, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary プレミアムウェビナーのハイライト取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1WebinarsHighlightGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2005>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1WebinarsHighlightGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary プレミアムウェビナー詳細取得
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1WebinarsIdGet(id: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse2006>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1WebinarsIdGet(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary プレミアムウェビナー視聴ログ作成
         * @param {string} id 
         * @param {WebinarViewingCreateRequest} webinarViewingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1WebinarsIdViewHistoriesPost(id: string, webinarViewingCreateRequest: WebinarViewingCreateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse201>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1WebinarsIdViewHistoriesPost(id, webinarViewingCreateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary プレミアムウェビナー視聴ログ更新
         * @param {string} id 
         * @param {string} viewingId 
         * @param {WebinarViewingUpdateRequest} webinarViewingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async v1WebinarsIdViewHistoriesViewingIdPatch(id: string, viewingId: string, webinarViewingUpdateRequest: WebinarViewingUpdateRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse201>> {
            const localVarAxiosArgs = await PropallyV1ApiAxiosParamCreator(configuration).v1WebinarsIdViewHistoriesViewingIdPatch(id, viewingId, webinarViewingUpdateRequest, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: (configuration?.basePath || basePath) + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * PropallyV1Api - factory interface
 * @export
 */
export const PropallyV1ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary ヘルスチェックエンドポイント
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthzGet(options?: any): AxiosPromise<InlineResponse200> {
            return PropallyV1ApiFp(configuration).healthzGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary エージェント詳細画面アクセス登録
         * @param {AgentDetailAccessLogRequest} agentDetailAccessLogRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentDetailAccessLogsPost(agentDetailAccessLogRequest: AgentDetailAccessLogRequest, options?: any): AxiosPromise<AgentDetailAccessLog> {
            return PropallyV1ApiFp(configuration).v1AgentDetailAccessLogsPost(agentDetailAccessLogRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary エージェント別投資提案サマリー一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentInvestmentProposalSummariesGet(options?: any): AxiosPromise<Array<AgentInvestmentProposalSummary>> {
            return PropallyV1ApiFp(configuration).v1AgentInvestmentProposalSummariesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary エージェントの連絡対応可能枠取得
         * @param {number} agentId エージェント ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsAgentIdAvailableContactSlotsGet(agentId: number, options?: any): AxiosPromise<AgentAvailableContactSlotsResponse> {
            return PropallyV1ApiFp(configuration).v1AgentsAgentIdAvailableContactSlotsGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary エージェント取得
         * @param {number} agentId エージェント ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsAgentIdGet(agentId: number, options?: any): AxiosPromise<Agent> {
            return PropallyV1ApiFp(configuration).v1AgentsAgentIdGet(agentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 「入力内容にマッチ」「直近で高評価」「直近でアクティブ」の3セクションをまとめて取得する 
         * @summary 初回ロード用のエージェント検索結果をまとめて取得
         * @param {number} [perSectionPerPage] 各セクションの1ページあたり件数（初回）
         * @param {AgentSearchRequest} [agentSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsFeedsPost(perSectionPerPage?: number, agentSearchRequest?: AgentSearchRequest, options?: any): AxiosPromise<AgentFeedsResponse> {
            return PropallyV1ApiFp(configuration).v1AgentsFeedsPost(perSectionPerPage, agentSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary セクション毎の検索結果を追加で取得する
         * @param {'match' | 'top_rated' | 'active'} section セクション名
         * @param {number} [page] 取得したいページ番号（範囲外・型不一致はリクエスト検証により 400）
         * @param {number} [perPage] 1ページあたりの件数（範囲外・型不一致はリクエスト検証により 400）
         * @param {AgentsSortOptionEnum} [sort] 並び順。match セクションでのみ有効で、compatibility 指定時はログインユーザーとの相性順 （相性が算出できないエージェントは最後尾）。絞り込み後の母集団全体を相性順に並べたうえで ページングするため、ページを跨いでも並びが崩れない。 未指定時は従来の並び順（タグ指定ありはタグ一致数順、なしは id 降順）。 match 以外のセクションに指定した場合は無視する。enum 外の値はリクエスト検証により 400。 
         * @param {AgentSearchRequest} [agentSearchRequest] 検索条件。 match の追加ロードで正しく is_search を記録するには、クライアントが検索時の company_agent_search_tag_ids を再送する必要がある（再送しないと検索由来の表示が is_search: false になる） 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsFeedsSectionPost(section: 'match' | 'top_rated' | 'active', page?: number, perPage?: number, sort?: AgentsSortOptionEnum, agentSearchRequest?: AgentSearchRequest, options?: any): AxiosPromise<PaginatedAgentsResponse> {
            return PropallyV1ApiFp(configuration).v1AgentsFeedsSectionPost(section, page, perPage, sort, agentSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary エージェント取得
         * @param {number} [page] 取得したいページ番号
         * @param {number} [perPage] 1ページあたりの件数（範囲外・型不一致はリクエスト検証により 400）
         * @param {AgentsSortOptionEnum} [sort] 並び順。compatibility 指定時はログインユーザーとの相性順（相性が算出できないエージェントは最後尾）。 未指定時は従来の並び順（id 降順）。enum 外の値はリクエスト検証により 400。 
         * @param {boolean} [includeAllPublic] 診断後のプランナー選択用。true かつ sort&#x3D;compatibility の場合、相性面・詳細条件検索の個別表示設定が両方ONの公開対象全員を相性順で返す。
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsGet(page?: number, perPage?: number, sort?: AgentsSortOptionEnum, includeAllPublic?: boolean, options?: any): AxiosPromise<PaginatedAgentsResponse> {
            return PropallyV1ApiFp(configuration).v1AgentsGet(page, perPage, sort, includeAllPublic, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary エージェント検索
         * @param {number} [page] 表示したいページ番号
         * @param {number} [perPage] 1ページあたりの件数
         * @param {AgentSearchRequest} [agentSearchRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AgentsSearchPost(page?: number, perPage?: number, agentSearchRequest?: AgentSearchRequest, options?: any): AxiosPromise<PaginatedAgentsResponse> {
            return PropallyV1ApiFp(configuration).v1AgentsSearchPost(page, perPage, agentSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary アナウンス既読更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AnnouncementsReadPatch(options?: any): AxiosPromise<ResponseMessage> {
            return PropallyV1ApiFp(configuration).v1AnnouncementsReadPatch(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 査定提案未読数取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalUnreadCountGet(options?: any): AxiosPromise<AssessmentProposalUnreadCountResponse> {
            return PropallyV1ApiFp(configuration).v1AssessmentProposalUnreadCountGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 査定提案承認or否承認実行
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {ProposalApprovedRequest} proposalApprovedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalsAssessmentProposalIdApprovedPatch(assessmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options?: any): AxiosPromise<ResponseMessage> {
            return PropallyV1ApiFp(configuration).v1AssessmentProposalsAssessmentProposalIdApprovedPatch(assessmentProposalId, proposalApprovedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary エージェント・企業情報を含む査定提案詳細1件取得
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalsAssessmentProposalIdGet(assessmentProposalId: number, options?: any): AxiosPromise<AssessmentProposal> {
            return PropallyV1ApiFp(configuration).v1AssessmentProposalsAssessmentProposalIdGet(assessmentProposalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 査定提案の希望連絡日程更新
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalsAssessmentProposalIdPreferredContactSchedulesPatch(assessmentProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options?: any): AxiosPromise<ResponseMessage> {
            return PropallyV1ApiFp(configuration).v1AssessmentProposalsAssessmentProposalIdPreferredContactSchedulesPatch(assessmentProposalId, investmentProposalPreferredContactSchedulesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 査定提案既読更新
         * @param {number} assessmentProposalId 査定提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalsAssessmentProposalIdReadPatch(assessmentProposalId: number, options?: any): AxiosPromise<ResponseMessage> {
            return PropallyV1ApiFp(configuration).v1AssessmentProposalsAssessmentProposalIdReadPatch(assessmentProposalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 査定提案一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1AssessmentProposalsGet(options?: any): AxiosPromise<Array<AssessmentProposal>> {
            return PropallyV1ApiFp(configuration).v1AssessmentProposalsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Propally限定物件一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1CompanyLimitedPropertiesGet(options?: any): AxiosPromise<Array<LimitedProperties>> {
            return PropallyV1ApiFp(configuration).v1CompanyLimitedPropertiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary メールアドレス確認
         * @param {InlineObject3} inlineObject3 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1EmailConfirmationsPost(inlineObject3: InlineObject3, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1EmailConfirmationsPost(inlineObject3, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary HowMa(外部API)物件詳細(部屋情報一覧)API
         * @param {number} buildingId (HowMa管理の)マンションID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1HowmaBuildingsBuildingIdGet(buildingId: number, options?: any): AxiosPromise<HowMaBuildingDetailResponse> {
            return PropallyV1ApiFp(configuration).v1HowmaBuildingsBuildingIdGet(buildingId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary HowMa(外部API)物件検索API
         * @param {HowMaBuildingsSearchRequest} howMaBuildingsSearchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1HowmaBuildingsPost(howMaBuildingsSearchRequest: HowMaBuildingsSearchRequest, options?: any): AxiosPromise<HowMaBuildingsResponse> {
            return PropallyV1ApiFp(configuration).v1HowmaBuildingsPost(howMaBuildingsSearchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 投資提案の対エージェントステータス更新
         * @param {InvestmentProposalStatusUpdateRequest} investmentProposalStatusUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalStatusPatch(investmentProposalStatusUpdateRequest: InvestmentProposalStatusUpdateRequest, options?: any): AxiosPromise<InvestmentProposalStatusResponse> {
            return PropallyV1ApiFp(configuration).v1InvestmentProposalStatusPatch(investmentProposalStatusUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 投資提案未読数取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalUnreadCountGet(options?: any): AxiosPromise<InvestmentProposalUnreadCountResponse> {
            return PropallyV1ApiFp(configuration).v1InvestmentProposalUnreadCountGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 投資提案一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsGet(options?: any): AxiosPromise<Array<InvestmentProposal>> {
            return PropallyV1ApiFp(configuration).v1InvestmentProposalsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 投資提案承認or否承認実行
         * @param {number} investmentProposalId 投資提案 ID
         * @param {ProposalApprovedRequest} proposalApprovedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdApprovedPatch(investmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options?: any): AxiosPromise<ResponseMessage> {
            return PropallyV1ApiFp(configuration).v1InvestmentProposalsInvestmentProposalIdApprovedPatch(investmentProposalId, proposalApprovedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 投資提案承認or否承認実行（追加マッチング候補付き）
         * @param {number} investmentProposalId 投資提案 ID
         * @param {ProposalApprovedRequest} proposalApprovedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdApprovedWithRecommendationsPatch(investmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options?: any): AxiosPromise<InvestmentProposalApprovedWithRecommendationsResponse> {
            return PropallyV1ApiFp(configuration).v1InvestmentProposalsInvestmentProposalIdApprovedWithRecommendationsPatch(investmentProposalId, proposalApprovedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 投資提案詳細1件取得
         * @param {number} investmentProposalId 投資提案 ID
         * @param {boolean} [hasHistory] 過去の投資提案も取得するフラグ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdGet(investmentProposalId: number, hasHistory?: boolean, options?: any): AxiosPromise<InvestmentProposal> {
            return PropallyV1ApiFp(configuration).v1InvestmentProposalsInvestmentProposalIdGet(investmentProposalId, hasHistory, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 投資提案の希望連絡日程更新
         * @param {number} investmentProposalId 投資提案 ID
         * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdPreferredContactSchedulesPatch(investmentProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options?: any): AxiosPromise<ResponseMessage> {
            return PropallyV1ApiFp(configuration).v1InvestmentProposalsInvestmentProposalIdPreferredContactSchedulesPatch(investmentProposalId, investmentProposalPreferredContactSchedulesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 投資提案既読更新
         * @param {number} investmentProposalId 投資提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdReadPatch(investmentProposalId: number, options?: any): AxiosPromise<ResponseMessage> {
            return PropallyV1ApiFp(configuration).v1InvestmentProposalsInvestmentProposalIdReadPatch(investmentProposalId, options).then((request) => request(axios, basePath));
        },
        /**
         * メッセージ詳細の「お断り」。お断りの単位はメッセージではなくプランナーで、 以後そのプランナーからのメッセージ（過去分も含む）は一覧・詳細・未読件数・通知に出なくなる。解除はできない。 お断り済みのプランナーのメッセージに再度呼んでも 200 を返す（冪等）。 
         * @summary 投資提案の送信元プランナーをお断り
         * @param {number} investmentProposalId 投資提案 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentProposalsInvestmentProposalIdRefusalPost(investmentProposalId: number, options?: any): AxiosPromise<ResponseMessage> {
            return PropallyV1ApiFp(configuration).v1InvestmentProposalsInvestmentProposalIdRefusalPost(investmentProposalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 投資スタイル診断の結果取得（本人）
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentStyleDiagnosisGet(options?: any): AxiosPromise<InvestmentStyleDiagnosis> {
            return PropallyV1ApiFp(configuration).v1InvestmentStyleDiagnosisGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 投資スタイル診断の回答送信・結果取得
         * @param {InvestmentStyleDiagnosisRequest} investmentStyleDiagnosisRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1InvestmentStyleDiagnosisPost(investmentStyleDiagnosisRequest: InvestmentStyleDiagnosisRequest, options?: any): AxiosPromise<InvestmentStyleDiagnosis> {
            return PropallyV1ApiFp(configuration).v1InvestmentStyleDiagnosisPost(investmentStyleDiagnosisRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 学習記事を達成済みに登録
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LearningArticlesArticleIdCompletePost(articleId: string, options?: any): AxiosPromise<LearningArticleStatus> {
            return PropallyV1ApiFp(configuration).v1LearningArticlesArticleIdCompletePost(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 学習記事の達成状況を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LearningArticlesStatusesGet(options?: any): AxiosPromise<Array<LearningArticleStatus>> {
            return PropallyV1ApiFp(configuration).v1LearningArticlesStatusesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Appleアカウントでログイン
         * @param {InlineObject2} inlineObject2 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LoginApplePost(inlineObject2: InlineObject2, options?: any): AxiosPromise<User> {
            return PropallyV1ApiFp(configuration).v1LoginApplePost(inlineObject2, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Googleアカウントでログイン
         * @param {InlineObject1} inlineObject1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LoginGooglePost(inlineObject1: InlineObject1, options?: any): AxiosPromise<User> {
            return PropallyV1ApiFp(configuration).v1LoginGooglePost(inlineObject1, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ログイン
         * @param {InlineObject} inlineObject 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LoginPost(inlineObject: InlineObject, options?: any): AxiosPromise<User> {
            return PropallyV1ApiFp(configuration).v1LoginPost(inlineObject, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ログアウト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1LogoutPost(options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1LogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary エージェント検索タグマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataAgentSearchTagsGet(options?: any): AxiosPromise<Array<MasterAgentSearchTag>> {
            return PropallyV1ApiFp(configuration).v1MasterDataAgentSearchTagsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 流入経路マスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataInflowRoutesGet(options?: any): AxiosPromise<Array<IdName>> {
            return PropallyV1ApiFp(configuration).v1MasterDataInflowRoutesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 興味のある物件タイプマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataInterestedPropertyTypesGet(options?: any): AxiosPromise<Array<IdName>> {
            return PropallyV1ApiFp(configuration).v1MasterDataInterestedPropertyTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 都道府県一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataPrefecturesGet(options?: any): AxiosPromise<Array<string>> {
            return PropallyV1ApiFp(configuration).v1MasterDataPrefecturesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 町丁目一覧
         * @param {string} prefectureName 都道府県名
         * @param {string} cityName 市区町村名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName: string, cityName: string, options?: any): AxiosPromise<Array<string>> {
            return PropallyV1ApiFp(configuration).v1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName, cityName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 市区町村一覧
         * @param {string} prefectureName 都道府県名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName: string, options?: any): AxiosPromise<Array<string>> {
            return PropallyV1ApiFp(configuration).v1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 利用目的マスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataPurposeOfUsesGet(options?: any): AxiosPromise<Array<IdName>> {
            return PropallyV1ApiFp(configuration).v1MasterDataPurposeOfUsesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 鉄道一覧
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataRailwaysGet(options?: any): AxiosPromise<Array<IdName>> {
            return PropallyV1ApiFp(configuration).v1MasterDataRailwaysGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 駅名一覧
         * @param {string} railwayName 鉄道名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataRailwaysRailwayNameStationsGet(railwayName: string, options?: any): AxiosPromise<Array<string>> {
            return PropallyV1ApiFp(configuration).v1MasterDataRailwaysRailwayNameStationsGet(railwayName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 居住タイプマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataResidenceTypesGet(options?: any): AxiosPromise<Array<IdName>> {
            return PropallyV1ApiFp(configuration).v1MasterDataResidenceTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary タグマスタ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MasterDataTagsGet(options?: any): AxiosPromise<Array<IdName>> {
            return PropallyV1ApiFp(configuration).v1MasterDataTagsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 最低アプリバージョン取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MinAppVersionGet(options?: any): AxiosPromise<InlineResponse2001> {
            return PropallyV1ApiFp(configuration).v1MinAppVersionGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 三井住友海上営業リストにユーザを登録
         * @param {MsinsLeadEntry} msinsLeadEntry 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1MsinsLeadsPost(msinsLeadEntry: MsinsLeadEntry, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1MsinsLeadsPost(msinsLeadEntry, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary リセット後、新しいパスワードの登録
         * @param {InlineObject6} inlineObject6 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1NewPasswordsPost(inlineObject6: InlineObject6, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1NewPasswordsPost(inlineObject6, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 初回物件登録時エージェント通知
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1NotificationsToAgentForNewPropertyPost(options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1NotificationsToAgentForNewPropertyPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザSTEP1登録時エージェント通知
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1NotificationsToAgentForNewUserPost(options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1NotificationsToAgentForNewUserPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary パスワードリセット
         * @param {InlineObject5} inlineObject5 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PasswordResetsPost(inlineObject5: InlineObject5, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PasswordResetsPost(inlineObject5, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 現行プライバシーポリシーへの同意状態と本文を取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivacyPolicyConsentGet(options?: any): AxiosPromise<PrivacyPolicyConsent> {
            return PropallyV1ApiFp(configuration).v1PrivacyPolicyConsentGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 現行プライバシーポリシーへの同意を記録
         * @param {PrivacyPolicyConsentCreateRequest} privacyPolicyConsentCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PrivacyPolicyConsentPost(privacyPolicyConsentCreateRequest: PrivacyPolicyConsentCreateRequest, options?: any): AxiosPromise<void> {
            return PropallyV1ApiFp(configuration).v1PrivacyPolicyConsentPost(privacyPolicyConsentCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
         * @summary マンション名からAI補完して検討物件を登録
         * @param {InlineObject9} inlineObject9 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiCreateConsiderationPost(inlineObject9: InlineObject9, options?: any): AxiosPromise<Property> {
            return PropallyV1ApiFp(configuration).v1PropertiesAiCreateConsiderationPost(inlineObject9, options).then((request) => request(axios, basePath));
        },
        /**
         * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
         * @summary マンション名からAI補完して保有物件を登録
         * @param {InlineObject8} inlineObject8 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiCreateOwnPost(inlineObject8: InlineObject8, options?: any): AxiosPromise<Property> {
            return PropallyV1ApiFp(configuration).v1PropertiesAiCreateOwnPost(inlineObject8, options).then((request) => request(axios, basePath));
        },
        /**
         * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
         * @summary マンション名からAI補完して物件登録
         * @param {InlineObject7} inlineObject7 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiCreatePost(inlineObject7: InlineObject7, options?: any): AxiosPromise<Property> {
            return PropallyV1ApiFp(configuration).v1PropertiesAiCreatePost(inlineObject7, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 書類PDF/画像をOCRして検討物件の下書きを作成（推定なし）
         * @param {InlineObject13} inlineObject13 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiDraftConsiderationDocumentPost(inlineObject13: InlineObject13, options?: any): AxiosPromise<PropertyBuilder> {
            return PropallyV1ApiFp(configuration).v1PropertiesAiDraftConsiderationDocumentPost(inlineObject13, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary マンション名からAI補完して検討物件の下書きを作成
         * @param {InlineObject12} inlineObject12 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiDraftConsiderationPost(inlineObject12: InlineObject12, options?: any): AxiosPromise<PropertyBuilder> {
            return PropallyV1ApiFp(configuration).v1PropertiesAiDraftConsiderationPost(inlineObject12, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 書類PDF/画像をOCRして保有物件の下書きを作成（推定なし）
         * @param {InlineObject11} inlineObject11 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiDraftOwnDocumentPost(inlineObject11: InlineObject11, options?: any): AxiosPromise<PropertyBuilder> {
            return PropallyV1ApiFp(configuration).v1PropertiesAiDraftOwnDocumentPost(inlineObject11, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary マンション名からAI補完して保有物件の下書きを作成
         * @param {InlineObject10} inlineObject10 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesAiDraftOwnPost(inlineObject10: InlineObject10, options?: any): AxiosPromise<PropertyBuilder> {
            return PropallyV1ApiFp(configuration).v1PropertiesAiDraftOwnPost(inlineObject10, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesGet(options?: any): AxiosPromise<Array<Property>> {
            return PropallyV1ApiFp(configuration).v1PropertiesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 返済期間は1〜50年の整数（借入なしの場合のみ0年も可）、金利は0〜100%です。借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。不整合時は関連データも保存せず422を返します。AI補完した登録にも同じ制約を適用します。
         * @summary 物件登録
         * @param {PropertyBuilder} propertyBuilder 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPost(propertyBuilder: PropertyBuilder, options?: any): AxiosPromise<Property> {
            return PropallyV1ApiFp(configuration).v1PropertiesPost(propertyBuilder, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary AIおまかせ入力のお知らせ閉じ状態を更新
         * @param {number} propertyId 物件 ID
         * @param {PropertyAiCreateNotificationDismissedRequest} propertyAiCreateNotificationDismissedRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdAiCreateNotificationDismissedPatch(propertyId: number, propertyAiCreateNotificationDismissedRequest: PropertyAiCreateNotificationDismissedRequest, options?: any): AxiosPromise<PropertyAiCreateNotificationDismissedResponse> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdAiCreateNotificationDismissedPatch(propertyId, propertyAiCreateNotificationDismissedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 一棟物件の部屋の削除
         * @param {number} propertyId 物件 ID
         * @param {number} buildingRoomId 部屋ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdDelete(propertyId: number, buildingRoomId: number, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdDelete(propertyId, buildingRoomId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 一棟物件の部屋ごとの情報更新
         * @param {number} propertyId 物件 ID
         * @param {number} buildingRoomId 部屋ID
         * @param {BuildingRoom} buildingRoom 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdPatch(propertyId: number, buildingRoomId: number, buildingRoom: BuildingRoom, options?: any): AxiosPromise<BuildingRoom> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdPatch(propertyId, buildingRoomId, buildingRoom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 一棟物件の部屋ごとの情報取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdBuildingRoomsGet(propertyId: number, options?: any): AxiosPromise<Array<BuildingRoom>> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdBuildingRoomsGet(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 一棟物件の部屋ごとの情報登録
         * @param {number} propertyId 物件 ID
         * @param {BuildingRoom} buildingRoom 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdBuildingRoomsPost(propertyId: number, buildingRoom: BuildingRoom, options?: any): AxiosPromise<BuildingRoom> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdBuildingRoomsPost(propertyId, buildingRoom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件削除
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDelete(propertyId: number, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdDelete(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントの削除
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdDelete(propertyId: number, documentType: DocumentType, fileId: number, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdDelete(propertyId, documentType, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントのファイルバイナリ取得
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdGet(propertyId: number, documentType: DocumentType, fileId: number, options?: any): AxiosPromise<any> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdGet(propertyId, documentType, fileId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ドキュメント更新
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {DocumentForm} documentForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch(propertyId: number, documentType: DocumentType, fileId: number, documentForm: DocumentForm, options?: any): AxiosPromise<Document> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch(propertyId, documentType, fileId, documentForm, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントのURLを署名とヘッダー付きで取得
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {number} fileId ファイル ID
         * @param {string} filename ファイル名
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet(propertyId: number, documentType: DocumentType, fileId: number, filename: string, options?: any): AxiosPromise<InlineResponse2004> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet(propertyId, documentType, fileId, filename, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントの一覧取得
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesGet(propertyId: number, documentType: DocumentType, options?: any): AxiosPromise<Array<Document>> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesGet(propertyId, documentType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件に紐づくドキュメントの登録
         * @param {number} propertyId 物件 ID
         * @param {DocumentType} documentType 
         * @param {Base64EncodedImage} base64EncodedImage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdDocumentsDocumentTypeFilesPost(propertyId: number, documentType: DocumentType, base64EncodedImage: Base64EncodedImage, options?: any): AxiosPromise<Document> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesPost(propertyId, documentType, base64EncodedImage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件に紐づく画像の削除
         * @param {number} propertyId 物件 ID
         * @param {number} imageId 画像 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdImagesImageIdDelete(propertyId: number, imageId: number, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdImagesImageIdDelete(propertyId, imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件に紐づく画像ごとの URL 取得
         * @param {number} propertyId 物件 ID
         * @param {number} imageId 画像 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdImagesImageIdUrlGet(propertyId: number, imageId: number, options?: any): AxiosPromise<InlineResponse2003> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdImagesImageIdUrlGet(propertyId, imageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件ごとの画像登録
         * @param {number} propertyId 物件 ID
         * @param {Base64EncodedImage} base64EncodedImage 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdImagesPost(propertyId: number, base64EncodedImage: Base64EncodedImage, options?: any): AxiosPromise<Id> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdImagesPost(propertyId, base64EncodedImage, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdLeaseContractsGet(propertyId: number, options?: any): AxiosPromise<Array<LeaseContract>> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdLeaseContractsGet(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約削除
         * @param {number} propertyId 物件 ID
         * @param {number} leaseContractId 賃貸契約ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdLeaseContractsLeaseContractIdDelete(propertyId: number, leaseContractId: number, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdLeaseContractsLeaseContractIdDelete(propertyId, leaseContractId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約更新
         * @param {number} propertyId 物件 ID
         * @param {number} leaseContractId 賃貸契約ID
         * @param {LeaseContract} leaseContract 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdLeaseContractsLeaseContractIdPatch(propertyId: number, leaseContractId: number, leaseContract: LeaseContract, options?: any): AxiosPromise<LeaseContract> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdLeaseContractsLeaseContractIdPatch(propertyId, leaseContractId, leaseContract, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件ごとの賃貸契約登録
         * @param {number} propertyId 物件 ID
         * @param {LeaseContract} leaseContract 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdLeaseContractsPost(propertyId: number, leaseContract: LeaseContract, options?: any): AxiosPromise<LeaseContract> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdLeaseContractsPost(propertyId, leaseContract, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 金利履歴の登録・訂正・削除（訂正は原子的に保存）
         * @param {number} propertyId 
         * @param {LoanInterestRateUpdate} loanInterestRateUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdLoanInterestRatesPatch(propertyId: number, loanInterestRateUpdate: LoanInterestRateUpdate, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdLoanInterestRatesPatch(propertyId, loanInterestRateUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 各項目ごとの合計取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdMonthlyCashflowResultSumByItemGet(propertyId: number, options?: any): AxiosPromise<MonthlyCashflowResultSumByItem> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdMonthlyCashflowResultSumByItemGet(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 月毎の（ユーザ定義による）実績一覧
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdMonthlyCashflowResultsGet(propertyId: number, options?: any): AxiosPromise<Array<MonthlyCashflowResult>> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdMonthlyCashflowResultsGet(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 旧アプリとの互換性のため、金利は数値文字列も数値へ変換して受け付ける。有限な0〜100%のみ有効。金利のnull化・行削除でも初回返済月に必要な金利は保護する。
         * @summary 月毎の（ユーザ定義による）実績登録
         * @param {number} propertyId 物件 ID
         * @param {MonthlyCashflowResultUpdate} monthlyCashflowResultUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdMonthlyCashflowResultsPatch(propertyId: number, monthlyCashflowResultUpdate: MonthlyCashflowResultUpdate, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdMonthlyCashflowResultsPatch(propertyId, monthlyCashflowResultUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件に紐づく周辺情報(不動価格)取得
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdNearbyPricesGet(propertyId: number, options?: any): AxiosPromise<Array<ReinfolibPrice>> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdNearbyPricesGet(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 返済期間または借入額の変更時は、返済期間を1〜50年の整数（借入なしの場合のみ0年も可）で検証します。範囲外は422を返します。既存の範囲外データでも、無関係な項目の更新は許可します。
         * @summary 物件更新
         * @param {number} propertyId 物件 ID
         * @param {PropertyUpdate} propertyUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdPatch(propertyId: number, propertyUpdate: PropertyUpdate, options?: any): AxiosPromise<Property> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdPatch(propertyId, propertyUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定
         * @param {number} propertyId 物件 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdSimulationConfigsGet(propertyId: number, options?: any): AxiosPromise<Array<SimulationConfigWithId>> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdSimulationConfigsGet(propertyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定登録
         * @param {number} propertyId 物件 ID
         * @param {SimulationConfig} simulationConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdSimulationConfigsPost(propertyId: number, simulationConfig: SimulationConfig, options?: any): AxiosPromise<SimulationConfigWithId> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdSimulationConfigsPost(propertyId, simulationConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定の削除
         * @param {number} propertyId 物件 ID
         * @param {number} simulationConfigId シミュレーション設定 ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdDelete(propertyId: number, simulationConfigId: number, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdDelete(propertyId, simulationConfigId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定の更新
         * @param {number} propertyId 物件 ID
         * @param {number} simulationConfigId シミュレーション設定 ID
         * @param {SimulationConfig} simulationConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdPatch(propertyId: number, simulationConfigId: number, simulationConfig: SimulationConfig, options?: any): AxiosPromise<SimulationConfigWithId> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdPatch(propertyId, simulationConfigId, simulationConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件ごとのシミュレーション設定における修繕積立金の金額変動の更新
         * @param {number} propertyId 物件 ID
         * @param {number} simulationConfigId シミュレーション設定 ID
         * @param {InlineObject14} inlineObject14 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdReserveFundPriceChangesPost(propertyId: number, simulationConfigId: number, inlineObject14: InlineObject14, options?: any): AxiosPromise<Array<ReserveFundPriceChange>> {
            return PropallyV1ApiFp(configuration).v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdReserveFundPriceChangesPost(propertyId, simulationConfigId, inlineObject14, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件一時保存状態削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertyTemporaryDelete(options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PropertyTemporaryDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件一時保存状態取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertyTemporaryGet(options?: any): AxiosPromise<PropertyTemporary> {
            return PropallyV1ApiFp(configuration).v1PropertyTemporaryGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 物件一時保存状態登録・更新
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1PropertyTemporaryPost(options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1PropertyTemporaryPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary マッチング一覧取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ProposalMatchingsGet(options?: any): AxiosPromise<Array<ProposalMatching>> {
            return PropallyV1ApiFp(configuration).v1ProposalMatchingsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary マッチング登録
         * @param {ProposalMatchingRequest} proposalMatchingRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ProposalMatchingsPost(proposalMatchingRequest: ProposalMatchingRequest, options?: any): AxiosPromise<ResponseMessage> {
            return PropallyV1ApiFp(configuration).v1ProposalMatchingsPost(proposalMatchingRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Appleアカウントでユーザー登録
         * @param {UserRegistrationsApple} userRegistrationsApple 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RegistrationsApplePost(userRegistrationsApple: UserRegistrationsApple, options?: any): AxiosPromise<User> {
            return PropallyV1ApiFp(configuration).v1RegistrationsApplePost(userRegistrationsApple, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Googleアカウントでユーザー登録
         * @param {UserRegistrationsGoogle} userRegistrationsGoogle 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RegistrationsGooglePost(userRegistrationsGoogle: UserRegistrationsGoogle, options?: any): AxiosPromise<User> {
            return PropallyV1ApiFp(configuration).v1RegistrationsGooglePost(userRegistrationsGoogle, options).then((request) => request(axios, basePath));
        },
        /**
         * 年収検証フラグ有効時は万円単位の0〜100,000（10億円）を許可し、範囲外は補正せず422を返します。旧アプリ移行中は既定OFFです。
         * @summary ユーザー登録
         * @param {UserRegistrations} userRegistrations 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1RegistrationsPost(userRegistrations: UserRegistrations, options?: any): AxiosPromise<User> {
            return PropallyV1ApiFp(configuration).v1RegistrationsPost(userRegistrations, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 電話番号認証コード送信
         * @param {InlineObject4} inlineObject4 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SendPhoneNumberAuthCodesPost(inlineObject4: InlineObject4, options?: any): AxiosPromise<InlineResponse2002> {
            return PropallyV1ApiFp(configuration).v1SendPhoneNumberAuthCodesPost(inlineObject4, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ログイン状況確認
         * @param {string} [adjustNetwork] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SessionGet(adjustNetwork?: string, options?: any): AxiosPromise<void> {
            return PropallyV1ApiFp(configuration).v1SessionGet(adjustNetwork, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary SMAUL 問い合わせを認証ユーザー情報付きで登録
         * @param {SmaulLeadV1Request} smaulLeadV1Request 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1SmaulLeadsPost(smaulLeadV1Request: SmaulLeadV1Request, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1SmaulLeadsPost(smaulLeadV1Request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザ画面アクセス登録
         * @param {UserAccessScreenLog} userAccessScreenLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserAccessScreenLogsPost(userAccessScreenLog: UserAccessScreenLog, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1UserAccessScreenLogsPost(userAccessScreenLog, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザデータ初回登録ステータス取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserDataFirstRegisteredStatusGet(options?: any): AxiosPromise<UserDataFirstRegisteredStatus> {
            return PropallyV1ApiFp(configuration).v1UserDataFirstRegisteredStatusGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザデータ初回登録ステータス更新
         * @param {UserDataFirstRegisteredStatus} userDataFirstRegisteredStatus 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus: UserDataFirstRegisteredStatus, options?: any): AxiosPromise<UserDataFirstRegisteredStatus> {
            return PropallyV1ApiFp(configuration).v1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーデバイストークン登録削除
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserDeviceTokenDelete(options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1UserDeviceTokenDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーデバイストークン登録
         * @param {UserDeviceToken} userDeviceToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserDeviceTokenPost(userDeviceToken: UserDeviceToken, options?: any): AxiosPromise<InlineResponse401> {
            return PropallyV1ApiFp(configuration).v1UserDeviceTokenPost(userDeviceToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザー情報取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserGet(options?: any): AxiosPromise<User> {
            return PropallyV1ApiFp(configuration).v1UserGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 年収検証フラグ有効時は万円単位の0〜100,000（10億円）を許可します。年収の変更時に検証し、範囲外は補正せず422を返します。旧アプリ移行中は既定OFFです。
         * @summary ユーザー情報更新
         * @param {UserUpdate} userUpdate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserPatch(userUpdate: UserUpdate, options?: any): AxiosPromise<User> {
            return PropallyV1ApiFp(configuration).v1UserPatch(userUpdate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーオファー登録
         * @param {UserProposalRequest} userProposalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserProposalsPost(userProposalRequest: UserProposalRequest, options?: any): AxiosPromise<UserProposalResponse> {
            return PropallyV1ApiFp(configuration).v1UserProposalsPost(userProposalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーオファーの希望連絡日程更新
         * @param {number} userProposalId ユーザーオファー ID
         * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserProposalsUserProposalIdPreferredContactSchedulesPatch(userProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options?: any): AxiosPromise<ResponseMessage> {
            return PropallyV1ApiFp(configuration).v1UserProposalsUserProposalIdPreferredContactSchedulesPatch(userProposalId, investmentProposalPreferredContactSchedulesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ユーザーオファー登録（追加マッチング候補付き）
         * @param {UserProposalRequest} userProposalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserProposalsWithRecommendationsPost(userProposalRequest: UserProposalRequest, options?: any): AxiosPromise<UserProposalWithRecommendationsResponse> {
            return PropallyV1ApiFp(configuration).v1UserProposalsWithRecommendationsPost(userProposalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 累計既読/マッチング件数取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1UserTotalReadAndMatchCountGet(options?: any): AxiosPromise<TotalReadAndMatchCountResponse> {
            return PropallyV1ApiFp(configuration).v1UserTotalReadAndMatchCountGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary プレミアムウェビナー一覧取得
         * @param {number} [page] 
         * @param {number} [perPage] 
         * @param {boolean} [recentOnly] 最近のウェビナーのみ取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarsGet(page?: number, perPage?: number, recentOnly?: boolean, options?: any): AxiosPromise<InlineResponse2005> {
            return PropallyV1ApiFp(configuration).v1WebinarsGet(page, perPage, recentOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary プレミアムウェビナーのハイライト取得
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarsHighlightGet(options?: any): AxiosPromise<InlineResponse2005> {
            return PropallyV1ApiFp(configuration).v1WebinarsHighlightGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary プレミアムウェビナー詳細取得
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarsIdGet(id: string, options?: any): AxiosPromise<InlineResponse2006> {
            return PropallyV1ApiFp(configuration).v1WebinarsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary プレミアムウェビナー視聴ログ作成
         * @param {string} id 
         * @param {WebinarViewingCreateRequest} webinarViewingCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarsIdViewHistoriesPost(id: string, webinarViewingCreateRequest: WebinarViewingCreateRequest, options?: any): AxiosPromise<InlineResponse201> {
            return PropallyV1ApiFp(configuration).v1WebinarsIdViewHistoriesPost(id, webinarViewingCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary プレミアムウェビナー視聴ログ更新
         * @param {string} id 
         * @param {string} viewingId 
         * @param {WebinarViewingUpdateRequest} webinarViewingUpdateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1WebinarsIdViewHistoriesViewingIdPatch(id: string, viewingId: string, webinarViewingUpdateRequest: WebinarViewingUpdateRequest, options?: any): AxiosPromise<InlineResponse201> {
            return PropallyV1ApiFp(configuration).v1WebinarsIdViewHistoriesViewingIdPatch(id, viewingId, webinarViewingUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PropallyV1Api - object-oriented interface
 * @export
 * @class PropallyV1Api
 * @extends {BaseAPI}
 */
export class PropallyV1Api extends BaseAPI {
    /**
     * 
     * @summary ヘルスチェックエンドポイント
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public healthzGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).healthzGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary エージェント詳細画面アクセス登録
     * @param {AgentDetailAccessLogRequest} agentDetailAccessLogRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AgentDetailAccessLogsPost(agentDetailAccessLogRequest: AgentDetailAccessLogRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AgentDetailAccessLogsPost(agentDetailAccessLogRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary エージェント別投資提案サマリー一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AgentInvestmentProposalSummariesGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AgentInvestmentProposalSummariesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary エージェントの連絡対応可能枠取得
     * @param {number} agentId エージェント ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AgentsAgentIdAvailableContactSlotsGet(agentId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AgentsAgentIdAvailableContactSlotsGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary エージェント取得
     * @param {number} agentId エージェント ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AgentsAgentIdGet(agentId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AgentsAgentIdGet(agentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 「入力内容にマッチ」「直近で高評価」「直近でアクティブ」の3セクションをまとめて取得する 
     * @summary 初回ロード用のエージェント検索結果をまとめて取得
     * @param {number} [perSectionPerPage] 各セクションの1ページあたり件数（初回）
     * @param {AgentSearchRequest} [agentSearchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AgentsFeedsPost(perSectionPerPage?: number, agentSearchRequest?: AgentSearchRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AgentsFeedsPost(perSectionPerPage, agentSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary セクション毎の検索結果を追加で取得する
     * @param {'match' | 'top_rated' | 'active'} section セクション名
     * @param {number} [page] 取得したいページ番号（範囲外・型不一致はリクエスト検証により 400）
     * @param {number} [perPage] 1ページあたりの件数（範囲外・型不一致はリクエスト検証により 400）
     * @param {AgentsSortOptionEnum} [sort] 並び順。match セクションでのみ有効で、compatibility 指定時はログインユーザーとの相性順 （相性が算出できないエージェントは最後尾）。絞り込み後の母集団全体を相性順に並べたうえで ページングするため、ページを跨いでも並びが崩れない。 未指定時は従来の並び順（タグ指定ありはタグ一致数順、なしは id 降順）。 match 以外のセクションに指定した場合は無視する。enum 外の値はリクエスト検証により 400。 
     * @param {AgentSearchRequest} [agentSearchRequest] 検索条件。 match の追加ロードで正しく is_search を記録するには、クライアントが検索時の company_agent_search_tag_ids を再送する必要がある（再送しないと検索由来の表示が is_search: false になる） 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AgentsFeedsSectionPost(section: 'match' | 'top_rated' | 'active', page?: number, perPage?: number, sort?: AgentsSortOptionEnum, agentSearchRequest?: AgentSearchRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AgentsFeedsSectionPost(section, page, perPage, sort, agentSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary エージェント取得
     * @param {number} [page] 取得したいページ番号
     * @param {number} [perPage] 1ページあたりの件数（範囲外・型不一致はリクエスト検証により 400）
     * @param {AgentsSortOptionEnum} [sort] 並び順。compatibility 指定時はログインユーザーとの相性順（相性が算出できないエージェントは最後尾）。 未指定時は従来の並び順（id 降順）。enum 外の値はリクエスト検証により 400。 
     * @param {boolean} [includeAllPublic] 診断後のプランナー選択用。true かつ sort&#x3D;compatibility の場合、相性面・詳細条件検索の個別表示設定が両方ONの公開対象全員を相性順で返す。
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AgentsGet(page?: number, perPage?: number, sort?: AgentsSortOptionEnum, includeAllPublic?: boolean, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AgentsGet(page, perPage, sort, includeAllPublic, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary エージェント検索
     * @param {number} [page] 表示したいページ番号
     * @param {number} [perPage] 1ページあたりの件数
     * @param {AgentSearchRequest} [agentSearchRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AgentsSearchPost(page?: number, perPage?: number, agentSearchRequest?: AgentSearchRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AgentsSearchPost(page, perPage, agentSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary アナウンス既読更新
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AnnouncementsReadPatch(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AnnouncementsReadPatch(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 査定提案未読数取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AssessmentProposalUnreadCountGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AssessmentProposalUnreadCountGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 査定提案承認or否承認実行
     * @param {number} assessmentProposalId 査定提案 ID
     * @param {ProposalApprovedRequest} proposalApprovedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AssessmentProposalsAssessmentProposalIdApprovedPatch(assessmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AssessmentProposalsAssessmentProposalIdApprovedPatch(assessmentProposalId, proposalApprovedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary エージェント・企業情報を含む査定提案詳細1件取得
     * @param {number} assessmentProposalId 査定提案 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AssessmentProposalsAssessmentProposalIdGet(assessmentProposalId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AssessmentProposalsAssessmentProposalIdGet(assessmentProposalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 査定提案の希望連絡日程更新
     * @param {number} assessmentProposalId 査定提案 ID
     * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AssessmentProposalsAssessmentProposalIdPreferredContactSchedulesPatch(assessmentProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AssessmentProposalsAssessmentProposalIdPreferredContactSchedulesPatch(assessmentProposalId, investmentProposalPreferredContactSchedulesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 査定提案既読更新
     * @param {number} assessmentProposalId 査定提案 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AssessmentProposalsAssessmentProposalIdReadPatch(assessmentProposalId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AssessmentProposalsAssessmentProposalIdReadPatch(assessmentProposalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 査定提案一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1AssessmentProposalsGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1AssessmentProposalsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Propally限定物件一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1CompanyLimitedPropertiesGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1CompanyLimitedPropertiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary メールアドレス確認
     * @param {InlineObject3} inlineObject3 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1EmailConfirmationsPost(inlineObject3: InlineObject3, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1EmailConfirmationsPost(inlineObject3, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary HowMa(外部API)物件詳細(部屋情報一覧)API
     * @param {number} buildingId (HowMa管理の)マンションID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1HowmaBuildingsBuildingIdGet(buildingId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1HowmaBuildingsBuildingIdGet(buildingId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary HowMa(外部API)物件検索API
     * @param {HowMaBuildingsSearchRequest} howMaBuildingsSearchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1HowmaBuildingsPost(howMaBuildingsSearchRequest: HowMaBuildingsSearchRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1HowmaBuildingsPost(howMaBuildingsSearchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 投資提案の対エージェントステータス更新
     * @param {InvestmentProposalStatusUpdateRequest} investmentProposalStatusUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentProposalStatusPatch(investmentProposalStatusUpdateRequest: InvestmentProposalStatusUpdateRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentProposalStatusPatch(investmentProposalStatusUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 投資提案未読数取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentProposalUnreadCountGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentProposalUnreadCountGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 投資提案一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentProposalsGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentProposalsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 投資提案承認or否承認実行
     * @param {number} investmentProposalId 投資提案 ID
     * @param {ProposalApprovedRequest} proposalApprovedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentProposalsInvestmentProposalIdApprovedPatch(investmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentProposalsInvestmentProposalIdApprovedPatch(investmentProposalId, proposalApprovedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 投資提案承認or否承認実行（追加マッチング候補付き）
     * @param {number} investmentProposalId 投資提案 ID
     * @param {ProposalApprovedRequest} proposalApprovedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentProposalsInvestmentProposalIdApprovedWithRecommendationsPatch(investmentProposalId: number, proposalApprovedRequest: ProposalApprovedRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentProposalsInvestmentProposalIdApprovedWithRecommendationsPatch(investmentProposalId, proposalApprovedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 投資提案詳細1件取得
     * @param {number} investmentProposalId 投資提案 ID
     * @param {boolean} [hasHistory] 過去の投資提案も取得するフラグ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentProposalsInvestmentProposalIdGet(investmentProposalId: number, hasHistory?: boolean, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentProposalsInvestmentProposalIdGet(investmentProposalId, hasHistory, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 投資提案の希望連絡日程更新
     * @param {number} investmentProposalId 投資提案 ID
     * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentProposalsInvestmentProposalIdPreferredContactSchedulesPatch(investmentProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentProposalsInvestmentProposalIdPreferredContactSchedulesPatch(investmentProposalId, investmentProposalPreferredContactSchedulesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 投資提案既読更新
     * @param {number} investmentProposalId 投資提案 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentProposalsInvestmentProposalIdReadPatch(investmentProposalId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentProposalsInvestmentProposalIdReadPatch(investmentProposalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メッセージ詳細の「お断り」。お断りの単位はメッセージではなくプランナーで、 以後そのプランナーからのメッセージ（過去分も含む）は一覧・詳細・未読件数・通知に出なくなる。解除はできない。 お断り済みのプランナーのメッセージに再度呼んでも 200 を返す（冪等）。 
     * @summary 投資提案の送信元プランナーをお断り
     * @param {number} investmentProposalId 投資提案 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentProposalsInvestmentProposalIdRefusalPost(investmentProposalId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentProposalsInvestmentProposalIdRefusalPost(investmentProposalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 投資スタイル診断の結果取得（本人）
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentStyleDiagnosisGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentStyleDiagnosisGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 投資スタイル診断の回答送信・結果取得
     * @param {InvestmentStyleDiagnosisRequest} investmentStyleDiagnosisRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1InvestmentStyleDiagnosisPost(investmentStyleDiagnosisRequest: InvestmentStyleDiagnosisRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1InvestmentStyleDiagnosisPost(investmentStyleDiagnosisRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 学習記事を達成済みに登録
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1LearningArticlesArticleIdCompletePost(articleId: string, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1LearningArticlesArticleIdCompletePost(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 学習記事の達成状況を取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1LearningArticlesStatusesGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1LearningArticlesStatusesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Appleアカウントでログイン
     * @param {InlineObject2} inlineObject2 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1LoginApplePost(inlineObject2: InlineObject2, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1LoginApplePost(inlineObject2, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Googleアカウントでログイン
     * @param {InlineObject1} inlineObject1 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1LoginGooglePost(inlineObject1: InlineObject1, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1LoginGooglePost(inlineObject1, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ログイン
     * @param {InlineObject} inlineObject 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1LoginPost(inlineObject: InlineObject, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1LoginPost(inlineObject, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ログアウト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1LogoutPost(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1LogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary エージェント検索タグマスタ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataAgentSearchTagsGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataAgentSearchTagsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 流入経路マスタ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataInflowRoutesGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataInflowRoutesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 興味のある物件タイプマスタ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataInterestedPropertyTypesGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataInterestedPropertyTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 都道府県一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataPrefecturesGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataPrefecturesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 町丁目一覧
     * @param {string} prefectureName 都道府県名
     * @param {string} cityName 市区町村名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName: string, cityName: string, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataPrefecturesPrefectureNameCitiesCityNameTownsGet(prefectureName, cityName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 市区町村一覧
     * @param {string} prefectureName 都道府県名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName: string, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataPrefecturesPrefectureNameCitiesGet(prefectureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 利用目的マスタ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataPurposeOfUsesGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataPurposeOfUsesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 鉄道一覧
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataRailwaysGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataRailwaysGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 駅名一覧
     * @param {string} railwayName 鉄道名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataRailwaysRailwayNameStationsGet(railwayName: string, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataRailwaysRailwayNameStationsGet(railwayName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 居住タイプマスタ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataResidenceTypesGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataResidenceTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary タグマスタ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MasterDataTagsGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MasterDataTagsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 最低アプリバージョン取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MinAppVersionGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MinAppVersionGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 三井住友海上営業リストにユーザを登録
     * @param {MsinsLeadEntry} msinsLeadEntry 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1MsinsLeadsPost(msinsLeadEntry: MsinsLeadEntry, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1MsinsLeadsPost(msinsLeadEntry, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary リセット後、新しいパスワードの登録
     * @param {InlineObject6} inlineObject6 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1NewPasswordsPost(inlineObject6: InlineObject6, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1NewPasswordsPost(inlineObject6, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 初回物件登録時エージェント通知
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1NotificationsToAgentForNewPropertyPost(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1NotificationsToAgentForNewPropertyPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザSTEP1登録時エージェント通知
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1NotificationsToAgentForNewUserPost(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1NotificationsToAgentForNewUserPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary パスワードリセット
     * @param {InlineObject5} inlineObject5 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PasswordResetsPost(inlineObject5: InlineObject5, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PasswordResetsPost(inlineObject5, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 現行プライバシーポリシーへの同意状態と本文を取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PrivacyPolicyConsentGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PrivacyPolicyConsentGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 現行プライバシーポリシーへの同意を記録
     * @param {PrivacyPolicyConsentCreateRequest} privacyPolicyConsentCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PrivacyPolicyConsentPost(privacyPolicyConsentCreateRequest: PrivacyPolicyConsentCreateRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PrivacyPolicyConsentPost(privacyPolicyConsentCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
     * @summary マンション名からAI補完して検討物件を登録
     * @param {InlineObject9} inlineObject9 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesAiCreateConsiderationPost(inlineObject9: InlineObject9, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesAiCreateConsiderationPost(inlineObject9, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
     * @summary マンション名からAI補完して保有物件を登録
     * @param {InlineObject8} inlineObject8 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesAiCreateOwnPost(inlineObject8: InlineObject8, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesAiCreateOwnPost(inlineObject8, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。金利は0〜100%です。不整合時は関連データも保存しません。
     * @summary マンション名からAI補完して物件登録
     * @param {InlineObject7} inlineObject7 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesAiCreatePost(inlineObject7: InlineObject7, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesAiCreatePost(inlineObject7, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 書類PDF/画像をOCRして検討物件の下書きを作成（推定なし）
     * @param {InlineObject13} inlineObject13 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesAiDraftConsiderationDocumentPost(inlineObject13: InlineObject13, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesAiDraftConsiderationDocumentPost(inlineObject13, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary マンション名からAI補完して検討物件の下書きを作成
     * @param {InlineObject12} inlineObject12 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesAiDraftConsiderationPost(inlineObject12: InlineObject12, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesAiDraftConsiderationPost(inlineObject12, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 書類PDF/画像をOCRして保有物件の下書きを作成（推定なし）
     * @param {InlineObject11} inlineObject11 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesAiDraftOwnDocumentPost(inlineObject11: InlineObject11, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesAiDraftOwnDocumentPost(inlineObject11, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary マンション名からAI補完して保有物件の下書きを作成
     * @param {InlineObject10} inlineObject10 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesAiDraftOwnPost(inlineObject10: InlineObject10, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesAiDraftOwnPost(inlineObject10, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 返済期間は1〜50年の整数（借入なしの場合のみ0年も可）、金利は0〜100%です。借入がある場合、初回返済月は購入月以降とし、適用できる初期金利が必要です。不整合時は関連データも保存せず422を返します。AI補完した登録にも同じ制約を適用します。
     * @summary 物件登録
     * @param {PropertyBuilder} propertyBuilder 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPost(propertyBuilder: PropertyBuilder, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPost(propertyBuilder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary AIおまかせ入力のお知らせ閉じ状態を更新
     * @param {number} propertyId 物件 ID
     * @param {PropertyAiCreateNotificationDismissedRequest} propertyAiCreateNotificationDismissedRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdAiCreateNotificationDismissedPatch(propertyId: number, propertyAiCreateNotificationDismissedRequest: PropertyAiCreateNotificationDismissedRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdAiCreateNotificationDismissedPatch(propertyId, propertyAiCreateNotificationDismissedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 一棟物件の部屋の削除
     * @param {number} propertyId 物件 ID
     * @param {number} buildingRoomId 部屋ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdDelete(propertyId: number, buildingRoomId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdDelete(propertyId, buildingRoomId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 一棟物件の部屋ごとの情報更新
     * @param {number} propertyId 物件 ID
     * @param {number} buildingRoomId 部屋ID
     * @param {BuildingRoom} buildingRoom 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdPatch(propertyId: number, buildingRoomId: number, buildingRoom: BuildingRoom, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdBuildingRoomsBuildingRoomIdPatch(propertyId, buildingRoomId, buildingRoom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 一棟物件の部屋ごとの情報取得
     * @param {number} propertyId 物件 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdBuildingRoomsGet(propertyId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdBuildingRoomsGet(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 一棟物件の部屋ごとの情報登録
     * @param {number} propertyId 物件 ID
     * @param {BuildingRoom} buildingRoom 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdBuildingRoomsPost(propertyId: number, buildingRoom: BuildingRoom, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdBuildingRoomsPost(propertyId, buildingRoom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件削除
     * @param {number} propertyId 物件 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdDelete(propertyId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdDelete(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件に紐づくドキュメントの削除
     * @param {number} propertyId 物件 ID
     * @param {DocumentType} documentType 
     * @param {number} fileId ファイル ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdDelete(propertyId: number, documentType: DocumentType, fileId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdDelete(propertyId, documentType, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件に紐づくドキュメントのファイルバイナリ取得
     * @param {number} propertyId 物件 ID
     * @param {DocumentType} documentType 
     * @param {number} fileId ファイル ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdGet(propertyId: number, documentType: DocumentType, fileId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdGet(propertyId, documentType, fileId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ドキュメント更新
     * @param {number} propertyId 物件 ID
     * @param {DocumentType} documentType 
     * @param {number} fileId ファイル ID
     * @param {DocumentForm} documentForm 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch(propertyId: number, documentType: DocumentType, fileId: number, documentForm: DocumentForm, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdPatch(propertyId, documentType, fileId, documentForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件に紐づくドキュメントのURLを署名とヘッダー付きで取得
     * @param {number} propertyId 物件 ID
     * @param {DocumentType} documentType 
     * @param {number} fileId ファイル ID
     * @param {string} filename ファイル名
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet(propertyId: number, documentType: DocumentType, fileId: number, filename: string, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesFileIdUrlGet(propertyId, documentType, fileId, filename, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件に紐づくドキュメントの一覧取得
     * @param {number} propertyId 物件 ID
     * @param {DocumentType} documentType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdDocumentsDocumentTypeFilesGet(propertyId: number, documentType: DocumentType, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesGet(propertyId, documentType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件に紐づくドキュメントの登録
     * @param {number} propertyId 物件 ID
     * @param {DocumentType} documentType 
     * @param {Base64EncodedImage} base64EncodedImage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdDocumentsDocumentTypeFilesPost(propertyId: number, documentType: DocumentType, base64EncodedImage: Base64EncodedImage, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdDocumentsDocumentTypeFilesPost(propertyId, documentType, base64EncodedImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件に紐づく画像の削除
     * @param {number} propertyId 物件 ID
     * @param {number} imageId 画像 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdImagesImageIdDelete(propertyId: number, imageId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdImagesImageIdDelete(propertyId, imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件に紐づく画像ごとの URL 取得
     * @param {number} propertyId 物件 ID
     * @param {number} imageId 画像 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdImagesImageIdUrlGet(propertyId: number, imageId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdImagesImageIdUrlGet(propertyId, imageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件ごとの画像登録
     * @param {number} propertyId 物件 ID
     * @param {Base64EncodedImage} base64EncodedImage 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdImagesPost(propertyId: number, base64EncodedImage: Base64EncodedImage, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdImagesPost(propertyId, base64EncodedImage, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件ごとの賃貸契約取得
     * @param {number} propertyId 物件 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdLeaseContractsGet(propertyId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdLeaseContractsGet(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件ごとの賃貸契約削除
     * @param {number} propertyId 物件 ID
     * @param {number} leaseContractId 賃貸契約ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdLeaseContractsLeaseContractIdDelete(propertyId: number, leaseContractId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdLeaseContractsLeaseContractIdDelete(propertyId, leaseContractId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件ごとの賃貸契約更新
     * @param {number} propertyId 物件 ID
     * @param {number} leaseContractId 賃貸契約ID
     * @param {LeaseContract} leaseContract 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdLeaseContractsLeaseContractIdPatch(propertyId: number, leaseContractId: number, leaseContract: LeaseContract, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdLeaseContractsLeaseContractIdPatch(propertyId, leaseContractId, leaseContract, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件ごとの賃貸契約登録
     * @param {number} propertyId 物件 ID
     * @param {LeaseContract} leaseContract 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdLeaseContractsPost(propertyId: number, leaseContract: LeaseContract, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdLeaseContractsPost(propertyId, leaseContract, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 金利履歴の登録・訂正・削除（訂正は原子的に保存）
     * @param {number} propertyId 
     * @param {LoanInterestRateUpdate} loanInterestRateUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdLoanInterestRatesPatch(propertyId: number, loanInterestRateUpdate: LoanInterestRateUpdate, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdLoanInterestRatesPatch(propertyId, loanInterestRateUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 各項目ごとの合計取得
     * @param {number} propertyId 物件 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdMonthlyCashflowResultSumByItemGet(propertyId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdMonthlyCashflowResultSumByItemGet(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 月毎の（ユーザ定義による）実績一覧
     * @param {number} propertyId 物件 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdMonthlyCashflowResultsGet(propertyId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdMonthlyCashflowResultsGet(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 旧アプリとの互換性のため、金利は数値文字列も数値へ変換して受け付ける。有限な0〜100%のみ有効。金利のnull化・行削除でも初回返済月に必要な金利は保護する。
     * @summary 月毎の（ユーザ定義による）実績登録
     * @param {number} propertyId 物件 ID
     * @param {MonthlyCashflowResultUpdate} monthlyCashflowResultUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdMonthlyCashflowResultsPatch(propertyId: number, monthlyCashflowResultUpdate: MonthlyCashflowResultUpdate, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdMonthlyCashflowResultsPatch(propertyId, monthlyCashflowResultUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件に紐づく周辺情報(不動価格)取得
     * @param {number} propertyId 物件 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdNearbyPricesGet(propertyId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdNearbyPricesGet(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 返済期間または借入額の変更時は、返済期間を1〜50年の整数（借入なしの場合のみ0年も可）で検証します。範囲外は422を返します。既存の範囲外データでも、無関係な項目の更新は許可します。
     * @summary 物件更新
     * @param {number} propertyId 物件 ID
     * @param {PropertyUpdate} propertyUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdPatch(propertyId: number, propertyUpdate: PropertyUpdate, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdPatch(propertyId, propertyUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件ごとのシミュレーション設定
     * @param {number} propertyId 物件 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdSimulationConfigsGet(propertyId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdSimulationConfigsGet(propertyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件ごとのシミュレーション設定登録
     * @param {number} propertyId 物件 ID
     * @param {SimulationConfig} simulationConfig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdSimulationConfigsPost(propertyId: number, simulationConfig: SimulationConfig, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdSimulationConfigsPost(propertyId, simulationConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件ごとのシミュレーション設定の削除
     * @param {number} propertyId 物件 ID
     * @param {number} simulationConfigId シミュレーション設定 ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdDelete(propertyId: number, simulationConfigId: number, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdDelete(propertyId, simulationConfigId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件ごとのシミュレーション設定の更新
     * @param {number} propertyId 物件 ID
     * @param {number} simulationConfigId シミュレーション設定 ID
     * @param {SimulationConfig} simulationConfig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdPatch(propertyId: number, simulationConfigId: number, simulationConfig: SimulationConfig, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdPatch(propertyId, simulationConfigId, simulationConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件ごとのシミュレーション設定における修繕積立金の金額変動の更新
     * @param {number} propertyId 物件 ID
     * @param {number} simulationConfigId シミュレーション設定 ID
     * @param {InlineObject14} inlineObject14 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdReserveFundPriceChangesPost(propertyId: number, simulationConfigId: number, inlineObject14: InlineObject14, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertiesPropertyIdSimulationConfigsSimulationConfigIdReserveFundPriceChangesPost(propertyId, simulationConfigId, inlineObject14, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件一時保存状態削除
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertyTemporaryDelete(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertyTemporaryDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件一時保存状態取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertyTemporaryGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertyTemporaryGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 物件一時保存状態登録・更新
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1PropertyTemporaryPost(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1PropertyTemporaryPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary マッチング一覧取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1ProposalMatchingsGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1ProposalMatchingsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary マッチング登録
     * @param {ProposalMatchingRequest} proposalMatchingRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1ProposalMatchingsPost(proposalMatchingRequest: ProposalMatchingRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1ProposalMatchingsPost(proposalMatchingRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Appleアカウントでユーザー登録
     * @param {UserRegistrationsApple} userRegistrationsApple 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1RegistrationsApplePost(userRegistrationsApple: UserRegistrationsApple, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1RegistrationsApplePost(userRegistrationsApple, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Googleアカウントでユーザー登録
     * @param {UserRegistrationsGoogle} userRegistrationsGoogle 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1RegistrationsGooglePost(userRegistrationsGoogle: UserRegistrationsGoogle, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1RegistrationsGooglePost(userRegistrationsGoogle, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 年収検証フラグ有効時は万円単位の0〜100,000（10億円）を許可し、範囲外は補正せず422を返します。旧アプリ移行中は既定OFFです。
     * @summary ユーザー登録
     * @param {UserRegistrations} userRegistrations 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1RegistrationsPost(userRegistrations: UserRegistrations, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1RegistrationsPost(userRegistrations, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 電話番号認証コード送信
     * @param {InlineObject4} inlineObject4 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1SendPhoneNumberAuthCodesPost(inlineObject4: InlineObject4, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1SendPhoneNumberAuthCodesPost(inlineObject4, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ログイン状況確認
     * @param {string} [adjustNetwork] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1SessionGet(adjustNetwork?: string, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1SessionGet(adjustNetwork, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary SMAUL 問い合わせを認証ユーザー情報付きで登録
     * @param {SmaulLeadV1Request} smaulLeadV1Request 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1SmaulLeadsPost(smaulLeadV1Request: SmaulLeadV1Request, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1SmaulLeadsPost(smaulLeadV1Request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザ画面アクセス登録
     * @param {UserAccessScreenLog} userAccessScreenLog 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserAccessScreenLogsPost(userAccessScreenLog: UserAccessScreenLog, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserAccessScreenLogsPost(userAccessScreenLog, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザデータ初回登録ステータス取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserDataFirstRegisteredStatusGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserDataFirstRegisteredStatusGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザデータ初回登録ステータス更新
     * @param {UserDataFirstRegisteredStatus} userDataFirstRegisteredStatus 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus: UserDataFirstRegisteredStatus, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserDataFirstRegisteredStatusPatch(userDataFirstRegisteredStatus, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーデバイストークン登録削除
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserDeviceTokenDelete(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserDeviceTokenDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーデバイストークン登録
     * @param {UserDeviceToken} userDeviceToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserDeviceTokenPost(userDeviceToken: UserDeviceToken, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserDeviceTokenPost(userDeviceToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザー情報取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 年収検証フラグ有効時は万円単位の0〜100,000（10億円）を許可します。年収の変更時に検証し、範囲外は補正せず422を返します。旧アプリ移行中は既定OFFです。
     * @summary ユーザー情報更新
     * @param {UserUpdate} userUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserPatch(userUpdate: UserUpdate, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserPatch(userUpdate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーオファー登録
     * @param {UserProposalRequest} userProposalRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserProposalsPost(userProposalRequest: UserProposalRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserProposalsPost(userProposalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーオファーの希望連絡日程更新
     * @param {number} userProposalId ユーザーオファー ID
     * @param {InvestmentProposalPreferredContactSchedulesRequest} investmentProposalPreferredContactSchedulesRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserProposalsUserProposalIdPreferredContactSchedulesPatch(userProposalId: number, investmentProposalPreferredContactSchedulesRequest: InvestmentProposalPreferredContactSchedulesRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserProposalsUserProposalIdPreferredContactSchedulesPatch(userProposalId, investmentProposalPreferredContactSchedulesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ユーザーオファー登録（追加マッチング候補付き）
     * @param {UserProposalRequest} userProposalRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserProposalsWithRecommendationsPost(userProposalRequest: UserProposalRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserProposalsWithRecommendationsPost(userProposalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 累計既読/マッチング件数取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1UserTotalReadAndMatchCountGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1UserTotalReadAndMatchCountGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary プレミアムウェビナー一覧取得
     * @param {number} [page] 
     * @param {number} [perPage] 
     * @param {boolean} [recentOnly] 最近のウェビナーのみ取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1WebinarsGet(page?: number, perPage?: number, recentOnly?: boolean, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1WebinarsGet(page, perPage, recentOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary プレミアムウェビナーのハイライト取得
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1WebinarsHighlightGet(options?: any) {
        return PropallyV1ApiFp(this.configuration).v1WebinarsHighlightGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary プレミアムウェビナー詳細取得
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1WebinarsIdGet(id: string, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1WebinarsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary プレミアムウェビナー視聴ログ作成
     * @param {string} id 
     * @param {WebinarViewingCreateRequest} webinarViewingCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1WebinarsIdViewHistoriesPost(id: string, webinarViewingCreateRequest: WebinarViewingCreateRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1WebinarsIdViewHistoriesPost(id, webinarViewingCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary プレミアムウェビナー視聴ログ更新
     * @param {string} id 
     * @param {string} viewingId 
     * @param {WebinarViewingUpdateRequest} webinarViewingUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PropallyV1Api
     */
    public v1WebinarsIdViewHistoriesViewingIdPatch(id: string, viewingId: string, webinarViewingUpdateRequest: WebinarViewingUpdateRequest, options?: any) {
        return PropallyV1ApiFp(this.configuration).v1WebinarsIdViewHistoriesViewingIdPatch(id, viewingId, webinarViewingUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


